// Translation strings for the application

export const translations = {
  en: {
    // Navbar
    gettingStarted: 'Getting Started',
    navMobileApp: 'Mobile app',
    about: 'About',
    faq: 'Frequently Asked Questions',
    terms: 'Terms of Use',
    privacy: 'Privacy Policy',
    contact: 'Contact Support',
    deleteAccountData: 'Delete account & data',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    upgradeToPro: 'Upgrade to Pro',
    subscriptionPro: 'Subscription (Pro)',
    role: 'Role',
    
    // Language names
    english: 'English',
    hebrew: 'עברית',
    yiddish: 'ייִדיש',
    
    // Auth
    welcomeBack: 'Welcome back',
    shadchanLogin: 'Shadchan Login',
    singleLogin: 'Single Login',
    parentLogin: 'Parent Login',
    signInToAccount: 'Sign in to your {role} account.',
    signInToManage: 'Sign in to manage profiles, references, and Resunize shidduchim.',
    email: 'Email',
    password: 'Password',
    enterEmail: 'Enter your email',
    enterPassword: 'Enter your password',
    forgotPassword: 'Forgot password?',
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: 'Already have an account?',
    createAccount: 'Create an account',
    chooseAccountType: 'Choose what type of account you are {action}.',
    chooseAccountTypeRegisterNote: 'Singles and parents get a 60-day free trial with full access. A credit card is required to start — you won\'t be charged until the trial ends.',
    registerTrialSubheading: 'Set up your private shidduch workspace. A credit card is required to start your 60-day free trial.',
    loggingInto: 'logging into',
    creating: 'creating',
    areYouShadchan: 'Are you a shadchan?',
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Phone',
    confirmPassword: 'Confirm Password',
    enterFirstName: 'Enter your first name',
    enterLastName: 'Enter your last name',
    enterPhone: 'Enter your phone number',
    enterConfirmPassword: 'Confirm your password',
    createPassword: 'Create a password',
    confirmYourPassword: 'Confirm your password',
    createYourAccount: 'Create your account',
    createAccountInMinute: 'Create a {role} account in under a minute.',
    chooseRoleCompleteRegistration: 'Choose your role, then complete your secure registration.',
    selectRole: 'Select your role',
    shadchan: 'Shadchan',
    single: 'Single',
    parent: 'Parent',
    
    // Validation messages
    invalidEmail: 'Invalid email address',
    emailRequired: 'Email is required',
    passwordRequired: 'Password is required',
    passwordMinLength: 'Password must be at least 8 characters',
    passwordComplexity: 'Password must contain at least one letter and one number',
    passwordsMustMatch: 'Passwords must match',
    confirmPasswordRequired: 'Please confirm your password',
    firstNameRequired: 'First name is required',
    firstNameMaxLength: 'First name must be less than 100 characters',
    lastNameRequired: 'Last name is required',
    lastNameMaxLength: 'Last name must be less than 100 characters',
    invalidPhone: 'Please enter a valid phone number',
    roleRequired: 'Please select your role',
    invalidRole: 'Please select a valid role',
    
    // Common
    submit: 'Submit',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    ok: 'OK',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    search: 'Search',
    filter: 'Filter',
    actions: 'Actions',
    appDownloadPromoWelcomeTitle: 'Welcome to Resunize',
    appDownloadPromoWelcomeSubtitle:
      'Download the mobile app for iPhone or Android — stay organized on the go.',
    appDownloadPromoRandomTitle: 'Take Resunize with you',
    appDownloadPromoRandomSubtitle: 'Get the Resunize app on the App Store or Google Play.',
    downloadOnAppStore: 'Download on the App Store',
    getItOnGooglePlay: 'Get it on Google Play',
    appStoreBadgeKicker: 'Download on the',
    appStoreBadgeTitle: 'App Store',
    googlePlayBadgeKicker: 'GET IT ON',
    googlePlayBadgeTitle: 'Google Play',
    landingAppBarTitle: 'Get the Resunize app',
    landingAppBarSubtitle: 'Native apps for iPhone and Android — faster, with push notifications.',
    landingAppBarNotNow: 'Not now',
    
    // Dashboard
    dashboard: 'Dashboard',
    myAccount: 'My Account',
    welcomeBack: 'Welcome Back',
    everythingInOnePlace: 'Organize Everything in one place: your resume, references, and shidduch notes.',
    myResumes: 'My Resume',
    myDigitalResumes: 'My Resume',
    createResumeHere: 'Create a resume here: manage, share, and edit.',
    createMyResume: 'Create My Resume',
    editResume: 'Edit Resume',
    fillInYourDetails: 'Fill in your details below.',
    makePublicToShadchanim: 'Make this resume public to all shadchanim',
    addResume: 'Add Resume',
    suggestions: 'Suggestions',
    spotlight: 'Spotlight',
    spotlightList: 'Spotlight list',
    notForNow: 'Not for Now',
    profile: 'Profile',
    messages: 'Messages',
    newResume: 'New Resume',
    yourResumes: 'Your resumes',
    noResumesYet: 'No resumes yet.',
    selectResumeToEdit: 'Select a resume to edit it.',
    public: 'public',
    private: 'private',
    resume: 'Resume',
    
    // Subscription
    subscription: 'Subscription',
    subscriptionManagement: 'Subscription Management',
    freePlan: 'Free Plan',
    proPlan: 'Pro Plan',
    proPlanActive: 'Pro Plan Active',
    proSubscriptionActive: 'Pro Subscription Active',
    unlimitedPlan: 'Unlimited Plan',
    unlimitedSubscriptionActive: 'Unlimited Plan Active',
    unlimitedPlanResumes: 'Unlimited resumes and access to all Pro features.',
    proPlanResumes: 'Up to 50 resumes and access to all Pro features.',
    unlimitedResumes: 'Unlimited resumes and access to all Pro features.',
    currentPeriodEnds: 'Current Period Ends',
    cancelSubscription: 'Cancel Subscription',
    cancelScheduledMessage: 'Subscription will be canceled at the end of the billing period',
    subscribeToPro: 'Subscribe to Pro',
    subscribeToUnlimited: 'Subscribe to Unlimited',
    upgradeToUnlimited: 'Upgrade to Unlimited',
    securePayment: 'Secure payment powered by Stripe',
    subscriptionActivated: 'Subscription Activated!',
    thankYouForUpgrading: 'Thank you for upgrading. You now have access to your new plan features.',
    thankYouForUpgradingPro: 'Thank you for upgrading to Pro. You now have up to 50 resumes and access to all Pro features.',
    thankYouForUpgradingUnlimited: 'Thank you for upgrading to Unlimited. You now have unlimited resumes and access to all Pro features.',
    viewSubscription: 'View Subscription',
    goToDashboard: 'Go to Dashboard',
    pricingTitle: 'Simple, transparent pricing',
    pricingSubtitle: 'Start with a 60-day free trial (card required). After the trial, we automatically bill $2.99/month if you have up to 50 resumes, or $7.99/month if you have more.',
    pricingPerMonth: '/month',
    pricingMostPopular: 'Limited Offer',
    pricingCurrentPlan: 'Current Plan',
    pricingFreeTitle: '60-Day Free Trial',
    pricingProTitle: 'Pro',
    pricingUnlimitedTitle: 'Unlimited',
    pricingTrialOffer: 'Limited time offer: start your 60-day free trial.',
    pricingTrialDuration: 'for 60 days',
    pricingFreeCta: 'Start 60-Day Free Trial',
    pricingFreeFeature1: 'Unlimited resumes during your 60-day trial',
    pricingFreeFeature2: 'Full access to notes, suggestions & follow-ups',
    pricingFreeFeature3: 'Credit card required — billing starts automatically after trial',
    pricingProFeature1: 'Up to 50 resumes',
    pricingProFeature2: 'Share résumés by email',
    pricingProFeature3: 'Priority support',
    pricingUnlimitedFeature1: 'More than 50 resumes',
    pricingUnlimitedFeature2: 'All Pro features included',
    pricingUnlimitedFeature3: 'Best for large families',
    pricingAfterTrialTitle: 'After your free trial',
    pricingAfterTrialDesc: 'No need to pick a plan. We automatically assign the right one based on how many resumes you have when the trial ends.',
    pricingAfterTrialProSubtitle: '50 resumes or fewer',
    pricingAfterTrialUnlimitedSubtitle: 'More than 50 resumes',
    pricingAutoAssignedNote: 'Assigned automatically — no action needed',
    pricingTrialSetupTitle: 'Add your card to start your free trial',
    pricingTrialSetupDesc: 'A credit card is required to begin your 60-day trial. You will not be charged until the trial ends.',
    pricingTrialActiveTitle: 'Your 60-day trial is active',
    pricingTrialActiveDesc: 'Add as many resumes as you want during your trial. When it ends, we bill you automatically based on your resume count.',
    pricingTrialActiveHelper: 'Unlimited resumes during trial',
    pricingTrialResumeHelper: 'Unlimited during your trial',
    pricingTrialUnlimitedResumes: 'unlimited during trial',
    pricingAutoBillHelper: 'Auto-assigned when trial ends',
    pricingTrialEndsLabel: 'Trial ends',
    pricingTrialProjectedBill: 'Based on your {count} resume(s) now, you would be billed {price}/month after the trial.',
    pricingTrialStarted: 'Your 60-day free trial has started!',
    resumeUsageMessage: "You've used {current} of {limit} resumes on your current plan.",
    
    // Resume
    resumeLimitReached: 'Resume Limit Reached!',
    resumeLimitMessage: "You've used {current} of {limit} resumes on the Free plan. Upgrade to Pro or Unlimited for more.",
    createResume: 'Create Resume',
    editResume: 'Edit Resume',
    deleteResume: 'Delete Resume',
    resumeCreated: 'Resume created',
    resumeUpdated: 'Resume updated',
    resumeDeleted: 'Resume deleted',
    addResumeFromOutside: 'Add Single Profile',
    createDigitalResume: 'Create a digital resume to manage and suggest shidduchim.',
    resumeUploadedReadOnly: 'This resume has been uploaded and is now read-only. You can still add notes under each reference.',
    pdfResume: 'PDF Resume',
    firstName: 'First name',
    lastName: 'Last name',
    birthday: 'Birthday',
    height: 'Height (inches)',
    feet: 'Feet',
    inches: 'Inches',
    address: 'Address',
    enterAddress: 'Enter address',
    city: 'City',
    state: 'State',
    fathersName: "Father's name",
    mothersName: "Mother's name",
    motherMaidenName: "Mother's maiden name",
    paternalGrandparents: 'Paternal grandparents',
    maternalGrandparents: 'Maternal grandparents',
    grandfather: 'Grandfather',
    grandmother: 'Grandmother',
    shulsAttended: 'Shuls attended',
    shulName: 'Shul name',
    rabbiName: 'Rabbi name',
    saved: 'Saved',
    deleteThisResume: 'Delete this resume{name}? This will remove its references, PDFs, shares, and suggestions.',
    resumeSavedToSuggestions: 'Resume saved to Suggestions',
    failedToSaveToSuggestions: 'Failed to save to Suggestions',
    failedToLoadResumes: 'Failed to load digital resumes',
    failedToCreateResume: 'Failed to create resume',
    failedToSave: 'Failed to save',
    failedToDeleteResume: 'Failed to delete resume',
    
    // Toast messages
    loginSuccessful: 'Login successful!',
    registrationSuccessful: 'Registration successful!',
    logoutSuccessful: 'Logged out successfully',
    loginFailed: 'Login failed',
    registrationFailed: 'Registration failed',
    
    // Additional common strings
    shareResume: 'Share resume',
    shareResumeTitle: 'Share Resume',
    uploadPdf: 'Upload PDF',
    uploading: 'Uploading…',
    uploadPdfFirst: 'Upload a PDF first to auto-fill the form, then convert it.',
    profilePicture: 'Profile Picture',
    uploadProfilePicture: 'Upload Profile Picture',
    uploadProfilePictureDescription: 'Upload a profile picture to personalize your resume. You can choose whether to share it when the resume is shared.',
    shareProfilePictureWhenResumeShared: 'Share profile picture when resume is shared',
    profilePictureUploaded: 'Profile picture uploaded successfully',
    profilePictureDeleted: 'Profile picture deleted successfully',
    profilePictureNowShareable: 'Profile picture will be shared when resume is shared',
    profilePictureNotShareable: 'Profile picture will not be shared when resume is shared',
    deleteProfilePictureConfirm: 'Are you sure you want to delete this profile picture?',
    failedToUploadProfilePicture: 'Failed to upload profile picture',
    failedToDeleteProfilePicture: 'Failed to delete profile picture',
    failedToLoadProfilePicture: 'Failed to load profile picture',
    failedToUpdateShareable: 'Failed to update shareable setting',
    invalidImageFormat: 'Invalid image format. Please upload JPG, PNG, GIF, or WebP.',
    imageTooLarge: 'Image is too large. Maximum size is 5MB.',
    noProfilePicture: 'No profile picture uploaded',
    uploadProfilePictureToGetStarted: 'Upload a profile picture to get started',
    replace: 'Replace',
    profilePictureIsShareable: 'This profile picture is shareable with shadchanim when the resume is shared.',
    resumeNeededForProfilePicture: 'A resume must be created first before uploading a profile picture.',
    resumeCreatedForProfilePicture: 'Resume created. You can now upload a profile picture.',
    saving: 'Saving…',
    saveResume: 'Save Resume',
    saveToSpotlight: 'Save to Spotlight',
    saveToSuggestions: 'Save to Suggestions',
    discardChanges: 'Discard changes',
    discarding: 'Discarding…',
    discardResumeDraftConfirm:
      'Discard this draft? The uploaded resume will be removed from your account until you upload again.',
    saveResumeBeforeLeavingTabs:
      'Save your resume to Spotlight or Suggestions before switching tabs, or discard your changes.',
    changesDiscarded: 'Changes discarded',
    resumeSavedToSpotlight: 'Resume saved to Spotlight',
    failedToSaveToSpotlight: 'Failed to save to Spotlight',
    uploadFailed: 'Upload failed',
    failedToOpenPdf: 'Failed to open PDF',
    failedToLoadPdf: 'Failed to load PDFs',
    formAutoFilledFromPdf: 'Form auto-filled from PDF',
    pleaseReviewYourInformation: 'Please Review Your Information',
    reviewAutofillMessage: 'Your details have been automatically extracted from the PDF. Please double-check that all fields are correct before continuing.',
    rabbiPhone: 'Rabbi phone',
    siblingName: 'Sibling name',
    schoolNumber: 'School #{number}',
    mechutanNumber: 'Mechutan #{number}',
    shulNumber: 'Shul #{number}',
    noShulsAddedYet: 'No shuls added yet.',
    noSchoolsAddedYet: 'No schools added yet.',
    noMechutanimAddedYet: 'No mechutanim added yet.',
    noSiblingsAddedYet: 'No siblings added yet.',
    viewProfile: 'View Profile',
    shareForMatch: 'Share for Match',
    togglePublicVisibility: 'Toggle public visibility',
    makePrivate: 'Make Private',
    makePublic: 'Make Public',
    birthdayLabel: 'Birthday',
    heightLabel: 'Height',
    synagogue: 'Synagogue',
    searchSingles: 'Search singles + shared resumes…',
    searchPublicSingles: 'Search public singles…',
    searchShidduchim: 'Search suggestions…',
    searchShadchanim: 'Search shadchanim…',
    refresh: 'Refresh',
    writeReferenceNote: 'Write what the reference told you… (only you can see this)',
    phonePlaceholder: 'Digits only (or +)',
    shadchanEmailPlaceholder: 'shadchan@email.com',
    thankYouForHelp: 'Thank you for your help...',
    provideDetails: 'Please provide as much detail as possible so we can assist you better...',
    willGenerateEmail: 'Will generate temporary email if not provided',
    enterExistingEmail: 'Enter the email of the existing single account',
    removeChild: 'Remove child',
    failedToStartCheckout: 'Failed to start checkout',
    failedToCancelSubscription: 'Failed to cancel subscription',
    failedToLoadSubscription: 'Failed to load subscription',
    processing: 'Processing...',
    
    // Additional fields
    schoolsAttended: 'Schools / Yeshivos attended',
    mechutanim: 'Mechutanim',
    siblings: 'Siblings',
    age: 'Age',
    additionalInfo: 'Additional info',
    summerCamp: 'Summer / Camp',
    enterSummerCamp: 'e.g. Camp Agudah, Camp Sternberg',
    previouslyMarried: 'Previously Married',
    wasMarriedTo: 'Was married to',
    divorced: 'Divorced',
    widowed: 'Widowed',
    none: 'None',
    enterName: 'Enter name',
    selectOption: 'Select...',
    personalInformation: 'Personal Information',
    familyInformation: 'Family',
    educationAndCommunity: 'Education & Community',
    career: 'Career',
    uploadPdfToAutofill: 'Upload a PDF to automatically fill in your resume details.',
    noResumeDataAvailable: 'No resume data available.',
    references: 'References',
    saveResumeOrUploadPdfFirst: 'Save the resume or upload a PDF first to add references.',
    myNotesPrivate: 'My notes (private)',
    readOnlyShared: 'Read-only (shared with you)',
    makeResumePublic: 'Make this resume public to all shadchanim',
    failedToLoadSuggestion: 'Failed to load suggestion',
    converting: 'Converting…',
    deletePdfConfirm: 'Delete this PDF?',
    deleted: 'Deleted',
    deleteFailed: 'Delete failed',
    reorderFailed: 'Reorder failed',
    uploadPdfViewConvert: 'Upload a PDF, view it, and convert it to autofill this digital resume.',
    noPdfsYet: 'No PDFs uploaded yet',
    uploadPdfResumeToGetStarted: 'Upload a PDF resume to get started',
    noPdfsAvailableForViewing: 'No PDFs available for viewing',
    
    // Voice Notes
    myVoiceNote: 'My Voice Note',
    startRecording: 'Start Recording',
    stopRecording: 'Stop Recording',
    recording: 'Recording',
    voiceNote: 'Voice Note',
    voiceNoteSaved: 'Voice note saved successfully',
    voiceNoteDeleted: 'Voice note deleted successfully',
    failedToSaveVoiceNote: 'Failed to save voice note',
    failedToDeleteVoiceNote: 'Failed to delete voice note',
    deleteVoiceNoteConfirm: 'Are you sure you want to delete this voice note?',
    microphonePermissionDenied: 'Microphone permission denied. Please allow microphone access to record voice notes.',
    recordNew: 'Record New',
    uploading: 'Uploading...',
    voiceNoteTitleLabel: 'Name (optional)',
    voiceNoteTitlePlaceholder: 'Label this clip to find it later…',
    saveVoiceNoteTitle: 'Save name',
    voiceNoteTitleSaved: 'Name saved',
    voiceNoteTitleSaveFailed: 'Failed to save name',
    voiceNotePlay: 'Play',
    voiceNotePause: 'Pause',
    voiceNoteSeek: 'Seek playback',
    voiceNotePlaybackError: 'Could not play audio',
    
    // Not For Now Reason
    whyNotForNow: 'Why "Not For Now"?',
    enterReasonNotForNow: 'Please enter a reason why this suggestion is "Not For Now". This will help you remember later.',
    enterReasonNotForNowOptional: 'You can add an optional note so you remember why this is "Not For Now". Leave blank if you prefer.',
    enterReason: 'Enter reason...',
    restoreToSuggestions: 'Restore to Suggestions',
    restoreToSpotlight: 'Restore to Spotlight',
    confirmDeleteSuggestion: 'Permanently delete this suggestion? This cannot be undone.',
    suggestionDeleted: 'Suggestion deleted',
    moveToNotForNow: 'Move to Not For Now',
    reason: 'Reason',
    reasonNotForNow: 'Reason for "Not For Now"',
    suggestedBy: 'Suggested by',
    enterSuggestedBy: 'Enter who suggested this resume...',
    suggestedByName: 'Shadchan Name',
    suggestedByEmail: 'Shadchan Email',
    enterShadchanName: 'Enter shadchan name...',
    enterShadchanEmail: 'Enter shadchan email...',
    searchShadchanim: 'Search Shadchanim',
    searchShadchanimPlaceholder: 'Search by name or email...',
    orSearchShadchanim: 'Or search from registered shadchanim',
    tipPayShadchan: 'Tip / Pay Shadchan',
    personalNotes: 'Personal Notes',
    personalNotesPlaceholder: 'Add your personal notes about this suggestion...',
    personalNotesDescription: 'These notes are private and only visible to you.',
    unsavedChangesWarning: 'You have unsaved changes. Are you sure you want to leave?',
    saveProgressOrDiscard: 'Save progress or discard changes?',
    personalNotes: 'My Personal Notes',
    personalNotesDescription: 'These notes are private and only visible to you.',
    writePersonalNotes: 'Write your personal notes about this suggestion...',
    saveNotes: 'Save Notes',
    saved: 'Saved',
    type: 'Type',
    name: 'Name',
    optional: 'optional',
    family: 'Family',
    friend: 'Friend',
    teacher: 'Teacher',
    rabbi: 'Rabbi',
    mentor: 'Mentor',
    colleague: 'Colleague',
    notes: 'Notes',
    voiceNotes: 'Voice notes',
    voiceNotesOnResumeTitle: 'Voice notes on this resume',
    noNotesYet: 'No notes yet. Tap Add to write one.',
    noVoiceNotesYet: 'No voice clips yet. Tap Add, then use Record.',
    notesOnThisResumeTitle: 'Notes on this resume',
    privateNotesOnResumeHint: 'Only you can see these notes. They stay on your account and are not included when you share this resume.',
    privateVoiceOnResumeHint: 'Only you can hear these clips. They are saved with this resume.',
    writeNotePlaceholder: 'Write your note here…',
    addNote: 'Add note',
    selectPdfIfMultiple: 'PDF file',
    noteCannotBeEmpty: 'Write something before saving.',
    noteReferenceNameLabel: 'Reference (who you heard this from)',
    noteReferenceNamePlaceholder: 'e.g. Ms. Cohen, Rabbi Stein',
    noteBodyLabel: 'Note',
    addVoiceNote: 'Add voice note',
    deleteNoteConfirm: 'Delete this note?',
    saveFailed: 'Failed to save',
    addReference: 'Add Reference',
    adding: 'Adding…',
    relationship: 'Relationship',
    mySingles: 'My Singles',
    publicSingles: 'Public Singles',
    shidduchim: 'Suggested Shidduchim',
    sharedResumes: 'Shared Resumes',
    sendResumes: 'Send Resumes',
    sharedResumesAutoAdded: 'Shared Resumes (auto-added)',
    orPickShadchan: 'Or pick a shadchan',
    searchForShadchanim: 'Search for shadchanim',
    share: 'Share',
    sharing: 'Sharing…',
    shareViaResunize: 'Share via Resunize',
    shareViaEmail: 'Share via Email',
    emailSentFromResunize: 'The email will be sent directly from Resunize.',
    recipientEmail: 'Recipient email',
    enterRecipientEmailPlaceholder: 'Enter recipient email address...',
    enterRecipientEmail: 'Please enter a recipient email.',
    personalMessage: 'Personal message',
    personalMessagePlaceholder: 'Add a personal message to include with the resume...',
    resumeBeingShared: 'Resume being shared',
    sendFromResunize: 'Send from Resunize',
    sending: 'Sending...',
    emailSentSuccessfully: 'Email sent successfully!',
    failedToSendEmail: 'Failed to send email.',
    optional: 'optional',
    childCreated: 'Child created successfully',
    childLinked: 'Child linked successfully',
    failedToCreateChild: 'Failed to create child',
    failedToLinkChild: 'Failed to link child',
    failedToLoadChildren: 'Failed to load children',
    childRemoved: 'Child removed',
    removeChildConfirm: 'Are you sure you want to remove this child? This will unlink them from your account but will not delete their account.',
    createChild: 'Create Child',
    linkChild: 'Link Child',
    createNewChild: 'Create New Account',
    linkExistingChild: 'Link Existing Account',
    childsEmail: "Child's Email",
    childMustHaveAccount: 'The child must have an existing account with role "single"',
    creating: 'Creating…',
    linking: 'Linking…',
    yourChildren: 'My Children',
    manageChildrenAccounts: 'Manage your children\'s accounts and resumes',
    noChildrenYet: 'No children added yet.',
    addChild: 'Add Child',
    addYourFirstChild: 'Add Your First Child',
    manageChildAccount: 'Manage {name}\'s Account',
    backToChildrenList: 'Back to Children List',
    childsAccount: '{name}\'s Account',
    manageChildResume: 'Manage {name}\'s resume, references, and shadchan suggestions.',
    parentDashboard: 'Parent Dashboard',
    checkingLink: 'Checking...',
    childAlreadyLinked: 'This child is already linked',
    passwordRequiredForLinking: 'Password is required for first-time linking',
    enterChildPassword: 'Enter child account password',
    passwordVerifyPermission: 'Password is required to verify you have permission to link this account',
    subscriptionSuccessTitle: 'Subscription Activated!',
    subscriptionSuccessMessage: 'Your billing is set up. Enjoy full access during your 60-day free trial — you won\'t be charged until the trial ends.',
    activatingProSubscription: 'Activating your Pro subscription...',
    proSubscriptionActive: 'Your Pro subscription is now active!',
    subscriptionProcessing: 'Subscription is processing. Your account will be upgraded shortly.',
    subscriptionCancelTitle: 'Subscription Canceled',
    subscriptionCancelMessage: 'Your subscription checkout was canceled. You can try again anytime.',
    failedToLoadShadchanim: 'Failed to load shadchanim',
    sharedWithShadchan: 'Shared with shadchan',
    failedToShare: 'Failed to share',
    noResumeSelected: 'No resume selected',
    thankYouContacting: "Thank you for contacting us! We'll get back to you soon.",
    failedToSubmitMessage: 'Failed to submit message. Please try again.',
    contactSupportTitle: 'Contact Support',
    contactSupportSubtitle: 'We\'re here to help! Reach out with any questions or concerns.',
    nameLabel: 'Name',
    emailLabel: 'Email',
    subject: 'Subject',
    category: 'Category',
    general: 'General',
    technical: 'Technical',
    billing: 'Billing',
    other: 'Other',
    submitMessage: 'Submit Message',
    noResults: 'No results.',
    noSinglesProfilesYet: 'No singles profiles yet.',
    tryDifferentSearch: 'Try a different search.',
    startByAddingFirstProfile: 'Start by adding your first profile.',
    noPublicProfilesAvailable: 'No public profiles available.',
    profileIsNowPublic: 'Profile is now public',
    profileIsNowPrivate: 'Profile is now private',
    suggestionSent: 'Suggestion sent (see Resunize Shidduchim)',
    resumeSuggestionsToSingles: 'Resume Suggestions (to singles/parents)',
    noMatchesOrSuggestionsYet: 'No matches or suggestions yet.',
    profileCreated: 'Profile created. It will appear in My Singles after refresh.',
    deleteMatchConfirm: 'Delete this match?',
    matchDeleted: 'Match deleted',
    failedToDeleteMatch: 'Failed to delete match',
    shadchanDashboard: 'Shadchan Dashboard',
    manageSinglesBrowseProfiles: 'Manage singles, browse public profiles, and track Resunize shidduchim.',
    statLabelMySingles: 'My Singles',
    statLabelPublicSingles: 'Public Singles',
    statLabelResunizeShidduchim: 'Suggested Shidduchim',
    schoolsYeshivosAttended: 'Schools / Yeshivos attended',
    resumeDetails: 'Resume Details',
    synagogueMembership: 'Synagogue Membership',
    educationLevel: 'Education Level',
    occupation: 'Occupation',
    salaryRange: 'Salary Range',
    maritalStatus: 'Marital Status',
    religiousObservance: 'Religious Observance',
    personalityTraits: 'Personality Traits',
    hobbiesInterests: 'Hobbies & Interests',
    proStatusActive: 'Pro Status Active!',
    accountUpgraded: 'Your account has been upgraded.',
    pleaseRefreshPage: 'Please refresh the page in a moment.',
    emailRequiredToLink: 'Email is required to link an existing account',
    failedToRemoveChild: 'Failed to remove child',
    clickButtonOpenEmailClient: 'Click the button below to open your email client with the resume information pre-filled.',
    openEmailClient: 'Open Email Client',
    emailPreview: 'Email Preview',
    noShadchanimFound: 'No shadchanim found.',
    resumeLabel: 'Resume',
    location: 'Location',
    shadchanDashboard: 'Shadchan Dashboard',
    manageSinglesBrowseProfiles: 'Manage singles, browse public profiles, and track Resunize shidduchim.',
    noResults: 'No results.',
    noSinglesProfilesYet: 'No singles profiles yet.',
    tryDifferentSearch: 'Try a different search.',
    startByAddingFirstProfile: 'Start by adding your first profile.',
    noPublicProfilesAvailable: 'No public profiles available.',
    profileIsNowPublic: 'Profile is now public',
    profileIsNowPrivate: 'Profile is now private',
    suggestionSent: 'Suggestion sent (see Resunize Shidduchim)',
    resumeSuggestionsToSingles: 'Resume Suggestions (to singles/parents)',
    noMatchesOrSuggestionsYet: 'No matches or suggestions yet.',
    profileCreated: 'Profile created. It will appear in My Singles after refresh.',
    deleteMatchConfirm: 'Delete this match?',
    matchDeleted: 'Match deleted',
    failedToDeleteMatch: 'Failed to delete match',
    sendToSingles: 'Send to Singles',
    myProfile: 'My Profile',
    profileNotAvailable: 'Your profile is not available yet.',
    profileNotCreated: 'Profile not created',
    profileNotCreatedDesc: 'Your shadchan typically creates your profile. Please contact them to get started.',
    contactShadchan: 'Contact a Shadchan',
    failedToLoadProfile: 'Failed to load profile',
    profileUpdated: 'Profile updated successfully!',
    profileCreationByShadchan: 'Profile creation is typically done by your shadchan. Please contact them.',
    loadingProfile: 'Loading profile...',
    organizeResumes: 'Organize Shidduch Resumes',
    organizeResumesDesc: 'Keep your regular shidduch resumes organized in one place, with PDF upload to save time.',
    manageTheProcess: 'Manage Suggestions & Notes',
    manageTheProcessDesc: 'Track each suggestion, add private notes, and keep important details clear from start to finish.',
    stayFocused: 'Keep the Process Clear',
    stayFocusedDesc: 'Use the same process you already know, just with better organization so nothing gets lost.',
    tipShadchan: 'Tip Shadchan',
    tipYourShadchan: 'Tip Your Shadchan',
    showAppreciationForShadchan: 'Show your appreciation for your shadchan\'s help in finding your match.',
    tipShadchanProDescription: 'Upgrade to Pro to tip your shadchan and show your appreciation for their hard work.',
    upgradeToPro: 'Upgrade to Pro',
    proFeature: 'Pro Feature',
    tipAnyShadchan: 'Tip any shadchan in the database',
    tipByEmail: 'Tip shadchanim by email address',
    securePaymentProcessing: 'Secure payment processing via Stripe',
    upgradeNow: 'Upgrade Now',
    maybeLater: 'Maybe Later',
    selectFromDatabase: 'Select from Database',
    selectShadchanFromList: 'Choose a shadchan from our database',
    tipShadchanNotInDatabase: 'Tip a shadchan who isn\'t registered yet',
    enterEmailAddress: 'Enter Email Address',
    shadchanEmailAddress: 'Shadchan Email Address',
    shadchanWillReceiveEmail: 'The shadchan will receive an email with instructions to claim their tip.',
    sendTip: 'Send Tip',
    pleaseEnterValidAmount: 'Please enter a valid amount',
    proRequiredForTipping: 'Pro subscription is required for tipping',
    tipSentSuccessfully: 'Tip sent successfully!',
    failedToProcessTip: 'Failed to process tip',
    amount: 'Amount',
    messageOptional: 'Message (Optional)',
    thankYouForHelp: 'Thank you for your help!',
    cardDetails: 'Card Details',
    processing: 'Processing...',
    withdrawalManagement: 'Withdrawal Management',
    availableBalance: 'Available Balance',
    addWithdrawalMethod: 'Add Withdrawal Method',
    requestWithdrawal: 'Request Withdrawal',
    selectMethod: 'Select Method',
    selectWithdrawalMethod: 'Select a withdrawal method',
    maxAmount: 'Maximum amount',
    withdrawalMethods: 'Withdrawal Methods',
    noWithdrawalMethods: 'No withdrawal methods added yet',
    default: 'Default',
    withdrawalHistory: 'Withdrawal History',
    noWithdrawals: 'No withdrawals yet',
    date: 'Date',
    method: 'Method',
    status: 'Status',
    failedToLoadData: 'Failed to load data',
    withdrawalMethodAdded: 'Withdrawal method added successfully',
    failedToAddMethod: 'Failed to add withdrawal method',
    pleaseSelectWithdrawalMethod: 'Please select a withdrawal method',
    insufficientBalance: 'Insufficient balance',
    withdrawalRequestSubmitted: 'Withdrawal request submitted successfully',
    failedToRequestWithdrawal: 'Failed to request withdrawal',
    methodType: 'Method Type',
    stripeAccountId: 'Stripe Account ID',
    stripeAccountIdRequired: 'Stripe Account ID is required',
    stripeAccountIdHelp: 'Your Stripe Connect account ID (starts with acct_)',
    paypalEmail: 'PayPal Email',
    paypalEmailRequired: 'PayPal email is required',
    zelleEmail: 'Zelle Email',
    zellePhone: 'Zelle Phone',
    zelleEmailOrPhoneRequired: 'Either email or phone is required for Zelle',
    cancel: 'Cancel',
    add: 'Add',
    back: 'Back',
    saveResumeOrUploadPdfToAddReferences: 'Save the resume or upload a PDF first to add references.',
    saveResumeToAddReferences: 'Save Resume to Add References',
    resumeCreatedForReferences: 'Resume saved! You can now add references.',
    referenceAdded: 'Reference added',
    referenceRemoved: 'Reference removed',
    failedToAddReference: 'Failed to add reference',
    failedToRemoveReference: 'Failed to remove reference',
    resumeMustBeCreatedFirst: 'Resume must be created first',
    subscriptionSuccessTitle: 'Subscription Activated!',
    subscriptionSuccessMessage: 'Your billing is set up. Enjoy full access during your 60-day free trial — you won\'t be charged until the trial ends.',
    activatingProSubscription: 'Activating your Pro subscription...',
    height: 'Height',
    address: 'Address',
    enterAddress: 'Enter address',
    city: 'City',
    state: 'State',
    fathersName: 'Father\'s Name',
    fathersOccupation: 'Father\'s Occupation',
    mothersName: 'Mother\'s Name',
    mothersOccupation: 'Mother\'s Occupation',
    motherMaidenName: 'Mother\'s Maiden Name',
    paternalGrandparents: 'Paternal Grandparents',
    maternalGrandparents: 'Maternal Grandparents',
    grandfather: 'Grandfather',
    grandmother: 'Grandmother',
    shulsAttended: 'Shuls Attended',
    shulName: 'Shul',
    rabbiName: 'Rabbi',
    mechutanim: 'Mechutanim',
    siblings: 'Siblings',
    age: 'Age',
    sharedResumesAutoAdded: 'Shared Resumes (auto-added)',
    mySingles: 'My Singles',
    publicSingles: 'Public Singles',
    shidduchim: 'Suggested Shidduchim',
    sharedResumes: 'Shared Resumes',
    backToChildrenList: 'Back to Children List',
    childsAccount: '{name}\'s Account',
    manageChildResume: 'Manage {name}\'s resume, references, and shadchan suggestions.',
    parentDashboard: 'Parent Dashboard',
    contactShadchanModalTitle: 'Contact a Shadchan',
    enterShadchanEmailToChat: 'Enter the shadchan\'s email to start a chat.',
    shadchanEmailPlaceholder: 'shadchan@email.com',
    startChat: 'Start Chat',
    starting: 'Starting…',
    failedToStartChat: 'Failed to start chat',
    keepDetailsAccurate: 'Keep your details accurate and references up to date.',
    profileInformation: 'Profile Information',
    basicPersonalFamilyDetails: 'Basic personal and family background details.',
    editProfile: 'Edit Profile',
    
    // Pages - About
    aboutTitle: 'About Resunize',
    aboutLead: 'Resunize supports the same trusted shidduch process that families and shadchanim already use — just with better organization. It keeps résumés, suggestions, notes, and communication in one place so the process becomes clearer, calmer, and easier to manage.',
    ourMission: 'Our Mission',
    ourMissionText: 'We believe that finding your shidduch should feel meaningful, organized, and less stressful. Resunize helps you stay on top of every detail while keeping the process respectful, familiar, and true to the way shidduchim have always been done.',
    aboutMobileAppsTitle: 'Mobile apps for iPhone & Android',
    aboutMobileAppsText:
      'Take Resunize with you — download our apps for iOS and Android for the same platform features with an experience tailored for your phone.',
    whatWeOffer: 'What We Offer',
    organizeResumesTitle: 'Organized Shidduch Résumés',
    organizeResumesText: 'Store all your standard shidduch résumés in one secure place. Upload PDFs and access them instantly whenever you need.',
    manageTheProcessTitle: 'Manage Suggestions & Notes',
    manageTheProcessText: 'Track every suggestion, add private notes, and keep important details clear throughout the entire process.',
    stayFocusedTitle: 'Clarity Without Changing the Process',
    stayFocusedText: 'Resunize doesn\'t reinvent shidduchim — it simply organizes what you\'re already doing so nothing gets lost or overlooked.',
    privacySecurityTitle: 'Privacy & Security',
    aboutPrivacySecurityText: 'We use appropriate technical and organizational safeguards to help protect your information and maintain confidentiality throughout the shidduch journey.',
    whoWeServe: 'Who We Serve',
    singlesTitle: 'Singles',
    singlesText: 'Upload and manage your résumé, receive suggestions, track your progress, and stay organized from start to finish.',
    parentsTitle: 'Parents',
    parentsText: 'Manage multiple children\'s accounts from one dashboard and keep all résumés, suggestions, and notes in one place.',
    builtWithCare: 'Built with Care',
    builtWithCareText: 'Resunize was created specifically for the Jewish community, with deep respect for the traditions and sensitivities of the shidduch world. Our goal is to support the process you already trust and make day-to-day coordination smoother — not to change the core approach, only to simplify it.',
    
    // Pages - Getting Started
    gettingStartedTitle: 'Getting Started with Resunize',
    forSinglesParents: 'For Singles & Parents',
    createYourAccount: 'Create Your Account',
    createYourAccountText: 'Register as a Single or Parent to begin your 60-day free trial. A credit card is required; you won\'t be charged until the trial ends. Parents can manage multiple children\'s profiles from one dashboard.',
    createYourDigitalResume: 'Create Your Resume',
    createYourDigitalResumeText: 'Build your complete resume with your details, references, shuls, schools, and more. You can also upload a PDF to auto-fill information.',
    uploadYourResume: 'Upload Your Résumé',
    uploadYourResumeText: 'Add your résumé to your dashboard so it\'s always ready to share when needed.',
    shareYourResume: 'Share Your Résumé',
    shareYourResumeText: 'Send your résumé to shadchanim and friends by email with ease.',
    receiveSuggestions: 'Receive Suggestions',
    receiveSuggestionsText: 'Shadchanim will send you suggestions. Review them in your Suggestions tab, move promising ones to Spotlight, and archive those not for now.',
    addPrivateNotes: 'Add Private Notes',
    addPrivateNotesText: 'Keep track of your thoughts, research, and feedback by adding private notes to every suggestion you receive.',
    forShadchanim: 'For Shadchanim',
    registerAsShadchan: 'Register as a Shadchan',
    registerAsShadchanText: 'Create your shadchan account to start reviewing résumés and managing suggestions.',
    browseAvailableSingles: 'Browse Available Singles',
    browseAvailableSinglesText: 'View public resumes and resumes shared with you. Search and filter to find the right matches.',
    createYourQuestionnaire: 'Create Your Questionnaire',
    createYourQuestionnaireText: 'Build your personalized questionnaire for boys and girls to better understand what types of shidduchim to recommend.',
    createMatches: 'Create Matches',
    createMatchesText: 'Suggest shidduchim and send résumés to singles and parents through Resunize or by direct email.',
    sendSuggestions: 'Send Suggestions',
    sendSuggestionsText: 'Send resume suggestions to singles or parents through Resunize or by direct email. They can review details in their dashboard when they use Resunize.',
    trackProgress: 'Track Progress',
    trackProgressText: 'Monitor the status of all your suggestions and matches in one organized dashboard.',
    tipsForSuccess: 'Tips for Success',
    tip1: 'Keep your résumé updated with accurate, current information',
    tip2: 'Use the Spotlight feature to highlight promising suggestions',
    tip3: 'Add private notes to remember important details',
    tip4: 'Communicate with shadchanim using the built-in messaging feature',
    tip5: 'Communicate with shadchanim through the messaging feature',
    getStartedNow: 'Start 60-Day Free Trial',
    navSubscriptionManage: 'Manage Subscription & Billing',
    navSubscriptionSetup: 'Start 60-Day Free Trial',
    alreadyHaveAccountQuestion: 'Already Have an Account?',
    
    // Pages - FAQ
    faqTitle: 'Frequently Asked Questions',
    faqLead: 'Find answers to common questions about using Resunize. If you don\'t find what you\'re looking for, please',
    contactSupportLink: 'contact support',
    faqCategoryGettingStarted: 'Getting Started',
    faqCategoryDigitalResumes: 'My Resume',
    faqCategorySuggestionsSpotlight: 'Suggestions & Spotlight',
    faqCategoryPrivacySecurity: 'Privacy & Security',
    faqCategoryTechnical: 'Technical',
    faqQ1: 'How do I create an account?',
    faqA1: 'Click on "Register" in the menu and choose whether you are a Single, Parent, or Shadchan. Fill out the registration form with your information and you\'ll be ready to start using Resunize.',
    faqQ2: 'Can parents manage multiple children?',
    faqA2: 'Yes! Parents can add multiple children to their account. Each child gets their own dashboard with their own resumes, suggestions, and spotlight list. You can switch between children easily from your parent dashboard.',
    faqQ3: 'What information do I need to create My Resume?',
    faqA3: 'You only need your résumé as a PDF and the name you want shown on the profile.',
    faqQ4: 'How do I share my resume with a shadchan?',
    faqA4: 'Open My Resume and choose Share. You can grant access to specific shadchanim on the platform or send your résumé by email.',
    faqQ5: 'Can I edit my resume after creating it?',
    faqA5: 'Yes, you can edit your resume at any time. Only you (the owner) can edit your resume. When shared with others, they see it in read-only mode.',
    faqQ6: 'What happens when I upload a PDF resume?',
    faqA6: 'Your file is stored in our secure, cloud-based system so you can access it whenever you need it.',
    faqQ7: 'Can I add references manually?',
    faqA7: 'Yes! You can add references manually with their name, relationship, phone number, email, and any notes. References are important for shadchanim to make informed suggestions.',
    faqQ8: 'What is the Spotlight list?',
    faqA8: 'The Spotlight list is for suggestions that are "hot on the table"—shidduchim you are actively considering. You can move suggestions from your regular Suggestions tab to Spotlight to prioritize them.',
    faqQ9: 'What does "Not for now" mean?',
    faqA9: 'The "Not for now" tab is for shidduchim you\'ve reviewed but aren\'t interested in at this time. You can restore them to Suggestions or Spotlight later if you change your mind.',
    faqQ10: 'Can I add notes to suggestions?',
    faqA10: 'Yes. When you open a suggestion, you can add private notes. Only you can see them; they help you keep track of what you have learned.',
    faqQ11: 'How do I know when I receive a new suggestion?',
    faqA11: 'You\'ll see new suggestions appear in your Suggestions tab. The platform will notify you when a shadchan sends you a suggestion.',
    faqQ12: 'How do I find singles to suggest?',
    faqA12: 'In your dashboard, you can browse public resumes and resumes that have been shared with you. Use the search and filter features to find the right matches.',
    faqQ14: 'Can I track the status of my suggestions?',
    faqA14: 'Yes! In your dashboard, you can see all suggestions you\'ve sent and their current status. You can also see which suggestions have been moved to Spotlight or archived.',
    faqQ16: 'Who can see my information?',
    faqA16: 'Your information is safe and secure. It is stored on an encrypted cloud server and is never made public.',
    faqQ17: 'Is my information secure?',
    faqA17: 'Yes, we use industry-standard security measures including encrypted connections, secure password storage, and role-based access control. Your information is protected and only accessible to authorized users.',
    faqQ18: 'Can I delete my account?',
    faqA18: 'Yes, you can contact support to request account deletion. We\'ll remove all your data in accordance with our privacy policy.',
    faqQ19: 'What browsers are supported?',
    faqA19: 'Resunize works best on modern browsers including Chrome, Firefox, Safari, and Edge. Make sure you\'re using an updated version for the best experience.',
    faqQ20: 'Can I use Resunize on mobile?',
    faqA20: 'Yes. Resunize is responsive and works well on smartphones and tablets, with access to the same features as on desktop. Native Android and iOS apps are in development.',
    faqQ21: 'What if I forget my password?',
    faqA21: 'Click "Forgot your password?" on the login page. Enter your email and you\'ll receive a password reset link. Follow the instructions to create a new password.',
    faqQ22: 'Why was I automatically logged out?',
    faqA22: 'For security, you\'ll be automatically logged out after 5 minutes of inactivity or when you navigate to the home page. Simply log in again to continue.',
    stillHaveQuestions: 'Still Have Questions?',
    stillHaveQuestionsText: 'Can\'t find the answer you\'re looking for? Our support team is here to help.',
    contactUs: 'Contact us',
    stillHaveQuestionsText2: 'and we\'ll get back to you as soon as possible.',
    
    // Pages - Terms of Use
    termsTitle: 'Terms of Use',
    lastUpdated: 'Last updated',
    termsAcceptance: '1. Acceptance of Terms',
    termsAcceptanceText: 'By accessing and using Resunize ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.',
    termsUseLicense: '2. Use License',
    termsUseLicenseText: 'Permission is granted to temporarily use Resunize for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:',
    termsUseLicenseItem1: 'Modify or copy the materials',
    termsUseLicenseItem2: 'Use the materials for any commercial purpose or for any public display',
    termsUseLicenseItem3: 'Attempt to reverse engineer any software contained on Resunize',
    termsUseLicenseItem4: 'Remove any copyright or other proprietary notations from the materials',
    termsUseLicenseItem5: 'Transfer the materials to another person or "mirror" the materials on any other server',
    termsUserAccounts: '3. User Accounts',
    termsUserAccountsText: 'You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account or password. You must notify us immediately of any unauthorized use of your account.',
    termsUserContent: '4. User Content',
    termsUserContentText1: 'You retain ownership of any content you submit, post, or display on or through the Service. By submitting content, you grant Resunize a worldwide, non-exclusive, royalty-free license to use, reproduce, and distribute such content solely for the purpose of providing and improving the Service.',
    termsUserContentText2: 'You are solely responsible for the content you post and represent that you have all necessary rights to post such content. You agree not to post content that is illegal, harmful, threatening, abusive, or violates any third party\'s rights.',
    termsPrivacy: '5. Privacy',
    termsPrivacyText: 'Your use of Resunize is also governed by our Privacy Policy. Please review our Privacy Policy to understand our practices regarding the collection and use of your information.',
    termsProhibitedUses: '6. Prohibited Uses',
    termsProhibitedUsesText: 'You may not use the Service:',
    termsProhibitedUsesItem1: 'In any way that violates any applicable law or regulation',
    termsProhibitedUsesItem2: 'To transmit any malicious code or viruses',
    termsProhibitedUsesItem3: 'To impersonate or attempt to impersonate another user or person',
    termsProhibitedUsesItem4: 'To engage in any automated use of the system',
    termsProhibitedUsesItem5: 'To interfere with or disrupt the Service or servers',
    termsProhibitedUsesItem6: 'To collect or store personal data about other users without their permission',
    termsTermination: '7. Termination',
    termsTerminationText: 'We may terminate or suspend your account and access to the Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use the Service will cease immediately.',
    termsDisclaimer: '8. Disclaimer',
    termsDisclaimerText1: 'The materials on Resunize are provided on an \'as is\' basis. Resunize makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.',
    termsDisclaimerText2: 'Resunize does not guarantee the accuracy, completeness, or usefulness of any information on the Service. We are not responsible for the actions, content, information, or data of third parties.',
    termsLimitationLiability: '9. Limitation of Liability',
    termsLimitationLiabilityText: 'In no event shall Resunize or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Resunize, even if Resunize or a Resunize authorized representative has been notified orally or in writing of the possibility of such damage.',
    termsChanges: '10. Changes to Terms',
    termsChangesText: 'We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.',
    termsCsae: '11. Child safety (CSAE)',
    termsCsaeText: 'Our standards against child sexual abuse and exploitation are published here:',
    childSafetyCsaeLink: 'Child safety & CSAE standards',
    termsContact: '12. Contact Information',
    termsContactText: 'If you have any questions about these Terms of Use, please contact us through our',
    termsNote: 'Note',
    termsNoteText: 'By using Resunize, you acknowledge that you have read, understood, and agree to be bound by these Terms of Use.',
    
    // Pages - Privacy Policy
    privacyTitle: 'Privacy Policy',
    privacyLead: 'At Resunize, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Service.',
    privacyInfoWeCollect: '1. Information We Collect',
    privacyPersonalInfo: 'Personal Information',
    privacyPersonalInfoText: 'We collect information that you provide directly to us, including:',
    privacyPersonalInfoItem1: 'Name, email address, and phone number',
    privacyPersonalInfoItem2: 'Account credentials (password, stored securely)',
    privacyPersonalInfoItem3: 'Resume information (personal details, family information, references, etc.)',
    privacyPersonalInfoItem4: 'Messages and communications sent through the platform',
    privacyPersonalInfoItem5: 'Any other information you choose to provide',
    privacyAutoCollected: 'Automatically Collected Information',
    privacyAutoCollectedText: 'When you use our Service, we may automatically collect:',
    privacyAutoCollectedItem1: 'Device information (browser type, operating system)',
    privacyAutoCollectedItem2: 'Usage data (pages visited, features used, time spent)',
    privacyAutoCollectedItem3: 'IP address and location data',
    privacyAutoCollectedItem4: 'Cookies and similar tracking technologies',
    privacyAndroidTitle: 'Android app permissions',
    privacyAndroidLead:
      'The Resunize Android app loads our website in an in-app browser. It may request device permissions so you can use the same features as on the web, including:',
    privacyAndroidCamera:
      'Camera — if you capture photos or video for your profile, resume, or uploads.',
    privacyAndroidMic:
      'Microphone — if you record audio (for example voice notes or similar features).',
    privacyAndroidPhotos:
      'Photos and media — if you choose files from your device to upload.',
    privacyAndroidNotifications:
      'Notifications — to show alerts about messages or account activity when you opt in.',
    privacyAndroidClosing:
      'You can allow or deny these in your device settings. We use them only to provide the features you actively use; we do not sell this permission data to third parties.',
    privacyHowWeUse: '2. How We Use Your Information',
    privacyHowWeUseText: 'We use the information we collect to:',
    privacyHowWeUseItem1: 'Provide, maintain, and improve our Service',
    privacyHowWeUseItem2: 'Process your registration and manage your account',
    privacyHowWeUseItem3: 'Enable communication between users (singles, parents, and shadchanim)',
    privacyHowWeUseItem4: 'Send suggestions and notifications',
    privacyHowWeUseItem5: 'Respond to your inquiries and provide customer support',
    privacyHowWeUseItem6: 'Detect, prevent, and address technical issues and security threats',
    privacyHowWeUseItem7: 'Comply with legal obligations',
    privacySharing: '3. Information Sharing and Disclosure',
    privacySharingText: 'We respect your privacy and only share your information in the following circumstances:',
    privacySharingWithConsent: 'With Your Consent',
    privacySharingWithConsentText: 'We share your resume information with shadchanim only when you explicitly share it or set it to public. You control who can see your information.',
    privacySharingServiceProviders: 'Service Providers',
    privacySharingServiceProvidersText: 'We may share information with third-party service providers who perform services on our behalf (hosting, email delivery, analytics). These providers are bound by confidentiality agreements.',
    privacySharingLegal: 'Legal Requirements',
    privacySharingLegalText: 'We may disclose information if required by law, court order, or government regulation, or to protect the rights, property, or safety of Resunize, our users, or others.',
    privacySharingBusiness: 'Business Transfers',
    privacySharingBusinessText: 'In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of that transaction.',
    privacySecurity: '4. Data Security',
    privacySecurityText: 'We implement appropriate technical and organizational security measures to protect your information, including:',
    privacySecurityItem1: 'Encryption of data in transit (SSL/TLS)',
    privacySecurityItem2: 'Secure password storage using industry-standard hashing',
    privacySecurityItem3: 'Role-based access control',
    privacySecurityItem4: 'Regular security assessments and updates',
    privacySecurityItem5: 'Limited access to personal information on a need-to-know basis',
    privacySecurityNote: 'However, no method of transmission over the Internet or electronic storage is 100% secure. While we strive to protect your information, we cannot guarantee absolute security.',
    privacyRights: '5. Your Privacy Rights',
    privacyRightsText: 'You have the right to:',
    privacyRightsAccess: 'Access',
    privacyRightsAccessText: 'Request access to your personal information',
    privacyRightsCorrection: 'Correction',
    privacyRightsCorrectionText: 'Update or correct your information at any time',
    privacyRightsDeletion: 'Deletion',
    privacyRightsDeletionText: 'Request deletion of your account and data',
    privacyRightsOptOut: 'Opt-out',
    privacyRightsOptOutText: 'Unsubscribe from non-essential communications',
    privacyRightsPortability: 'Data Portability',
    privacyRightsPortabilityText: 'Request a copy of your data in a portable format',
    privacyRightsContact: 'To exercise these rights, please contact us through our',
    privacyCookies: '6. Cookies and Tracking Technologies',
    privacyCookiesText: 'We use cookies and similar tracking technologies to track activity on our Service and store certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.',
    privacyChildren: '7. Children\'s Privacy',
    privacyChildrenText: 'Our Service is not intended for children under the age of 18. We do not knowingly collect personal information from children. If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately.',
    privacyRetention: '8. Data Retention',
    privacyRetentionText: 'We retain your information for as long as your account is active or as needed to provide you services. If you delete your account, we will delete or anonymize your information, except where we are required to retain it for legal purposes.',
    privacyInternational: '9. International Data Transfers',
    privacyInternationalText: 'Your information may be transferred to and processed in countries other than your country of residence. These countries may have data protection laws that differ from those in your country. By using our Service, you consent to such transfers.',
    privacyChanges: '10. Changes to This Privacy Policy',
    privacyChangesText: 'We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date. You are advised to review this Privacy Policy periodically for any changes.',
    privacyContact: '11. Contact Us',
    privacyContactText: 'If you have any questions about this Privacy Policy, please contact us through our',
    privacyMatters: 'Your Privacy Matters',
    privacyMattersText: 'We are committed to protecting your privacy and being transparent about how we collect and use your information. If you have concerns or questions, please don\'t hesitate to reach out.',
    
    // Pages - Contact Support
    contactSupportSubtitle: 'We\'re here to help! Reach out with any questions or concerns.',
    emailUs: 'Email Us',
    responseTime: 'Response Time',
    responseTimeText: 'Within 24-48 hours',
    supportHours: 'Support Hours',
    supportHoursText: 'Monday - Friday, 9 AM - 5 PM EST',
    nameRequired: 'Name *',
    emailRequired: 'Email *',
    categoryRequired: 'Category *',
    subjectRequired: 'Subject *',
    messageRequired: 'Message *',
    generalInquiry: 'General Inquiry',
    technicalSupport: 'Technical Support',
    accountIssues: 'Account Issues',
    billingQuestion: 'Billing Question',
    featureRequest: 'Feature Request',
    reportBug: 'Report a Bug',
    privacyConcern: 'Privacy Concern',
    contactCategoryAccountDeletion: 'Account & data deletion',
    sendMessage: 'Send Message',
    sending: 'Sending...',
    frequentlyAskedQuestions: 'Frequently Asked Questions',
    beforeContacting: 'Before contacting support, you might find the answer in our',
    faqSection: 'FAQ section',
    beforeContactingText: 'We\'ve compiled answers to the most common questions about using Resunize.',
    needImmediateHelp: 'Need Immediate Help?',
    needImmediateHelpText: 'For urgent account issues or security concerns, please include "URGENT" in your subject line. We prioritize these requests and will respond as quickly as possible.',
    privacyRightsDeletionBlurb: 'Request removal of your account and associated personal data.',
    dataDeletionTitle: 'Delete account & data',
    dataDeletionLeadBeforePrivacy: 'You can request that we delete your Resunize account and the personal data associated with it. We will verify your request and process it in line with our',
    dataDeletionLeadAfterPrivacy: 'We may ask you to confirm ownership of the account before deleting data.',
    dataDeletionWarningTitle: 'Before you continue',
    dataDeletionWarningText: 'Deletion may remove your profile, resumes, messages, and related content. Some information may be retained where the law requires (for example billing records).',
    dataDeletionHelpBefore: 'Submit the form using the',
    dataDeletionEmailStrong: 'email address on your account',
    dataDeletionHelpMiddle: 'If you cannot access that email, explain that in the message and include information we can use to verify your identity. You can also reach us via',
    dataDeletionNameLabel: 'Name *',
    dataDeletionEmailLabel: 'Email on your account *',
    dataDeletionDetailsLabel: 'Details (optional)',
    dataDeletionDefaultMessage: 'I request that my Resunize account and all associated personal data be deleted. I understand this may be irreversible after processing.',
    dataDeletionConfirmCheck: 'I understand that account deletion is serious and I want Resunize to delete my account and associated personal data as described above.',
    dataDeletionSubmitBtn: 'Submit deletion request',
    dataDeletionSending: 'Sending…',
    dataDeletionNeedConfirmToast: 'Please confirm that you understand this request.',
    dataDeletionSuccessToast: 'Your request was sent. We will process it and follow up by email.',
    dataDeletionErrorToast: 'Could not send your request. Please try again or email support.',
    
    // Chat
    chatTitle: 'Messages',
    conversations: 'Conversations',
    searchConversations: 'Search conversations...',
    contactShadchan: 'Contact Shadchan',
    contactSingle: 'Contact Single',
    contactByEmail: 'Contact by email',
    start: 'Start',
    noConversations: 'No conversations yet. Start a new conversation to begin messaging.',
    startNewConversation: 'Start New Conversation',
    typeMessage: 'Type a message...',
    send: 'Send',
    noMessages: 'No messages yet. Start the conversation!',
    searchContacts: 'Search contacts...',
    noContacts: 'No contacts found.',
    selectContact: 'Select a contact to start chatting',
    attachment: 'Attachment',
    removeAttachment: 'Remove attachment',
    fileSizeError: 'File size must be less than 10MB',
    today: 'Today',
    read: 'Read',
    sent: 'Sent',
    image: 'Image',
    file: 'File',
    justNow: 'Just now',
    minutesAgo: '{minutes} minutes ago',
    hoursAgo: '{hours} hours ago',
    daysAgo: '{days} days ago',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    loginFailedError: 'Login failed',
    conversations: 'Conversations',
    searchConversations: 'Search conversations...',
    contactShadchan: 'Contact a shadchan',
    contactSingle: 'Contact a single',
    justNow: 'Just now',
    minutesAgo: '{minutes}m ago',
    hoursAgo: '{hours}h ago',
    daysAgo: '{days}d ago',
    image: 'Image',
    file: 'File',
    preview: 'Preview',
    
    // Metadata
    siteTitle: 'Resunize - Shidduch Organizer',
    siteDescription: 'For parents and singles who take shidduchim seriously.',
    brandSlogan: 'For parents and singles who take shidduchim seriously.',
    enableJavaScript: 'You need to enable JavaScript to run this app.',
    wrongAccountType: 'This account is a {role}. Please use the correct login page.',
    failedToUpdateVisibility: 'Failed to update visibility',
    failedToLoadProfile: 'Failed to load profile',
    failedToLoadResumes: 'Failed to load resumes',

    // Landing Page
    landingBadge: 'The Modern Resume Organizer',
    landingHero1: 'Shidduchim are complicated enough,',
    landingHero2: "the paperwork shouldn't be",
    landingPainQuote1: 'Did anyone see where my shidduch notebook is?',
    landingPainQuote2: "The name rings a bell but I don't remember if it was already redt.",
    landingPainQuote3: "Someone already mentioned the name a while ago but I don't remember why it wasn't for us.",
    landingSubtitle: 'Resunize keeps the same shidduch process you already know, just more organized. Upload your suggested PDF resumes, and keep notes and important information together in one place.',
    landingGetStarted: 'Register now',
    landingSignIn: 'Sign In',
    landingSecure: 'Secure & Private',
    landingFree: '60-Day Free Trial',
    landingTrialNote: '60-day free trial with full access. Credit card required to start.',
    landingTrusted: 'Trusted Platform',
    landingFeaturesLabel: 'Why Resunize',
    landingFeaturesTitle1: 'The same process,',
    landingFeaturesTitle2: 'just better organized',
    landingFeaturesSubtitle: 'No new system to learn. Just simple tools to organize resumes, suggestions, and notes.',
    landingFeatureDigitalTitle: 'Resume Upload',
    landingFeatureDigitalDesc: 'Upload your suggested resume PDF. It saves time and keeps your regular process moving.',
    landingFeatureTrackTitle: 'Suggestions & Notes',
    landingFeatureTrackDesc: 'Keep each suggestion organized with statuses, notes, and important details so nothing gets lost.',
    landingFeatureChildrenTitle: 'Manage Multiple Children',
    landingFeatureChildrenDesc: 'Choose the account type that fits your needs. Singles can manage their own resumes and suggestions, while parents can create a parent account that allows them to oversee and organize multiple children\'s profiles from one simple dashboard.',
    landingFeatureMessageTitle: 'Simple Communication',
    landingFeatureMessageDesc: 'When needed, keep messages and shared files in one place so conversations stay clear and organized.',
    landingFeaturePrivacyTitle: 'Privacy First',
    landingFeaturePrivacyDesc: 'Your information is protected with industry-standard encryption. We never share your data with third parties — your privacy is our top priority.',
    landingFeatureLangTitle: 'Multi-Language',
    landingFeatureLangDesc: 'Full support for English, Hebrew, and Yiddish. The platform adapts to your preferred language.',
    landingFeatureDuplicateTitle: 'Duplicate Resume Detection',
    landingFeatureDuplicateDesc: 'We flag resumes you have already uploaded so you never store the same PDF twice by accident.',
    myResumeComingSoonTitle: 'Coming soon',
    myResumeComingSoonMessage: 'Coming soon: create your own resume',
    duplicateResumeTitle: 'Resume already in your account',
    duplicateResumeSubtitle: 'This file matches a resume you already uploaded.',
    duplicateResumeBody: 'This resume is already in your account.',
    duplicateResumeConfirm: 'Do you still want to upload this new resume?',
    duplicateResumeViewExisting: 'View existing resume',
    duplicateResumeUploadAnyway: 'Upload anyway',
    bulkUploadTitle: 'Bulk upload',
    bulkUploadSubtitle: 'Select multiple PDF resumes at once. Each file is saved to your Suggestions list.',
    bulkUploadSelectFiles: 'Select PDF files',
    bulkUploadInProgress: 'Uploading…',
    bulkUploadProgress: '{done} of {total} complete',
    bulkUploadComplete: '{count} resume(s) uploaded successfully.',
    bulkUploadPdfOnly: 'Please select PDF files only.',
    bulkUploadGenderRequired: 'Set your account gender in profile settings before bulk uploading.',
    speechStart: 'Dictate note',
    speechStop: 'Stop dictation',
    speechNotSupported: 'Speech recognition is not supported in this browser.',
    landingHowLabel: 'How It Works',
    landingHowTitle: 'Get started in minutes',
    landingHowSubtitle: 'Three simple steps to keep your regular shidduch process organized.',
    landingStep1Title: 'Create Your Account',
    landingStep1Desc: 'Sign up as a single or parent and start with the same workflow you already know.',
    landingStep2Title: 'Add Resume Information',
    landingStep2Desc: 'Upload a PDF resume when received, and keep all relevant information together.',
    landingStep3Title: 'Manage the Process',
    landingStep3Desc: 'Track suggestions, store notes, and keep communication organized from beginning to end.',
    landingMobileAppLabel: 'Mobile app',
    landingMobileAppTitle: 'Download our mobile app',
    landingMobileAppSubtitle: 'Take Resunize with you on iPhone and Android — same account, optimized for your phone.',
    landingRolesLabel: 'Built For Everyone',
    landingRolesTitle: 'Organized for your role',
    landingRoleSinglesTitle: 'Singles',
    landingRoleSinglesDesc: 'Keep your resume, suggestions, and notes organized in one place while following the usual process.',
    landingCtaTitle: 'Ready to organize your process?',
    landingCtaSubtitle: 'Start your 60-day free trial with full access. After the trial, billing is automatic based on how many resumes you have.',
    landingCtaButton: 'Register now',
    landingFooterAbout: 'About',
    landingFooterFaq: 'FAQ',
    landingFooterTerms: 'Terms',
    landingFooterPrivacy: 'Privacy',
    landingFooterContact: 'Contact',
  },
  he: {
    // Navbar
    gettingStarted: 'התחלה',
    navMobileApp: 'אפליקציה לנייד',
    about: 'אודות',
    faq: 'שאלות נפוצות',
    terms: 'תנאי שימוש',
    privacy: 'מדיניות פרטיות',
    contact: 'צור קשר',
    deleteAccountData: 'מחיקת חשבון ונתונים',
    login: 'התחברות',
    register: 'הרשמה',
    logout: 'התנתקות',
    upgradeToPro: 'שדרג ל-Pro',
    subscriptionPro: 'מנוי (Pro)',
    role: 'תפקיד',
    
    // Language names
    english: 'English',
    hebrew: 'עברית',
    yiddish: 'ייִדיש',
    
    // Auth
    welcomeBack: 'ברוך שובך',
    shadchanLogin: 'התחברות שדכן',
    singleLogin: 'התחברות רווק/ה',
    parentLogin: 'התחברות הורה',
    signInToAccount: 'התחבר לחשבון {role} שלך.',
    signInToManage: 'התחבר כדי לנהל פרופילים, המלצות ושידוכי Resunize.',
    email: 'אימייל',
    password: 'סיסמה',
    enterEmail: 'הכנס את האימייל שלך',
    enterPassword: 'הכנס את הסיסמה שלך',
    forgotPassword: 'שכחת סיסמה?',
    dontHaveAccount: 'אין לך חשבון?',
    alreadyHaveAccount: 'כבר יש לך חשבון?',
    createAccount: 'צור חשבון',
    chooseAccountType: 'בחר איזה סוג חשבון אתה {action}.',
    loggingInto: 'מתחבר אליו',
    creating: 'יוצר',
    areYouShadchan: 'האם אתה שדכן?',
    firstName: 'שם פרטי',
    lastName: 'שם משפחה',
    phone: 'טלפון',
    confirmPassword: 'אישור סיסמה',
    enterFirstName: 'הכנס את השם הפרטי שלך',
    enterLastName: 'הכנס את שם המשפחה שלך',
    enterPhone: 'הכנס את מספר הטלפון שלך',
    enterConfirmPassword: 'אשר את הסיסמה שלך',
    createPassword: 'צור סיסמה',
    confirmYourPassword: 'אשר את הסיסמה שלך',
    createYourAccount: 'צור את החשבון שלך',
    createAccountInMinute: 'צור חשבון {role} תוך פחות מדקה.',
    chooseRoleCompleteRegistration: 'בחר את התפקיד שלך, ואז השלם את ההרשמה המאובטחת שלך.',
    selectRole: 'בחר את התפקיד שלך',
    shadchan: 'שדכן',
    single: 'רווק/ה',
    parent: 'הורה',
    
    // Validation messages
    invalidEmail: 'כתובת אימייל לא תקינה',
    emailRequired: 'אימייל נדרש',
    passwordRequired: 'סיסמה נדרשת',
    passwordMinLength: 'הסיסמה חייבת להיות לפחות 8 תווים',
    passwordComplexity: 'הסיסמה חייבת להכיל לפחות אות אחת ומספר אחד',
    passwordsMustMatch: 'הסיסמאות חייבות להתאים',
    confirmPasswordRequired: 'אנא אשר את הסיסמה',
    firstNameRequired: 'שם פרטי נדרש',
    firstNameMaxLength: 'שם פרטי חייב להיות פחות מ-100 תווים',
    lastNameRequired: 'שם משפחה נדרש',
    lastNameMaxLength: 'שם משפחה חייב להיות פחות מ-100 תווים',
    invalidPhone: 'אנא הכנס מספר טלפון תקין',
    roleRequired: 'אנא בחר תפקיד',
    invalidRole: 'אנא בחר תפקיד תקין',
    
    // Common
    submit: 'שלח',
    cancel: 'ביטול',
    save: 'שמור',
    delete: 'מחק',
    edit: 'ערוך',
    close: 'סגור',
    ok: 'אישור',
    loading: 'טוען...',
    error: 'שגיאה',
    success: 'הצלחה',
    back: 'חזור',
    next: 'הבא',
    previous: 'הקודם',
    search: 'חפש',
    filter: 'סנן',
    actions: 'פעולות',
    appDownloadPromoWelcomeTitle: 'ברוכים הבאים לרסונייז',
    appDownloadPromoWelcomeSubtitle:
      'הורידו את אפליקציית המובייל לאייפון או לאנדרואיד — הישארו מסודרים בדרכים.',
    appDownloadPromoRandomTitle: 'קחו את רסונייז איתכם',
    appDownloadPromoRandomSubtitle: 'קבלו את אפליקציית רסונייז ב-App Store או ב-Google Play.',
    downloadOnAppStore: 'הורדה ב-App Store',
    getItOnGooglePlay: 'הורדה ב-Google Play',
    appStoreBadgeKicker: 'הורדה ב־',
    appStoreBadgeTitle: 'App Store',
    googlePlayBadgeKicker: 'זמין ב־',
    googlePlayBadgeTitle: 'Google Play',
    landingAppBarTitle: 'הורידו את אפליקציית רסונייז',
    landingAppBarSubtitle: 'אפליקציות נייטיביות לאייפון ולאנדרואיד — מהירות יותר, עם התראות.',
    landingAppBarNotNow: 'לא עכשיו',
    
    // Dashboard
    dashboard: 'לוח בקרה',
    myAccount: 'החשבון שלי',
    everythingInOnePlace: 'הכל במקום אחד: הקורות חיים שלך, ההמלצות וההצעות של השדכן.',
    myResumes: 'הקורות חיים שלי',
    myDigitalResumes: 'קורות החיים הדיגיטליות שלי',
    createResumeHere: 'צור קורות חיים כאן: נהל, שתף וערוך.',
    createMyResume: 'צור את קורות החיים שלי',
    editResume: 'ערוך קורות חיים',
    fillInYourDetails: 'מלא את הפרטים שלך למטה.',
    makePublicToShadchanim: 'הפוך קורות חיים אלו לציבוריים עבור כל השדכנים',
    addResume: 'הוסף קורות חיים',
    suggestions: 'הצעות',
    spotlight: 'בכותרות',
    spotlightList: 'רשימת בכותרות',
    notForNow: 'לא לעת עתה',
    profile: 'פרופיל',
    messages: 'הודעות',
    newResume: 'קורות חיים חדשות',
    yourResumes: 'הקורות חיים שלך',
    noResumesYet: 'עדיין אין קורות חיים.',
    selectResumeToEdit: 'בחר קורות חיים לעריכה.',
    public: 'ציבורי',
    private: 'פרטי',
    resume: 'קורות חיים',
    
    // Subscription
    subscription: 'מנוי',
    subscriptionManagement: 'ניהול מנוי',
    freePlan: 'תוכנית חינמית',
    proPlan: 'תוכנית Pro',
    proPlanActive: 'תוכנית Pro פעילה',
    proSubscriptionActive: 'מנוי Pro פעיל',
    unlimitedPlan: 'תוכנית ללא הגבלה',
    unlimitedSubscriptionActive: 'תוכנית ללא הגבלה פעילה',
    unlimitedPlanResumes: 'קורות חיים ללא הגבלה וגישה לכל התכונות של Pro.',
    proPlanResumes: 'עד 50 קורות חיים וגישה לכל התכונות של Pro.',
    unlimitedResumes: 'קורות חיים ללא הגבלה וגישה לכל התכונות של Pro.',
    currentPeriodEnds: 'התקופה הנוכחית מסתיימת',
    cancelSubscription: 'בטל מנוי',
    cancelScheduledMessage: 'המנוי יבוטל בסוף תקופת החיוב הנוכחית',
    subscribeToPro: 'הירשם ל-Pro',
    subscribeToUnlimited: 'הירשם לללא הגבלה',
    upgradeToUnlimited: 'שדרג לללא הגבלה',
    securePayment: 'תשלום מאובטח באמצעות Stripe',
    subscriptionActivated: 'המנוי הופעל!',
    thankYouForUpgrading: 'תודה על השדרוג. כעת יש לך גישה לתכונות התוכנית החדשה.',
    thankYouForUpgradingPro: 'תודה על שדרגת ל-Pro. כעת יש לך עד 50 קורות חיים וגישה לכל התכונות של Pro.',
    thankYouForUpgradingUnlimited: 'תודה על שדרגת לללא הגבלה. כעת יש לך קורות חיים ללא הגבלה וגישה לכל התכונות של Pro.',
    viewSubscription: 'צפה במנוי',
    goToDashboard: 'עבור ללוח הבקרה',
    pricingTitle: 'תמחור פשוט ושקוף',
    pricingSubtitle: 'התחילו בחינם, ושדרגו כשצריך יותר מקום לקורות חיים.',
    pricingPerMonth: '/חודש',
    pricingMostPopular: 'הכי פופולרי',
    pricingCurrentPlan: 'תוכנית נוכחית',
    pricingFreeTitle: 'חינם',
    pricingProTitle: 'Pro',
    pricingUnlimitedTitle: 'ללא הגבלה',
    pricingFreeCta: 'התחילו בחינם',
    pricingFreeFeature1: 'עד 10 קורות חיים',
    pricingFreeFeature2: 'ארגון הצעות והערות',
    pricingFreeFeature3: 'אחסון מאובטח',
    pricingProFeature1: 'עד 50 קורות חיים',
    pricingProFeature2: 'שיתוף קורות חיים באימייל',
    pricingProFeature3: 'תמיכה בעדיפות',
    pricingUnlimitedFeature1: 'קורות חיים ללא הגבלה',
    pricingUnlimitedFeature2: 'כל תכונות Pro כלולות',
    pricingUnlimitedFeature3: 'הכי מתאים למשפחות גדולות',
    resumeUsageMessage: 'השתמשת ב-{current} מתוך {limit} קורות חיים בתוכנית הנוכחית.',
    
    // Resume
    resumeLimitReached: 'הגעת למגבלת קורות החיים!',
    resumeLimitMessage: 'השתמשת ב-{current} מתוך {limit} קורות חיים בתוכנית החינמית. שדרג ל-Pro או ללא הגבלה לעוד.',
    createResume: 'צור קורות חיים',
    editResume: 'ערוך קורות חיים',
    deleteResume: 'מחק קורות חיים',
    resumeCreated: 'קורות חיים נוצרו',
    resumeUpdated: 'קורות חיים עודכנו',
    resumeDeleted: 'קורות חיים נמחקו',
    addResumeFromOutside: 'הוסף הצעת שידוך',
    createDigitalResume: 'העלה הצעת שידוך ועקוב אחר ההתקדמות.',
    resumeUploadedReadOnly: 'קורות החיים האלה הועלו וכעת הן לקריאה בלבד. אתה עדיין יכול להוסיף הערות תחת כל המלצה.',
    pdfResume: 'קורות חיים PDF',
    firstName: 'שם פרטי',
    lastName: 'שם משפחה',
    birthday: 'יום הולדת',
    height: 'גובה (אינצ\'ים)',
    feet: 'רגליים',
    inches: 'אינצ\'ים',
    address: 'כתובת',
    enterAddress: 'הכנס כתובת',
    city: 'עיר',
    state: 'מדינה',
    fathersName: 'שם האב',
    fathersOccupation: 'מקצוע האב',
    mothersName: 'שם האם',
    mothersOccupation: 'מקצוע האם',
    motherMaidenName: 'שם נעורים של האם',
    paternalGrandparents: 'סבים מצד האב',
    maternalGrandparents: 'סבים מצד האם',
    grandfather: 'סבא',
    grandmother: 'סבתא',
    shulsAttended: 'בתי כנסת שהשתתף',
    shulName: 'שם בית הכנסת',
    rabbiName: 'שם הרב',
    saved: 'נשמר',
    deleteThisResume: 'למחוק את קורות החיים האלה{name}? זה יסיר את ההמלצות, קבצי PDF, השיתופים וההצעות.',
    resumeSavedToSuggestions: 'קורות חיים נשמרו להצעות',
    failedToSaveToSuggestions: 'נכשל בשמירה להצעות',
    failedToLoadResumes: 'נכשל בטעינת קורות חיים דיגיטליות',
    failedToCreateResume: 'נכשל ביצירת קורות חיים',
    failedToSave: 'נכשל בשמירה',
    failedToDeleteResume: 'נכשל במחיקת קורות חיים',
    
    // Toast messages
    loginSuccessful: 'התחברות הצליחה!',
    registrationSuccessful: 'הרשמה הצליחה!',
    logoutSuccessful: 'התנתקת בהצלחה',
    loginFailed: 'התחברות נכשלה',
    registrationFailed: 'הרשמה נכשלה',
    
    // Additional common strings
    shareResume: 'שתף קורות חיים',
    shareResumeTitle: 'שתף קורות חיים',
    uploadPdf: 'העלה PDF',
    uploading: 'מעלה…',
    uploadPdfFirst: 'העלה PDF תחילה כדי למלא את הטופס אוטומטית, ואז המר אותו.',
    profilePicture: 'תמונת פרופיל',
    uploadProfilePicture: 'העלה תמונת פרופיל',
    uploadProfilePictureDescription: 'העלה תמונת פרופיל כדי personalize את קורות החיים שלך. אתה יכול לבחור האם לשתף אותה כאשר קורות החיים משותפים.',
    shareProfilePictureWhenResumeShared: 'שתף תמונת פרופיל כאשר קורות החיים משותפים',
    profilePictureUploaded: 'תמונת פרופיל הועלתה בהצלחה',
    profilePictureDeleted: 'תמונת פרופיל נמחקה בהצלחה',
    profilePictureNowShareable: 'תמונת פרופיל תהיה משותפת כאשר קורות החיים משותפים',
    profilePictureNotShareable: 'תמונת פרופיל לא תהיה משותפת כאשר קורות החיים משותפים',
    deleteProfilePictureConfirm: 'האם אתה בטוח שברצונך למחוק את תמונת הפרופיל הזו?',
    failedToUploadProfilePicture: 'נכשל בהעלאת תמונת פרופיל',
    failedToDeleteProfilePicture: 'נכשל במחיקת תמונת פרופיל',
    failedToLoadProfilePicture: 'נכשל בטעינת תמונת פרופיל',
    failedToUpdateShareable: 'נכשל בעדכון הגדרת השיתוף',
    invalidImageFormat: 'פורמט תמונה לא תקין. אנא העלה JPG, PNG, GIF או WebP.',
    imageTooLarge: 'התמונה גדולה מדי. גודל מקסימלי הוא 5MB.',
    noProfilePicture: 'לא הועלתה תמונת פרופיל',
    uploadProfilePictureToGetStarted: 'העלה תמונת פרופיל כדי להתחיל',
    replace: 'החלף',
    profilePictureIsShareable: 'תמונת פרופיל זו ניתנת לשיתוף עם שדכנים כאשר קורות החיים משותפים.',
    saving: 'שומר…',
    saveResume: 'שמור קורות חיים',
    saveToSpotlight: 'שמור לבכותרות',
    saveToSuggestions: 'שמור להצעות',
    discardChanges: 'בטל שינויים',
    discarding: 'מבטל…',
    discardResumeDraftConfirm:
      'לבטל את הטיוטה? קורות החיים שהועלו יוסרו מהחשבון עד להעלאה מחדש.',
    saveResumeBeforeLeavingTabs:
      'שמור לבכותרות או להצעות לפני מעבר ללשונית אחרת, או בטל את השינויים.',
    changesDiscarded: 'השינויים בוטלו',
    resumeSavedToSpotlight: 'קורות חיים נשמרו לבכותרות',
    failedToSaveToSpotlight: 'נכשל בשמירה לבכותרות',
    uploadFailed: 'העלאה נכשלה',
    failedToOpenPdf: 'נכשל בפתיחת PDF',
    failedToLoadPdf: 'נכשל בטעינת PDF',
    formAutoFilledFromPdf: 'טופס מולא אוטומטית מ-PDF',
    pleaseReviewYourInformation: 'אנא בדוק את המידע שלך',
    reviewAutofillMessage: 'הפרטים שלך נשלפו אוטומטית מה-PDF. אנא בדוק שכל השדות נכונים לפני המשך.',
    noPdfsYet: 'עדיין לא הועלו קבצי PDF',
    uploadPdfResumeToGetStarted: 'העלה קורות חיים ב-PDF כדי להתחיל',
    noPdfsAvailableForViewing: 'אין קבצי PDF זמינים לצפייה',
    rabbiPhone: 'טלפון הרב',
    siblingName: 'שם אחא/אחות',
    schoolNumber: 'בית ספר #{number}',
    mechutanNumber: 'מחותן #{number}',
    shulNumber: 'בית כנסת #{number}',
    noShulsAddedYet: 'עדיין לא נוספו בתי כנסת.',
    noSchoolsAddedYet: 'עדיין לא נוספו בתי ספר.',
    noMechutanimAddedYet: 'עדיין לא נוספו מחתנים.',
    noSiblingsAddedYet: 'עדיין לא נוספו אחים/אחיות.',
    viewProfile: 'צפה בפרופיל',
    shareForMatch: 'שתף לשידוך',
    togglePublicVisibility: 'החלף נראות ציבורית',
    makePrivate: 'הפוך לפרטי',
    makePublic: 'הפוך לציבורי',
    birthdayLabel: 'יום הולדת',
    heightLabel: 'גובה',
    synagogue: 'בית כנסת',
    searchSingles: 'חפש רווקים + קורות חיים משותפים…',
    searchPublicSingles: 'חפש רווקים ציבוריים…',
    searchShidduchim: 'חפש הצעות…',
    searchShadchanim: 'חפש שדכנים…',
    refresh: 'רענן',
    writeReferenceNote: 'כתוב מה ההמלצה אמרה לך… (רק אתה יכול לראות את זה)',
    phonePlaceholder: 'ספרות בלבד (או +)',
    shadchanEmailPlaceholder: 'shadchan@email.com',
    thankYouForHelp: 'תודה על העזרה שלך...',
    provideDetails: 'אנא ספק כמה שיותר פרטים כדי שנוכל לעזור לך טוב יותר...',
    willGenerateEmail: 'ייצור אימייל זמני אם לא מסופק',
    enterExistingEmail: 'הכנס את האימייל של חשבון הרווק הקיים',
    addChild: 'הוסף ילד',
    removeChild: 'הסר ילד',
    childCreated: 'הילד נוצר בהצלחה',
    childLinked: 'הילד קושר בהצלחה',
    failedToCreateChild: 'נכשל ביצירת ילד',
    failedToLinkChild: 'נכשל בקישור ילד',
    failedToLoadChildren: 'נכשל בטעינת ילדים',
    childRemoved: 'הילד הוסר',
    removeChildConfirm: 'האם אתה בטוח שברצונך להסיר ילד זה? פעולה זו תבטל את הקישור מחשבונך אך לא תמחק את חשבונו.',
    createChild: 'צור ילד',
    linkChild: 'קשר ילד',
    createNewChild: 'צור חשבון חדש',
    linkExistingChild: 'קשר חשבון קיים',
    childsEmail: 'אימייל הילד',
    childMustHaveAccount: 'לילד חייב להיות חשבון קיים עם תפקיד "רווק"',
    linking: 'מקשר…',
    yourChildren: 'הילדים שלי',
    manageChildrenAccounts: 'נהל את חשבונות ופרופילי הילדים שלך',
    noChildrenYet: 'עדיין לא נוספו ילדים.',
    addYourFirstChild: 'הוסף את הילד הראשון שלך',
    manageChildAccount: 'נהל את החשבון של {name}',
    backToChildrenList: 'חזרה לרשימת הילדים',
    childsAccount: 'החשבון של {name}',
    manageChildResume: 'נהל קורות חיים, המלצות והצעות שדכנים של {name}.',
    parentDashboard: 'לוח בקרה להורים',
    emailRequiredToLink: 'נדרש אימייל לקישור',
    failedToRemoveChild: 'נכשל בהסרת ילד',
    checkingLink: 'בודק...',
    childAlreadyLinked: 'ילד זה כבר מקושר',
    passwordRequiredForLinking: 'נדרשת סיסמה לקישור ראשוני',
    enterChildPassword: 'הכנס סיסמת חשבון הילד',
    passwordVerifyPermission: 'הסיסמה נדרשת כדי לוודא שיש לך הרשאה לקשר חשבון זה',
    failedToStartCheckout: 'נכשל בהתחלת תשלום',
    failedToCancelSubscription: 'נכשל בביטול מנוי',
    failedToLoadSubscription: 'נכשל בטעינת מנוי',
    processing: 'מעבד...',
    readOnlyShared: 'לקריאה בלבד (שותף איתך)',
    schoolsYeshivosAttended: 'בתי ספר / ישיבות שהשתתף',
    mechutanim: 'מחתנים',
    siblings: 'אחים/אחיות',
    summerCamp: 'קיץ / מחנה',
    enterSummerCamp: 'לדוגמה: מחנה אגודה, מחנה שטרנברג',
    previouslyMarried: 'נשוי בעבר',
    wasMarriedTo: 'היה נשוי ל',
    divorced: 'גרוש/ה',
    widowed: 'אלמן/ה',
    none: 'לא',
    enterName: 'הזן שם',
    selectOption: 'בחר...',
    personalInformation: 'מידע אישי',
    familyInformation: 'משפחה',
    educationAndCommunity: 'חינוך וקהילה',
    career: 'קריירה',
    uploadPdfToAutofill: 'העלה קובץ PDF כדי למלא אוטומטית את פרטי קורות החיים שלך.',
    noResumeDataAvailable: 'אין נתוני קורות חיים זמינים.',
    share: 'שתף',
    sharing: 'משתף…',
    shareViaResunize: 'שתף דרך Resunize',
    shareViaEmail: 'שתף באימייל',
    searchForShadchanim: 'חפש שדכנים',
    emailSentFromResunize: 'האימייל יישלח ישירות מ-Resunize.',
    recipientEmail: 'אימייל הנמען',
    enterRecipientEmailPlaceholder: 'הזן כתובת אימייל של הנמען...',
    enterRecipientEmail: 'אנא הזן אימייל נמען.',
    personalMessage: 'הודעה אישית',
    personalMessagePlaceholder: 'הוסף הודעה אישית לצירוף עם קורות החיים...',
    resumeBeingShared: 'קורות חיים שמשותפים',
    sendFromResunize: 'שלח מ-Resunize',
    sending: 'שולח...',
    emailSentSuccessfully: 'האימייל נשלח בהצלחה!',
    failedToSendEmail: 'השליחה נכשלה.',
    optional: 'אופציונלי',
    organizeResumes: 'ארגן קורות חיים',
    organizeResumesDesc: 'שמור כל הצעה בצורה מסודרת במקום מאובטח אחד. נפרד מקבצים מפוזרים וקבצי PDF אבודים — כל מה שאתה צריך נמצא בקצות האצבעות שלך.',
    manageTheProcess: 'נהל את התהליך',
    manageTheProcessDesc: 'עקוב בקלות אחר התקדמות, הוסף הערות פרטיות, והישאר על גבי כל פרט. קבל החלטות בביטחון עם בהירות ושלווה.',
    stayFocused: 'הישאר ממוקד',
    stayFocusedDesc: 'נקה את המסע והתמקד במה שבאמת חשוב. עם Resunize, תהליך השידוך הופך חלק יותר, פשוט יותר ומשמעותי יותר.',
    tipShadchan: 'תן טיפ לשדכן',
    tipYourShadchan: 'תן טיפ לשדכן שלך',
    showAppreciationForShadchan: 'הראה את הערכתך לשדכן שלך על העזרה במציאת השידוך.',
    tipShadchanProDescription: 'שדרג ל-Pro כדי לתת טיפ לשדכן שלך ולהראות את הערכתך לעבודה הקשה שלהם.',
    upgradeToPro: 'שדרג ל-Pro',
    proFeature: 'תכונת Pro',
    tipAnyShadchan: 'תן טיפ לכל שדכן במסד הנתונים',
    tipByEmail: 'תן טיפ לשדכנים בכתובת אימייל',
    securePaymentProcessing: 'עיבוד תשלומים מאובטח דרך Stripe',
    upgradeNow: 'שדרג עכשיו',
    maybeLater: 'אולי מאוחר יותר',
    selectFromDatabase: 'בחר ממסד הנתונים',
    selectShadchanFromList: 'בחר שדכן מהרשימה שלנו',
    tipShadchanNotInDatabase: 'תן טיפ לשדכן שעדיין לא רשום',
    enterEmailAddress: 'הכנס כתובת אימייל',
    shadchanEmailAddress: 'כתובת אימייל של השדכן',
    shadchanWillReceiveEmail: 'השדכן יקבל אימייל עם הוראות לתביעת הטיפ שלו.',
    sendTip: 'שלח טיפ',
    pleaseEnterValidAmount: 'אנא הכנס סכום תקין',
    proRequiredForTipping: 'מנוי Pro נדרש לטיפים',
    tipSentSuccessfully: 'טיפ נשלח בהצלחה!',
    failedToProcessTip: 'נכשל בעיבוד הטיפ',
    amount: 'סכום',
    messageOptional: 'הודעה (אופציונלי)',
    thankYouForHelp: 'תודה על העזרה שלך!',
    cardDetails: 'פרטי כרטיס',
    processing: 'מעבד...',
    withdrawalManagement: 'ניהול משיכות',
    availableBalance: 'יתרה זמינה',
    addWithdrawalMethod: 'הוסף שיטת משיכה',
    requestWithdrawal: 'בקש משיכה',
    selectMethod: 'בחר שיטה',
    selectWithdrawalMethod: 'בחר שיטת משיכה',
    maxAmount: 'סכום מקסימלי',
    withdrawalMethods: 'שיטות משיכה',
    noWithdrawalMethods: 'עדיין לא נוספו שיטות משיכה',
    default: 'ברירת מחדל',
    withdrawalHistory: 'היסטוריית משיכות',
    noWithdrawals: 'עדיין אין משיכות',
    date: 'תאריך',
    method: 'שיטה',
    status: 'סטטוס',
    failedToLoadData: 'נכשל בטעינת נתונים',
    withdrawalMethodAdded: 'שיטת משיכה נוספה בהצלחה',
    failedToAddMethod: 'נכשל בהוספת שיטת משיכה',
    pleaseSelectWithdrawalMethod: 'אנא בחר שיטת משיכה',
    insufficientBalance: 'יתרה לא מספקת',
    withdrawalRequestSubmitted: 'בקשת משיכה הוגשה בהצלחה',
    failedToRequestWithdrawal: 'נכשל בבקשת משיכה',
    methodType: 'סוג שיטה',
    stripeAccountId: 'מזהה חשבון Stripe',
    stripeAccountIdRequired: 'מזהה חשבון Stripe נדרש',
    stripeAccountIdHelp: 'מזהה חשבון Stripe Connect שלך (מתחיל ב-acct_)',
    paypalEmail: 'אימייל PayPal',
    paypalEmailRequired: 'אימייל PayPal נדרש',
    zelleEmail: 'אימייל Zelle',
    zellePhone: 'טלפון Zelle',
    zelleEmailOrPhoneRequired: 'אימייל או טלפון נדרש ל-Zelle',
    cancel: 'ביטול',
    add: 'הוסף',
    back: 'חזור',
    saveResumeOrUploadPdfToAddReferences: 'שמור את קורות החיים או העלה PDF תחילה כדי להוסיף המלצות.',
    saveResumeToAddReferences: 'שמור קורות חיים כדי להוסיף המלצות',
    resumeCreatedForReferences: 'קורות חיים נשמרו! כעת תוכל להוסיף המלצות.',
    resumeNeededForProfilePicture: 'יש ליצור קורות חיים תחילה לפני העלאת תמונת פרופיל.',
    resumeCreatedForProfilePicture: 'קורות חיים נוצרו. כעת תוכל להעלות תמונת פרופיל.',
    referenceAdded: 'המלצה נוספה',
    referenceRemoved: 'המלצה הוסרה',
    failedToAddReference: 'נכשל בהוספת המלצה',
    failedToRemoveReference: 'נכשל בהסרת המלצה',
    resumeMustBeCreatedFirst: 'קורות חיים חייבים להיווצר תחילה',
    suggestedBy: 'הוצע על ידי',
    enterSuggestedBy: 'הכנס מי הציע את קורות החיים...',
    suggestedByName: 'שם השדכן',
    suggestedByEmail: 'אימייל השדכן',
    enterShadchanName: 'הכנס שם שדכן...',
    enterShadchanEmail: 'הכנס אימייל שדכן...',
    searchShadchanim: 'חפש שדכנים',
    searchShadchanimPlaceholder: 'חפש לפי שם או אימייל...',
    orSearchShadchanim: 'או חפש משדכנים רשומים',
    tipPayShadchan: 'טיפ / תשלום לשדכן',
    personalNotes: 'הערות אישיות',
    personalNotesPlaceholder: 'הוסף הערות אישיות לגבי הצעה זו...',
    personalNotesDescription: 'הערות אלו פרטיות ונראות רק לך.',
    unsavedChangesWarning: 'יש לך שינויים שלא נשמרו. האם אתה בטוח שברצונך לעזוב?',
    saveProgressOrDiscard: 'שמור התקדמות או מחק שינויים?',
    personalNotes: 'ההערות האישיות שלי',
    personalNotesDescription: 'הערות אלה פרטיות וגלויות רק לך.',
    writePersonalNotes: 'כתוב הערות אישיות על הצעה זו...',
    saveNotes: 'שמור הערות',
    saved: 'נשמר',
    
    // Pages - About (Hebrew translations)
    aboutTitle: 'אודות Resunize',
    aboutLead: 'Resunize תומכת באותו תהליך שידוכים מהימן שמשפחות ושדכנים כבר מכירים — רק עם ארגון טוב יותר. היא שומרת קורות חיים, הצעות, הערות ותקשורת במקום אחד, כך שהתהליך הופך לברור יותר, רגוע יותר וקל יותר לניהול.',
    ourMission: 'המשימה שלנו',
    ourMissionText: 'אנו מאמינים שמציאת השידוך צריכה להרגיש משמעותית, מאורגנת ופחות מלחיצה. Resunize עוזרת לך לעמוד בראש כל פרט תוך שמירה על התהליך המכבד, המוכר והנאמן לדרך שבה שידוכים נעשים תמיד.',
    aboutMobileAppsTitle: 'אפליקציות ל-iPhone ול-Android',
    aboutMobileAppsText:
      'קחו את Resunize איתכם — הורידו את האפליקציות שלנו ל-iOS ול-Android לאותן תכונות עם חוויה מותאמת לטלפון.',
    whatWeOffer: 'מה אנו מציעים',
    organizeResumesTitle: 'קורות חיים מאורגנים לשידוך',
    organizeResumesText: 'אחסן את כל קורות החיים הרגילים לשידוך במקום מאובטח אחד. העלה PDF וגש אליהם מיד בכל עת שתצטרך.',
    manageTheProcessTitle: 'ניהול הצעות והערות',
    manageTheProcessText: 'עקוב אחר כל הצעה, הוסף הערות פרטיות, ושמור על פרטים חשובים ברורים לאורך כל התהליך.',
    stayFocusedTitle: 'בהירות בלי לשנות את התהליך',
    stayFocusedText: 'Resunize לא ממציאה מחדש את השידוכים — היא מארגנת רק את מה שאתם כבר עושים, כדי שלא יאבד או יפספס דבר.',
    privacySecurityTitle: 'פרטיות ואבטחה',
    aboutPrivacySecurityText: 'אנו משתמשים באמצעי הגנה טכניים וארגוניים מתאימים כדי לעזור בהגנה על המידע שלך ולשמירה על סודיות לאורך מסע השידוך.',
    whoWeServe: 'למי אנו משרתים',
    singlesTitle: 'רווקים',
    singlesText: 'העלה ונהל את קורות החיים שלך, קבל הצעות, עקוב אחר ההתקדמות והישאר מאורגן מההתחלה ועד הסוף.',
    parentsTitle: 'הורים',
    parentsText: 'נהל חשבונות של מספר ילדים מלוח בקרה אחד ושמור את כל קורות החיים, ההצעות וההערות במקום אחד.',
    builtWithCare: 'נבנה בקפידה',
    builtWithCareText: 'Resunize נבנתה במיוחד עבור הקהילה היהודית, עם כבוד עמוק למסורות ולרגישויות של עולם השידוכים. המטרה שלנו היא לתמוך בתהליך שאתם כבר סומכים עליו ולהחליק את התיאום היומיומי — לא לשנות את הגישה הבסיסית, רק לפשט אותה.',
    
    // Pages - Getting Started (Hebrew)
    gettingStartedTitle: 'התחלה עם Resunize',
    forSinglesParents: 'לרווקים והורים',
    createYourAccount: 'צור את החשבון שלך',
    createYourAccountText: 'הירשם כרווק או הורה כדי להתחיל. הורים יכולים לנהל בנוחות פרופילים של מספר ילדים מלוח בקרה אחד.',
    createYourDigitalResume: 'צור את קורות החיים שלך',
    createYourDigitalResumeText: 'בנה את קורות החיים המלאים שלך עם כל המידע שלך, המלצות, בתי כנסת, בתי ספר ועוד. אפשר גם להעלות קורות חיים ב-PDF למילוי אוטומטי של המידע.',
    uploadYourResume: 'העלה את קורות החיים שלך',
    uploadYourResumeText: 'הוסף את קורות החיים שלך ללוח הבקרה כדי שיהיו תמיד מוכנים לשיתוף כשתהיה צורך.',
    shareYourResume: 'שתף את קורות החיים שלך',
    shareYourResumeText: 'שלחו את קורות החיים שלכם לשדכנים ולחברים באימייל בקלות.',
    receiveSuggestions: 'קבל הצעות',
    receiveSuggestionsText: 'שדכנים ישלחו לך הצעות. עיין בהן בלשונית ההצעות, העבר מבטיחות לבכותרות וארכוב את אלה שלא לעת עתה.',
    addPrivateNotes: 'הוסף הערות פרטיות',
    addPrivateNotesText: 'עקוב אחר המחשבות, המחקר והמשוב שלך על ידי הוספת הערות פרטיות לכל הצעה שאתה מקבל.',
    forShadchanim: 'לשדכנים',
    registerAsShadchan: 'הירשם כשדכן',
    registerAsShadchanText: 'צור את חשבון השדכן שלך כדי להתחיל לעיין בקורות חיים ולנהל הצעות.',
    browseAvailableSingles: 'עיין ברווקים זמינים',
    browseAvailableSinglesText: 'צפה בקורות חיים ציבוריים ובקורות חיים ששותפו איתך. חפש וסנן כדי למצוא את השידוכים הנכונים.',
    createYourQuestionnaire: 'צור את השאלון שלך',
    createYourQuestionnaireText: 'בנה שאלון מותאם אישית לבנים ולבנות כדי להבין טוב יותר אילו סוגי שידוכים להמליץ.',
    createMatches: 'צור שידוכים',
    createMatchesText: 'הצע שידוכים ושלח קורות חיים לרווקים ולהורים דרך Resunize או בדוא"ל ישיר.',
    sendSuggestions: 'שלח הצעות',
    sendSuggestionsText: 'שלח הצעות קורות חיים לרווקים או הורים דרך Resunize או ישירות בדוא"ל. מי שמשתמש ב-Resunize יוכל לעיין בהן בלוח הבקרה שלו.',
    trackProgress: 'עקוב אחר התקדמות',
    trackProgressText: 'עקוב אחר הסטטוס של כל ההצעות והשידוכים שלך בלוח בקרה מאורגן אחד.',
    tipsForSuccess: 'טיפים להצלחה',
    tip1: 'שמור את קורות החיים שלך מעודכנים עם מידע מדויק ועדכני',
    tip2: 'השתמש בתכונת Spotlight כדי להדגיש הצעות מבטיחות',
    tip3: 'הוסף הערות פרטיות כדי לזכור פרטים חשובים',
    tip4: 'תקשר עם שדכנים באמצעות תכונת ההודעות המובנית',
    tip5: 'תקשר עם שדכנים דרך תכונת ההודעות',
    getStartedNow: 'התחל עכשיו',
    alreadyHaveAccountQuestion: 'כבר יש לך חשבון?',
    
    // Pages - FAQ (Hebrew) - Complete translations
    faqTitle: 'שאלות נפוצות',
    faqLead: 'מצא תשובות לשאלות נפוצות על שימוש ב-Resunize. אם לא תמצא מה שאתה מחפש, אנא',
    contactSupportLink: 'צור קשר עם התמיכה',
    faqCategoryGettingStarted: 'התחלה',
    faqCategoryDigitalResumes: 'קורות החיים שלי',
    faqCategorySuggestionsSpotlight: 'הצעות ובכותרות',
    faqCategoryPrivacySecurity: 'פרטיות ואבטחה',
    faqCategoryTechnical: 'טכני',
    faqQ1: 'איך אני יוצר חשבון?',
    faqA1: 'לחץ על "הרשמה" בתפריט ובחר האם אתה רווק, הורה או שדכן. מלא את טופס ההרשמה עם המידע שלך ותהיה מוכן להתחיל להשתמש ב-Resunize.',
    faqQ2: 'האם הורים יכולים לנהל מספר ילדים?',
    faqA2: 'כן! הורים יכולים להוסיף מספר ילדים לחשבון שלהם. כל ילד מקבל לוח בקרה משלו עם קורות החיים, ההצעות ורשימת הבכותרות שלו. אתה יכול לעבור בין ילדים בקלות מלוח הבקרה של ההורה.',
    faqQ3: 'איזה מידע אני צריך כדי ליצור את קורות החיים שלי?',
    faqA3: 'נדרשים רק קובץ PDF של קורות החיים והשם שיוצג בפרופיל.',
    faqQ4: 'איך אני משתף את קורות החיים שלי עם שדכן?',
    faqA4: 'עברו ל"קורות החיים שלי" ובחרו "שתף". ניתן לתת גישה לשדכנים ספציפיים בפלטפורמה או לשלוח את קורות החיים בדוא"ל.',
    faqQ5: 'האם אני יכול לערוך את קורות החיים שלי לאחר יצירתם?',
    faqA5: 'כן, אתה יכול לערוך את קורות החיים שלך בכל עת. רק אתה (הבעלים) יכול לערוך את קורות החיים שלך. כאשר משותף עם אחרים, הם רואים אותו במצב קריאה בלבד.',
    faqQ6: 'מה קורה כשאני מעלה קורות חיים ב-PDF?',
    faqA6: 'הקובץ נשמר בענן המאובטח שלנו, כך שתוכלו לגשת אליו בכל עת שתצטרכו.',
    faqQ7: 'האם אני יכול להוסיף המלצות ידנית?',
    faqA7: 'כן! אתה יכול להוסיף המלצות ידנית עם השם, הקשר, מספר הטלפון, האימייל וכל הערות. המלצות חשובות לשדכנים כדי להציע הצעות מושכלות.',
    faqQ8: 'מהי רשימת הבכותרות?',
    faqA8: 'רשימת הבכותרות מיועדת להצעות ש"חמות על השולחן" - שידוכים שאתה שוקל באופן פעיל. אתה יכול להעביר הצעות מהלשונית הרגילה של ההצעות לבכותרות כדי לתעדף אותן.',
    faqQ9: 'מה המשמעות של "לא לעת עתה"?',
    faqA9: 'הלשונית "לא לעת עתה" מיועדת לשידוכים שבדקת אבל לא מעוניין בהן כרגע. אתה יכול לשחזר אותן להצעות או לבכותרות מאוחר יותר אם תשנה את דעתך.',
    faqQ10: 'האם אני יכול להוסיף הערות להצעות?',
    faqA10: 'כן. בעת צפייה בהצעה ניתן להוסיף הערות פרטיות. רק אתה רואה אותן; הן עוזרות לעקוב אחר מה שלמדת.',
    faqQ11: 'איך אני יודע מתי אני מקבל הצעה חדשה?',
    faqA11: 'תראה הצעות חדשות מופיעות בלשונית ההצעות שלך. הפלטפורמה תתריע לך כששדכן שולח לך הצעה.',
    faqQ12: 'איך אני מוצא רווקים להציע?',
    faqA12: 'בלוח הבקרה שלך, אתה יכול לעיין בקורות חיים ציבוריים ובקורות חיים ששותפו איתך. השתמש בתכונות החיפוש והסינון כדי למצוא את השידוכים הנכונים.',
    faqQ14: 'האם אני יכול לעקוב אחר הסטטוס של ההצעות שלי?',
    faqA14: 'כן! בלוח הבקרה שלך, אתה יכול לראות את כל ההצעות ששלחת ואת הסטטוס הנוכחי שלהן. אתה יכול גם לראות אילו הצעות הועברו לבכותרות או נשמרו.',
    faqQ16: 'מי יכול לראות את המידע שלי?',
    faqA16: 'המידע שלך בטוח ומאובטח. הוא מאוחסן בשרת ענן מוצפן ולעולם אינו הופך לציבורי.',
    faqQ17: 'האם המידע שלי מאובטח?',
    faqA17: 'כן, אנו משתמשים באמצעי אבטחה ברמה תעשייתית כולל חיבורים מוצפנים, אחסון סיסמאות מאובטח, ובקרת גישה מבוססת תפקידים. המידע שלך מוגן ונגיש רק למשתמשים מורשים.',
    faqQ18: 'האם אני יכול למחוק את החשבון שלי?',
    faqA18: 'כן, אתה יכול ליצור קשר עם התמיכה כדי לבקש מחיקת חשבון. נסיר את כל הנתונים שלך בהתאם למדיניות הפרטיות שלנו.',
    faqQ19: 'אילו דפדפנים נתמכים?',
    faqA19: 'Resunize עובד הכי טוב בדפדפנים מודרניים כולל Chrome, Firefox, Safari ו-Edge. ודא שאתה משתמש בגרסה מעודכנת לחוויה הטובה ביותר.',
    faqQ20: 'האם אני יכול להשתמש ב-Resunize במובייל?',
    faqA20: 'כן. Resunize מותאם למובייל ועובד היטב בסמארטפונים ובטאבלטים, עם גישה לאותן תכונות כמו במחשב. אפליקציות ייעודיות ל-Android ול-iOS בפיתוח.',
    faqQ21: 'מה אם שכחתי את הסיסמה שלי?',
    faqA21: 'לחץ על "שכחת סיסמה?" בדף ההתחברות. הכנס את האימייל שלך ותקבל קישור לאיפוס סיסמה. עקוב אחר ההוראות כדי ליצור סיסמה חדשה.',
    faqQ22: 'למה התנתקתי אוטומטית?',
    faqA22: 'מטעמי אבטחה, תתנתק אוטומטית לאחר 5 דקות של חוסר פעילות או כשאתה מנווט לדף הבית. פשוט התחבר שוב כדי להמשיך.',
    stillHaveQuestions: 'עדיין יש שאלות?',
    stillHaveQuestionsText: 'לא מוצא את התשובה שאתה מחפש? צוות התמיכה שלנו כאן כדי לעזור.',
    contactUs: 'צור קשר',
    stillHaveQuestionsText2: 'ונחזור אליך בהקדם האפשרי.',
    
    // Pages - Terms (Hebrew) - Complete translations
    termsTitle: 'תנאי שימוש',
    lastUpdated: 'עודכן לאחרונה',
    termsAcceptance: '1. קבלת התנאים',
    termsAcceptanceText: 'על ידי גישה לשימוש ב-Resunize ("השירות"), אתה מקבל ומסכים להיות מחויב לתנאים והוראות של הסכם זה. אם אינך מסכים לעמוד לעיל, אנא אל תשתמש בשירות זה.',
    termsUseLicense: '2. רישיון שימוש',
    termsUseLicenseText: 'ניתנת הרשאה להשתמש זמנית ב-Resunize לצפייה אישית, לא מסחרית וחולפת בלבד. זו מתן רישיון, לא העברת בעלות, ובמסגרת רישיון זה אינך רשאי:',
    termsUseLicenseItem1: 'לשנות או להעתיק את החומרים',
    termsUseLicenseItem2: 'להשתמש בחומרים לכל מטרה מסחרית או לתצוגה ציבורית',
    termsUseLicenseItem3: 'לנסות להנדס לאחור כל תוכנה הכלולה ב-Resunize',
    termsUseLicenseItem4: 'להסיר כל זכויות יוצרים או סימונים קנייניים אחרים מהחומרים',
    termsUseLicenseItem5: 'להעביר את החומרים לאדם אחר או "לשקף" את החומרים בכל שרת אחר',
    termsUserAccounts: '3. חשבונות משתמשים',
    termsUserAccountsText: 'אתה אחראי לשמירה על הסודיות של החשבון והסיסמה שלך. אתה מסכים לקבל אחריות על כל הפעילויות המתרחשות תחת החשבון או הסיסמה שלך. עליך להודיע לנו מיד על כל שימוש לא מורשה בחשבון שלך.',
    termsUserContent: '4. תוכן משתמש',
    termsUserContentText1: 'אתה שומר על בעלות על כל תוכן שאתה שולח, מפרסם או מציג על או דרך השירות. על ידי שליחת תוכן, אתה מעניק ל-Resunize רישיון עולמי, לא בלעדי, ללא תמלוגים לשימוש, שכפול והפצה של תוכן כזה אך ורק למטרת מתן ושיפור השירות.',
    termsUserContentText2: 'אתה אחראי בלבד לתוכן שאתה מפרסם ומייצג שיש לך את כל הזכויות הנדרשות לפרסם תוכן כזה. אתה מסכים לא לפרסם תוכן שהוא בלתי חוקי, מזיק, מאיים, פוגעני או מפר זכויות של צד שלישי.',
    termsPrivacy: '5. פרטיות',
    termsPrivacyText: 'השימוש שלך ב-Resunize כפוף גם למדיניות הפרטיות שלנו. אנא עיין במדיניות הפרטיות שלנו כדי להבין את הפרקטיקות שלנו לגבי איסוף ושימוש במידע שלך.',
    termsProhibitedUses: '6. שימושים אסורים',
    termsProhibitedUsesText: 'אינך רשאי להשתמש בשירות:',
    termsProhibitedUsesItem1: 'בכל דרך המפרה כל חוק או תקנה חלים',
    termsProhibitedUsesItem2: 'להעביר כל קוד זדוני או וירוסים',
    termsProhibitedUsesItem3: 'להתחזות או לנסות להתחזות למשתמש או אדם אחר',
    termsProhibitedUsesItem4: 'לעסוק בכל שימוש אוטומטי של המערכת',
    termsProhibitedUsesItem5: 'להפריע או לשבש את השירות או השרתים',
    termsProhibitedUsesItem6: 'לאסוף או לאחסן נתונים אישיים על משתמשים אחרים ללא רשותם',
    termsTermination: '7. סיום',
    termsTerminationText: 'אנו רשאים לסיים או להשעות את החשבון שלך ואת הגישה לשירות מיד, ללא הודעה מוקדמת או אחריות, מכל סיבה שהיא, כולל ללא הגבלה אם אתה מפר את התנאים. עם סיום, זכותך להשתמש בשירות תיפסק מיד.',
    termsDisclaimer: '8. הצהרת אחריות',
    termsDisclaimerText1: 'החומרים ב-Resunize מסופקים על בסיס "כפי שהם". Resunize לא נותן כל אחריות, מפורשת או משתמעת, ובכך מתכחש ושולל כל אחריות אחרת כולל, ללא הגבלה, אחריות משתמעת או תנאים של סחירות, התאמה למטרה מסוימת, או אי הפרה של קניין רוחני או הפרה אחרת של זכויות.',
    termsDisclaimerText2: 'Resunize לא מבטיח את הדיוק, השלמות או התועלת של כל מידע בשירות. אנו לא אחראים לפעולות, תוכן, מידע או נתונים של צדדים שלישיים.',
    termsLimitationLiability: '9. הגבלת אחריות',
    termsLimitationLiabilityText: 'בשום מקרה Resunize או הספקים שלה לא יהיו אחראים לכל נזקים (כולל, ללא הגבלה, נזקים לאובדן נתונים או רווח, או עקב הפרעה עסקית) הנובעים משימוש או חוסר יכולת להשתמש בחומרים ב-Resunize, גם אם Resunize או נציג מורשה של Resunize הוזהר בעל פה או בכתב על אפשרות נזק כזה.',
    termsChanges: '10. שינויים בתנאים',
    termsChangesText: 'אנו שומרים לעצמנו את הזכות, לפי שיקול דעתנו הבלעדי, לשנות או להחליף את התנאים האלה בכל עת. אם תיקון הוא מהותי, נספק הודעה של לפחות 30 יום לפני שתנאים חדשים ייכנסו לתוקף. מה מהווה שינוי מהותי ייקבע לפי שיקול דעתנו הבלעדי.',
    termsCsae: '11. בטיחות ילדים (CSAE)',
    termsCsaeText: 'התקנים שלנו נגד ניצול ותקיפה מינית של ילדים מפורסמים כאן:',
    childSafetyCsaeLink: 'תקני בטיחות ילדים ו-CSAE',
    termsContact: '12. פרטי יצירת קשר',
    termsContactText: 'אם יש לך שאלות כלשהן על תנאי השימוש האלה, אנא צור קשר איתנו דרך',
    termsNote: 'הערה',
    termsNoteText: 'על ידי שימוש ב-Resunize, אתה מאשר שקראת, הבנת ומסכים להיות מחויב לתנאי השימוש האלה.',
    
    // Pages - Privacy (Hebrew) - Complete translations
    privacyTitle: 'מדיניות פרטיות',
    privacyLead: 'ב-Resunize, אנו לוקחים את הפרטיות שלך ברצינות. מדיניות הפרטיות הזו מסבירה איך אנו אוספים, משתמשים, חושפים ושומרים על המידע שלך כשאתה משתמש בשירות שלנו.',
    privacyInfoWeCollect: '1. מידע שאנו אוספים',
    privacyPersonalInfo: 'מידע אישי',
    privacyPersonalInfoText: 'אנו אוספים מידע שאתה מספק לנו ישירות, כולל:',
    privacyPersonalInfoItem1: 'שם, כתובת אימייל ומספר טלפון',
    privacyPersonalInfoItem2: 'פרטי חשבון (סיסמה, מאוחסנת בצורה מאובטחת)',
    privacyPersonalInfoItem3: 'מידע קורות חיים (פרטים אישיים, מידע משפחתי, המלצות וכו\')',
    privacyPersonalInfoItem4: 'הודעות ותקשורת שנשלחו דרך הפלטפורמה',
    privacyPersonalInfoItem5: 'כל מידע אחר שאתה בוחר לספק',
    privacyAutoCollected: 'מידע שנאסף אוטומטית',
    privacyAutoCollectedText: 'כשאתה משתמש בשירות שלנו, אנו עשויים לאסוף אוטומטית:',
    privacyAutoCollectedItem1: 'מידע על המכשיר (סוג דפדפן, מערכת הפעלה)',
    privacyAutoCollectedItem2: 'נתוני שימוש (דפים שביקרת, תכונות שהשתמשת, זמן שבילית)',
    privacyAutoCollectedItem3: 'כתובת IP ונתוני מיקום',
    privacyAutoCollectedItem4: 'עוגיות וטכנולוגיות מעקב דומות',
    privacyHowWeUse: '2. איך אנו משתמשים במידע שלך',
    privacyHowWeUseText: 'אנו משתמשים במידע שאנו אוספים כדי:',
    privacyHowWeUseItem1: 'לספק, לתחזק ולשפר את השירות שלנו',
    privacyHowWeUseItem2: 'לעבד את ההרשמה שלך ולנהל את החשבון שלך',
    privacyHowWeUseItem3: 'לאפשר תקשורת בין משתמשים (רווקים, הורים ושדכנים)',
    privacyHowWeUseItem4: 'לשלוח הצעות והתראות',
    privacyHowWeUseItem5: 'להגיב לשאלות שלך ולספק תמיכה ללקוחות',
    privacyHowWeUseItem6: 'לזהות, למנוע ולטפל בבעיות טכניות ואיומי אבטחה',
    privacyHowWeUseItem7: 'לעמוד בהתחייבויות משפטיות',
    privacySharing: '3. שיתוף וגילוי מידע',
    privacySharingText: 'אנו מכבדים את הפרטיות שלך ומשתפים את המידע שלך רק בנסיבות הבאות:',
    privacySharingWithConsent: 'עם הסכמתך',
    privacySharingWithConsentText: 'אנו משתפים את מידע קורות החיים שלך עם שדכנים רק כשאתה משתף אותו במפורש או מגדיר אותו לציבורי. אתה שולט במי יכול לראות את המידע שלך.',
    privacySharingServiceProviders: 'ספקי שירותים',
    privacySharingServiceProvidersText: 'אנו עשויים לשתף מידע עם ספקי שירותים של צד שלישי המבצעים שירותים מטעמנו (אירוח, משלוח דוא"ל, אנליטיקה). ספקים אלה כפופים להסכמי סודיות.',
    privacySharingLegal: 'דרישות משפטיות',
    privacySharingLegalText: 'אנו עשויים לחשוף מידע אם נדרש על פי חוק, צו בית משפט או תקנה ממשלתית, או כדי להגן על הזכויות, הרכוש או הבטיחות של Resunize, המשתמשים שלנו או אחרים.',
    privacySharingBusiness: 'העברות עסקיות',
    privacySharingBusinessText: 'במקרה של מיזוג, רכישה או מכירת נכסים, המידע שלך עשוי להיות מועבר כחלק מעסקה זו.',
    privacySecurity: '4. אבטחת נתונים',
    privacySecurityText: 'אנו מיישמים אמצעי אבטחה טכניים וארגוניים מתאימים כדי להגן על המידע שלך, כולל:',
    privacySecurityItem1: 'הצפנת נתונים במעבר (SSL/TLS)',
    privacySecurityItem2: 'אחסון סיסמאות מאובטח באמצעות הצפנה ברמה תעשייתית',
    privacySecurityItem3: 'בקרת גישה מבוססת תפקידים',
    privacySecurityItem4: 'הערכות אבטחה ועדכונים קבועים',
    privacySecurityItem5: 'גישה מוגבלת למידע אישי על בסיס צורך לדעת',
    privacySecurityNote: 'עם זאת, אין שיטת העברה דרך האינטרנט או אחסון אלקטרוני שהיא מאה אחוז מאובטחת. בעוד שאנו שואפים להגן על המידע שלך, איננו יכולים להבטיח אבטחה מוחלטת.',
    privacyRights: '5. זכויות הפרטיות שלך',
    privacyRightsText: 'יש לך את הזכות ל:',
    privacyRightsAccess: 'גישה',
    privacyRightsAccessText: 'לבקש גישה למידע האישי שלך',
    privacyRightsCorrection: 'תיקון',
    privacyRightsCorrectionText: 'לעדכן או לתקן את המידע שלך בכל עת',
    privacyRightsDeletion: 'מחיקה',
    privacyRightsDeletionText: 'לבקש מחיקה של החשבון והנתונים שלך',
    privacyRightsOptOut: 'הסרה',
    privacyRightsOptOutText: 'לבטל הרשמה מתקשורת לא חיונית',
    privacyRightsPortability: 'ניידות נתונים',
    privacyRightsPortabilityText: 'לבקש עותק של הנתונים שלך בפורמט נייד',
    privacyRightsContact: 'כדי לממש זכויות אלה, אנא צור קשר איתנו דרך',
    privacyCookies: '6. עוגיות וטכנולוגיות מעקב',
    privacyCookiesText: 'אנו משתמשים בעוגיות וטכנולוגיות מעקב דומות כדי לעקוב אחר פעילות בשירות שלנו ולאחסן מידע מסוים. אתה יכול להורות לדפדפן שלך לסרב לכל העוגיות או לציין מתי עוגיה נשלחת. עם זאת, אם אינך מקבל עוגיות, ייתכן שלא תוכל להשתמש בחלקים מסוימים מהשירות שלנו.',
    privacyChildren: '7. פרטיות ילדים',
    privacyChildrenText: 'השירות שלנו אינו מיועד לילדים מתחת לגיל 18. אנו לא אוספים במודע מידע אישי מילדים. אם אתה הורה או אפוטרופוס ומאמין שילדך סיפק לנו מידע אישי, אנא צור קשר איתנו מיד.',
    privacyRetention: '8. שמירת נתונים',
    privacyRetentionText: 'אנו שומרים את המידע שלך כל עוד החשבון שלך פעיל או כפי שנדרש כדי לספק לך שירותים. אם תמחק את החשבון שלך, נמחק או נאנונימי את המידע שלך, למעט מקומות שבהם אנו נדרשים לשמור אותו למטרות משפטיות.',
    privacyInternational: '9. העברות נתונים בינלאומיות',
    privacyInternationalText: 'המידע שלך עשוי להיות מועבר ומעובד במדינות אחרות ממדינת המגורים שלך. למדינות אלה עשויות להיות חוקי הגנת נתונים השונים מאלה במדינה שלך. על ידי שימוש בשירות שלנו, אתה מסכים להעברות כאלה.',
    privacyChanges: '10. שינויים במדיניות הפרטיות הזו',
    privacyChangesText: 'אנו עשויים לעדכן את מדיניות הפרטיות שלנו מעת לעת. נודיע לך על כל שינוי על ידי פרסום מדיניות הפרטיות החדשה בדף זה ועדכון תאריך "עודכן לאחרונה". מומלץ לך לבדוק את מדיניות הפרטיות הזו מעת לעת לכל שינוי.',
    privacyContact: '11. צור קשר',
    privacyContactText: 'אם יש לך שאלות כלשהן על מדיניות הפרטיות הזו, אנא צור קשר איתנו דרך',
    privacyMatters: 'הפרטיות שלך חשובה',
    privacyMattersText: 'אנו מחויבים להגן על הפרטיות שלך ולהיות שקופים לגבי איך אנו אוספים ומשתמשים במידע שלך. אם יש לך חששות או שאלות, אנא אל תהסס לפנות.',
    privacySecurityItem2: 'אחסון סיסמאות מאובטח באמצעות הצפנה ברמה תעשייתית',
    privacySecurityItem3: 'בקרת גישה מבוססת תפקידים',
    privacySecurityItem4: 'הערכות אבטחה ועדכונים קבועים',
    privacySecurityItem5: 'גישה מוגבלת למידע אישי על בסיס צורך לדעת',
    privacySecurityNote: 'עם זאת, אין שיטת העברה דרך האינטרנט או אחסון אלקטרוני שהיא מאה אחוז מאובטחת. בעוד שאנו שואפים להגן על המידע שלך, איננו יכולים להבטיח אבטחה מוחלטת.',
    privacyRights: '5. זכויות הפרטיות שלך',
    privacyRightsText: 'יש לך את הזכות ל:',
    privacyRightsAccess: 'גישה',
    privacyRightsAccessText: 'לבקש גישה למידע האישי שלך',
    privacyRightsCorrection: 'תיקון',
    privacyRightsCorrectionText: 'לעדכן או לתקן את המידע שלך בכל עת',
    privacyRightsDeletion: 'מחיקה',
    privacyRightsDeletionText: 'לבקש מחיקה של החשבון והנתונים שלך',
    privacyRightsOptOut: 'הסרה',
    privacyRightsOptOutText: 'לבטל הרשמה מתקשורת לא חיונית',
    privacyRightsPortability: 'ניידות נתונים',
    privacyRightsPortabilityText: 'לבקש עותק של הנתונים שלך בפורמט נייד',
    privacyRightsContact: 'כדי לממש זכויות אלה, אנא צור קשר איתנו דרך',
    privacyCookies: '6. עוגיות וטכנולוגיות מעקב',
    privacyCookiesText: 'אנו משתמשים בעוגיות וטכנולוגיות מעקב דומות כדי לעקוב אחר פעילות בשירות שלנו ולאחסן מידע מסוים. אתה יכול להורות לדפדפן שלך לסרב לכל העוגיות או לציין מתי עוגיה נשלחת. עם זאת, אם אינך מקבל עוגיות, ייתכן שלא תוכל להשתמש בחלקים מסוימים מהשירות שלנו.',
    privacyChildren: '7. פרטיות ילדים',
    privacyChildrenText: 'השירות שלנו אינו מיועד לילדים מתחת לגיל 18. אנו לא אוספים במודע מידע אישי מילדים. אם אתה הורה או אפוטרופוס ומאמין שילדך סיפק לנו מידע אישי, אנא צור קשר איתנו מיד.',
    privacyRetention: '8. שמירת נתונים',
    privacyRetentionText: 'אנו שומרים את המידע שלך כל עוד החשבון שלך פעיל או כפי שנדרש כדי לספק לך שירותים. אם תמחק את החשבון שלך, נמחק או נאנונימי את המידע שלך, למעט מקומות שבהם אנו נדרשים לשמור אותו למטרות משפטיות.',
    privacyInternational: '9. העברות נתונים בינלאומיות',
    privacyInternationalText: 'המידע שלך עשוי להיות מועבר ומעובד במדינות אחרות ממדינת המגורים שלך. למדינות אלה עשויות להיות חוקי הגנת נתונים השונים מאלה במדינה שלך. על ידי שימוש בשירות שלנו, אתה מסכים להעברות כאלה.',
    privacyChanges: '10. שינויים במדיניות הפרטיות הזו',
    privacyChangesText: 'אנו עשויים לעדכן את מדיניות הפרטיות שלנו מעת לעת. נודיע לך על כל שינוי על ידי פרסום מדיניות הפרטיות החדשה בדף זה ועדכון תאריך "עודכן לאחרונה". מומלץ לך לבדוק את מדיניות הפרטיות הזו מעת לעת לכל שינוי.',
    privacyContact: '11. צור קשר',
    privacyContactText: 'אם יש לך שאלות כלשהן על מדיניות הפרטיות הזו, אנא צור קשר איתנו דרך',
    privacyMatters: 'הפרטיות שלך חשובה',
    privacyMattersText: 'אנו מחויבים להגן על הפרטיות שלך ולהיות שקופים לגבי איך אנו אוספים ומשתמשים במידע שלך. אם יש לך חששות או שאלות, אנא אל תהסס לפנות.',
    
    // Pages - Contact Support (Hebrew)
    contactSupportSubtitle: 'אנחנו כאן כדי לעזור! פנה עם כל שאלה או דאגה.',
    emailUs: 'שלח לנו דוא"ל',
    responseTime: 'זמן תגובה',
    responseTimeText: 'תוך 24-48 שעות',
    supportHours: 'שעות תמיכה',
    supportHoursText: 'יום שני - יום שישי, 9:00 - 17:00 EST',
    nameRequired: 'שם *',
    emailRequired: 'אימייל *',
    categoryRequired: 'קטגוריה *',
    subjectRequired: 'נושא *',
    messageRequired: 'הודעה *',
    generalInquiry: 'חקירה כללית',
    technicalSupport: 'תמיכה טכנית',
    accountIssues: 'בעיות חשבון',
    billingQuestion: 'שאלת חיוב',
    featureRequest: 'בקשת תכונה',
    reportBug: 'דווח על באג',
    privacyConcern: 'דאגת פרטיות',
    sendMessage: 'שלח הודעה',
    sending: 'שולח...',
    frequentlyAskedQuestions: 'שאלות נפוצות',
    beforeContacting: 'לפני פנייה לתמיכה, אולי תמצא את התשובה ב',
    faqSection: 'סעיף השאלות הנפוצות',
    beforeContactingText: 'אספנו תשובות לשאלות הנפוצות ביותר על שימוש ב-Resunize.',
    needImmediateHelp: 'צריך עזרה מיידית?',
    needImmediateHelpText: 'לבעיות חשבון דחופות או דאגות אבטחה, אנא כלול "דחוף" בשורת הנושא. אנו מתעדפים בקשות אלה ונשיב בהקדם האפשרי.',
    
    // Chat (Hebrew)
    chatTitle: 'הודעות',
    conversations: 'שיחות',
    searchConversations: 'חפש שיחות...',
    contactShadchan: 'צור קשר עם שדכן',
    contactSingle: 'צור קשר עם רווק/ה',
    contactByEmail: 'צור קשר בדוא"ל',
    start: 'התחל',
    noConversations: 'עדיין אין שיחות. התחל שיחה חדשה כדי להתחיל לשלוח הודעות.',
    startNewConversation: 'התחל שיחה חדשה',
    typeMessage: 'הקלד הודעה...',
    send: 'שלח',
    noMessages: 'עדיין אין הודעות. התחל את השיחה!',
    searchContacts: 'חפש אנשי קשר...',
    noContacts: 'לא נמצאו אנשי קשר.',
    selectContact: 'בחר איש קשר כדי להתחיל לצ\'אט',
    attachment: 'קובץ מצורף',
    removeAttachment: 'הסר קובץ מצורף',
    fileSizeError: 'גודל הקובץ חייב להיות פחות מ-10MB',
    today: 'היום',
    read: 'נקרא',
    sent: 'נשלח',
    image: 'תמונה',
    file: 'קובץ',
    justNow: 'עכשיו',
    minutesAgo: 'לפני {minutes} דקות',
    hoursAgo: 'לפני {hours} שעות',
    daysAgo: 'לפני {days} ימים',
    showPassword: 'הצג סיסמה',
    hidePassword: 'הסתר סיסמה',
    loginFailedError: 'התחברות נכשלה',
    conversations: 'שיחות',
    searchConversations: 'חפש שיחות...',
    contactShadchan: 'צור קשר עם שדכן',
    contactSingle: 'צור קשר עם רווק/ה',
    justNow: 'עכשיו',
    minutesAgo: 'לפני {minutes} דקות',
    hoursAgo: 'לפני {hours} שעות',
    daysAgo: 'לפני {days} ימים',
    preview: 'תצוגה מקדימה',
    image: 'תמונה',
    file: 'קובץ',
    
    // Metadata (Hebrew)
    siteTitle: 'Resunize - שידוך אָרגאַנייזער',
    siteDescription: 'Resunize - ארגן קורות חיים, נהל את התהליך, הישאר ממוקד',
    enableJavaScript: 'אתה צריך לאפשר JavaScript כדי להפעיל את האפליקציה.',
    wrongAccountType: 'חשבון זה הוא {role}. אנא השתמש בדף ההתחברות הנכון.',
    failedToUpdateVisibility: 'נכשל בעדכון הנראות',
    failedToLoadProfile: 'נכשל בטעינת הפרופיל',
    failedToLoadResumes: 'נכשל בטעינת קורות החיים',

    // Landing Page (Hebrew)
    landingBadge: 'מארגן קורות החיים המודרני',
    landingHero1: 'שמרו על',
    landingHero2: 'תהליך השידוכים מאורגן',
    landingSubtitle: 'Resunize שומר על אותו תהליך שידוכים שאתם כבר מכירים, רק יותר מאורגן. העלו קובצי PDF של קורות חיים שהוצעו, ושמרו הערות ומידע חשוב יחד במקום אחד.',
    landingGetStarted: 'התחילו בחינם',
    landingSignIn: 'התחברות',
    landingSecure: 'מאובטח ופרטי',
    landingFree: 'חינם להתחלה',
    landingTrusted: 'פלטפורמה אמינה',
    landingFeaturesLabel: 'למה Resunize',
    landingFeaturesTitle1: 'אותו תהליך,',
    landingFeaturesTitle2: 'רק יותר מאורגן',
    landingFeaturesSubtitle: 'אין מערכת חדשה ללמוד. רק כלים פשוטים לארגון קורות חיים, הצעות והערות.',
    landingFeatureDigitalTitle: 'העלאת קורות חיים',
    landingFeatureDigitalDesc: 'העלו קובץ PDF של קורות חיים שהוצעו. זה חוסך זמן ושומר על התהליך הרגיל שלכם.',
    landingFeatureTrackTitle: 'הצעות והערות',
    landingFeatureTrackDesc: 'שמרו על כל הצעה עם סטטוסים, הערות ופרטים חשובים כדי שלא יאבד כלום.',
    landingFeatureChildrenTitle: 'ניהול מספר ילדים',
    landingFeatureChildrenDesc: 'בחרו את סוג החשבון שמתאים לכם. רווקים יכולים לנהל את קורות החיים וההצעות שלהם, בעוד שהורים יכולים לפתוח חשבון הורה שמאפשר לפקח ולארגן פרופילים של מספר ילדים מלוח בקרה אחד ופשוט.',
    landingFeatureMessageTitle: 'תקשורת פשוטה',
    landingFeatureMessageDesc: 'כשצריך, שמרו הודעות וקבצים משותפים במקום אחד כדי שהשיחות יישארו ברורות ומסודרות.',
    landingFeaturePrivacyTitle: 'פרטיות בראש סדר העדיפויות',
    landingFeaturePrivacyDesc: 'המידע שלכם מוגן בהצפנה תקנית. אנחנו לעולם לא משתפים את הנתונים שלכם עם צדדים שלישיים — הפרטיות שלכם היא בראש סדר העדיפויות שלנו.',
    landingFeatureLangTitle: 'רב-שפתי',
    landingFeatureLangDesc: 'תמיכה מלאה באנגלית, עברית ויידיש. הפלטפורמה מתאימה את עצמה לשפה המועדפת עליכם.',
    landingHowLabel: 'איך זה עובד',
    landingHowTitle: 'התחילו תוך דקות',
    landingHowSubtitle: 'שלושה שלבים פשוטים לשמור על תהליך השידוכים הרגיל שלכם מאורגן.',
    landingStep1Title: 'צרו את החשבון',
    landingStep1Desc: 'הירשמו כרווק/ה או הורה והתחילו עם אותו זרימת עבודה שאתם כבר מכירים.',
    landingStep2Title: 'הוסיפו מידע מקורות חיים',
    landingStep2Desc: 'העלו קובץ PDF של קורות חיים כשהוא מגיע, ושמרו את כל המידע הרלוונטי יחד.',
    landingStep3Title: 'נהלו את התהליך',
    landingStep3Desc: 'עקבו אחר הצעות, שמרו הערות ושמרו על תקשורת מאורגנת מההתחלה ועד הסוף.',
    landingMobileAppLabel: 'אפליקציה לנייד',
    landingMobileAppTitle: 'הורידו את אפליקציית המובייל',
    landingMobileAppSubtitle: 'קחו את Resunize איתכם ב־iPhone וב־Android — אותו חשבון, מותאם לנייד.',
    landingRolesLabel: 'בנוי לכולם',
    landingRolesTitle: 'מאורגן לפי התפקיד שלכם',
    landingRoleSinglesTitle: 'רווקים/ות',
    landingRoleSinglesDesc: 'שמרו על קורות החיים, ההצעות וההערות שלכם במקום אחד תוך שמירה על התהליך הרגיל.',
    landingCtaTitle: 'מוכנים לארגן את התהליך?',
    landingCtaSubtitle: 'אותו תהליך שידוכים, עם ארגון פשוט יותר לקורות חיים, הערות והצעות.',
    landingCtaButton: 'צרו חשבון בחינם',
    landingFooterAbout: 'אודות',
    landingFooterFaq: 'שאלות נפוצות',
    landingFooterTerms: 'תנאי שימוש',
    landingFooterPrivacy: 'פרטיות',
    landingFooterContact: 'צור קשר',
  },
  yi: {
    // Navbar
    gettingStarted: 'אָנהייב',
    navMobileApp: 'מאָביל־אַפּ',
    about: 'וועגן',
    faq: 'אָפט געפֿרעגטע פֿראַגן',
    terms: 'ניצונג טערמינען',
    privacy: 'פּריוואַטקייט פּאָליטיק',
    contact: 'קאָנטאַקט שטיצן',
    deleteAccountData: 'אויסמעקן אַקאָונט און דאַטן',
    login: 'אַרייַן',
    register: 'רעגיסטרירן',
    logout: 'אַרויסגיין',
    upgradeToPro: 'אַרויפֿגרײַדן צו Pro',
    subscriptionPro: 'אַבאָנעמענט (Pro)',
    role: 'ראָלע',
    
    // Language names
    english: 'English',
    hebrew: 'עברית',
    yiddish: 'ייִדיש',
    
    // Auth
    welcomeBack: 'ברוך הבא',
    shadchanLogin: 'שדכן אַרייַן',
    singleLogin: 'איינציק אַרייַן',
    parentLogin: 'עלטער אַרייַן',
    signInToAccount: 'אַרייַן צו דיין {role} חשבון.',
    signInToManage: 'אַרייַן צו פירן פּראָפילן, רעקאָמענדאַציעס און Resunize שידוכים.',
    email: 'בליצפּאָסט',
    password: 'פּאַראָל',
    enterEmail: 'אַרייַן דיין בליצפּאָסט',
    enterPassword: 'אַרייַן דיין פּאַראָל',
    forgotPassword: 'פֿאַרגעסן פּאַראָל?',
    dontHaveAccount: 'האָסט נישט קיין חשבון?',
    alreadyHaveAccount: 'האָסט שוין אַ חשבון?',
    createAccount: 'שאַפֿן חשבון',
    chooseAccountType: 'קלייב וואָס טיפּ חשבון דו ביסט {action}.',
    loggingInto: 'אַרייַן צו',
    creating: 'שאַפֿן',
    areYouShadchan: 'ביסטו אַ שדכן?',
    firstName: 'ערשט נאָמען',
    lastName: 'משפּחה נאָמען',
    phone: 'טעלעפֿאָן',
    confirmPassword: 'באַשטעטיקן פּאַראָל',
    enterFirstName: 'אַרייַן דיין ערשט נאָמען',
    enterLastName: 'אַרייַן דיין משפּחה נאָמען',
    enterPhone: 'אַרייַן דיין טעלעפֿאָן נומער',
    enterConfirmPassword: 'באַשטעטיקן דיין פּאַראָל',
    createPassword: 'שאַפֿן אַ פּאַראָל',
    confirmYourPassword: 'באַשטעטיקן דיין פּאַראָל',
    createYourAccount: 'שאַפֿן דיין חשבון',
    createAccountInMinute: 'שאַפֿן אַ {role} חשבון אין אונטער אַ מינוט.',
    chooseRoleCompleteRegistration: 'קלייב דיין ראָלע, דעמאָלט פאַרענדיקן דיין זיכער רעגיסטראַציע.',
    selectRole: 'קלייב דיין ראָלע',
    shadchan: 'שדכן',
    single: 'איינציק',
    parent: 'עלטער',
    
    // Validation messages
    invalidEmail: 'אומגילטיקע בליצפּאָסט אַדרעס',
    emailRequired: 'בליצפּאָסט איז פארלאנגט',
    passwordRequired: 'פּאַראָל איז פארלאנגט',
    passwordMinLength: 'פּאַראָל מוז זיין מינדסטענס 8 אותיות',
    passwordComplexity: 'פּאַראָל מוז אנטהאלטן מינדסטענס איין אות און איין נומער',
    passwordsMustMatch: 'פּאַראָלען מוזן זיין גלייַך',
    confirmPasswordRequired: 'ביטע באַשטעטיקן דיין פּאַראָל',
    firstNameRequired: 'ערשט נאָמען איז פארלאנגט',
    firstNameMaxLength: 'ערשט נאָמען מוז זיין ווייניגער ווי 100 אותיות',
    lastNameRequired: 'משפּחה נאָמען איז פארלאנגט',
    lastNameMaxLength: 'משפּחה נאָמען מוז זיין ווייניגער ווי 100 אותיות',
    invalidPhone: 'ביטע אַרייַן אַ גילטיק טעלעפֿאָן נומער',
    roleRequired: 'ביטע קלייב אַ ראָלע',
    invalidRole: 'ביטע קלייב אַ גילטיק ראָלע',
    
    // Common
    submit: 'איבערגעבן',
    cancel: 'אַנולירן',
    save: 'היט',
    delete: 'מעקן',
    edit: 'רעדאַקטירן',
    close: 'שליסן',
    ok: 'גוט',
    loading: 'לאָודינג...',
    error: 'גרײַז',
    success: 'הצלחה',
    back: 'צוריק',
    next: 'ווייַטער',
    previous: 'פֿריִערדיקע',
    search: 'זוכן',
    filter: 'פֿילטער',
    actions: 'אַקציעס',
    appDownloadPromoWelcomeTitle: 'ברוך־הבא צו רעזוניז',
    appDownloadPromoWelcomeSubtitle:
      'לאָדט אַראָפּ די מאָביל־אַפּ פֿאַר אייפאָן אָדער אַנדרויד — בלייבט אָרגאַניזירט אונטערוועגס.',
    appDownloadPromoRandomTitle: 'נעמט רעזוניז מיט',
    appDownloadPromoRandomSubtitle: 'באַקומט די רעזוניז־אַפּ אין די App Store אָדער Google Play.',
    downloadOnAppStore: 'אַראָפּלאָדן אין די App Store',
    getItOnGooglePlay: 'אַראָפּלאָדן אין Google Play',
    appStoreBadgeKicker: 'אַראָפּלאָדן אויף',
    appStoreBadgeTitle: 'App Store',
    googlePlayBadgeKicker: 'פֿאַרבײַ',
    googlePlayBadgeTitle: 'Google Play',
    landingAppBarTitle: 'נעמט די רעזוניז־אַפּ',
    landingAppBarSubtitle: 'נייטיווע אַפּס פֿאַר אייפאָן און אַנדרויד — שנעלער, מיט פּוש־נאָטיפֿיקאַציעס.',
    landingAppBarNotNow: 'נישט יעצט',
    
    // Dashboard
    dashboard: 'דאַשבאָרד',
    myAccount: 'מײַן חשבון',
    everythingInOnePlace: 'אַלץ אין איין אָרט: דיין רעזומע, רעקאָמענדאַציעס און שדכן פֿאָרשלאַגן.',
    myResumes: 'מײַן רעזומע', // Singular in Yiddish
    myDigitalResumes: 'מײַנע דיגיטאַלע רעזומע',
    createResumeHere: 'שאַפֿן אַ רעזומע דאָ: פֿאַרוואַלטן, טיילן, און רעדאַקטירן.',
    createMyResume: 'שאַפֿן מיין רעזומע',
    editResume: 'רעדאַקטירן רעזומע',
    fillInYourDetails: 'פֿילט אויס אייערע פרטים אונטן.',
    makePublicToShadchanim: 'מאַכן דעם רעזומע עפנטלעך פֿאַר אַלע שדכנים',
    addResume: 'לייג רעזומע',
    suggestions: 'פֿאָרשלאַגן',
    spotlight: 'שפּאָטליכט',
    spotlightList: 'שפּאָטליכט רשימה',
    notForNow: 'נישט פֿאַר איצט',
    profile: 'פּראָפיל',
    messages: 'אָנזאָגן',
    newResume: 'נײַע רעזומע',
    yourResumes: 'דײַנע רעזומע',
    noResumesYet: 'נאָך קיין רעזומע.',
    selectResumeToEdit: 'קלייב אַ רעזומע צו רעדאַקטירן.',
    public: 'ציבור',
    private: 'פּריוואַט',
    resume: 'רעזומע',
    
    // Subscription
    subscription: 'אַבאָנעמענט',
    subscriptionManagement: 'אַבאָנעמענט פירערן',
    freePlan: 'פריי פּלאַן',
    proPlan: 'Pro פּלאַן',
    proPlanActive: 'Pro פּלאַן אַקטיוו',
    proSubscriptionActive: 'Pro אַבאָנעמענט אַקטיוו',
    unlimitedPlan: 'אומבאַגרענעצט פּלאַן',
    unlimitedSubscriptionActive: 'אומבאַגרענעצט פּלאַן אַקטיוו',
    unlimitedPlanResumes: 'אומבאַגרענעצטע רעזומע און צוטריט צו אַלע Pro פֿעיִקייטן.',
    proPlanResumes: 'ביז 50 רעזומעס און צוטריט צו אַלע Pro פֿעיִקייטן.',
    unlimitedResumes: 'אומבאַגרענעצטע רעזומע און צוטריט צו אַלע Pro פֿעיִקייטן.',
    currentPeriodEnds: 'קראַנט צייט ענדס',
    cancelSubscription: 'אַנולירן אַבאָנעמענט',
    cancelScheduledMessage: 'דער אַבאָנעמענט וועט ווערן אַנולירט אין סוף דער באַצאָלונג צייט',
    subscribeToPro: 'אַבאָנירן צו Pro',
    subscribeToUnlimited: 'אַבאָנירן צו אומבאַגרענעצט',
    upgradeToUnlimited: 'אַרויפֿגרײַדן צו אומבאַגרענעצט',
    securePayment: 'זיכער צאָלונג דורך Stripe',
    subscriptionActivated: 'אַבאָנעמענט אַקטיווירט!',
    thankYouForUpgrading: 'אַ דאַנק פֿאַר אַרויפֿגרײַדן. איצט האָסטו צוטריט צו די נייע פּלאַן פֿעיִקייטן.',
    thankYouForUpgradingPro: 'אַ דאַנק פֿאַר אַרויפֿגרײַדן צו Pro. איצט האָסטו ביז 50 רעזומעס און צוטריט צו אַלע Pro פֿעיִקייטן.',
    thankYouForUpgradingUnlimited: 'אַ דאַנק פֿאַר אַרויפֿגרײַדן צו אומבאַגרענעצט. איצט האָסטו אומבאַגרענעצטע רעזומע און צוטריט צו אַלע Pro פֿעיִקייטן.',
    viewSubscription: 'קוק אַבאָנעמענט',
    goToDashboard: 'גיין צו דאַשבאָרד',
    pricingTitle: 'פּשוטע, קלאָרע פּרייזן',
    pricingSubtitle: 'הייבט אָן אומזיסט, און אַרויפֿגרײַדן ווען איר דאַרפֿט מער רעזומע פּלאַץ.',
    pricingPerMonth: '/חודש',
    pricingMostPopular: 'מערסט פאָפּולער',
    pricingCurrentPlan: 'קראַנט פּלאַן',
    pricingFreeTitle: 'פריי',
    pricingProTitle: 'Pro',
    pricingUnlimitedTitle: 'אומבאַגרענעצט',
    pricingFreeCta: 'הייבט אָן אומזיסט',
    pricingFreeFeature1: 'ביז 10 רעזומעס',
    pricingFreeFeature2: 'אָרגאַניזירן הצעות און נאָטיצן',
    pricingFreeFeature3: 'זיכערע אויפֿבוואַהרונג',
    pricingProFeature1: 'ביז 50 רעזומעס',
    pricingProFeature2: 'טיילן רעזומעס מיט אימייל',
    pricingProFeature3: 'פּריאָריטעט שטיצע',
    pricingUnlimitedFeature1: 'אומבאַגרענעצטע רעזומעס',
    pricingUnlimitedFeature2: 'אַלע Pro פֿעיִקייטן אַריינגערעכנט',
    pricingUnlimitedFeature3: 'בעסט פֿאַר גרויסע משפחות',
    resumeUsageMessage: 'דו האָסט געניצט {current} פון {limit} רעזומעס אויף דײַן קראַנט פּלאַן.',
    
    // Resume
    resumeLimitReached: 'רעזומע שיעור דערגרייכט!',
    resumeLimitMessage: 'דו האָסט געניצט {current} פון {limit} רעזומעס אויף דעם פריי פּלאַן. אַרויפֿגרײַדן צו Pro אָדער אומבאַגרענעצט פֿאַר מער.',
    createResume: 'שאַפֿן רעזומע',
    editResume: 'רעדאַקטירן רעזומע',
    deleteResume: 'מעקן רעזומע',
    resumeCreated: 'רעזומע געשאַפֿן',
    resumeUpdated: 'רעזומע דערהייַנטיקט',
    resumeDeleted: 'רעזומע געמעקט',
    addResumeFromOutside: 'לייג שידוך רעזומע פֿאָרשלאָג',
    createDigitalResume: 'אַרויפֿלאָדן שידוך פֿאָרשלאָג און האַלטן שפּור פֿון פּראָגרעס.',
    resumeUploadedReadOnly: 'די רעזומע איז אַרויפֿגעלאָדן און איז איצט נאָר לייענען. דו קענסט נאָך לייגן נאָטיצן אונטער יעדער רעקאָמענדאַציע.',
    pdfResume: 'PDF רעזומע',
    firstName: 'ערשט נאָמען',
    lastName: 'משפּחה נאָמען',
    birthday: 'געבוירן טאָג',
    height: 'הייך (אינטשעס)',
    feet: 'פֿיס',
    inches: 'אינטשעס',
    address: 'אַדרעס',
    enterAddress: 'אַרייַן אַדרעס',
    city: 'שטאָט',
    state: 'שטאַט',
    fathersName: 'פֿאָטער נאָמען',
    fathersOccupation: 'פֿאָטער באַרוף',
    mothersName: 'מוטער נאָמען',
    mothersOccupation: 'מוטער באַרוף',
    motherMaidenName: 'מוטער מיידן נאָמען',
    paternalGrandparents: 'פֿאָטער זיידע-באָבע',
    maternalGrandparents: 'מוטער זיידע-באָבע',
    grandfather: 'זיידע',
    grandmother: 'באָבע',
    shulsAttended: 'שולן וואָס איז באַטייליקט',
    shulName: 'שול נאָמען',
    rabbiName: 'רב נאָמען',
    saved: 'געהיט',
    deleteThisResume: 'מעקן די רעזומע{name}? דאָס וועט אַראָפּנעמען זײַנע רעקאָמענדאַציעס, PDFs, שיירס און פֿאָרשלאַגן.',
    resumeSavedToSuggestions: 'רעזומע געהיט צו פֿאָרשלאַגן',
    failedToSaveToSuggestions: 'נישט געלונגען צו היטן צו פֿאָרשלאַגן',
    failedToLoadResumes: 'נישט געלונגען צו לאָדן דיגיטאַלע רעזומע',
    failedToCreateResume: 'נישט געלונגען צו שאַפֿן רעזומע',
    failedToSave: 'נישט געלונגען צו היטן',
    failedToDeleteResume: 'נישט געלונגען צו מעקן רעזומע',
    
    // Toast messages
    loginSuccessful: 'אַרייַן הצליח!',
    registrationSuccessful: 'רעגיסטראַציע הצליח!',
    logoutSuccessful: 'אַרויסגעגאַנגען הצלחה',
    loginFailed: 'אַרייַן נישט געלונגען',
    registrationFailed: 'רעגיסטראַציע נישט געלונגען',
    
    // Additional common strings
    shareResume: 'טיילן רעזומע',
    shareResumeTitle: 'טיילן רעזומע',
    uploadPdf: 'אַרויפֿלאָדן PDF',
    uploading: 'אַרויפֿלאָדן…',
    uploadPdfFirst: 'אַרויפֿלאָדן PDF ערשט צו אַוטאָ-פֿילן די פֿאָרם, דעמאָלט קאָנווערט עס.',
    profilePicture: 'פּראָפֿיל בילד',
    uploadProfilePicture: 'אַרויפֿלאָדן פּראָפֿיל בילד',
    uploadProfilePictureDescription: 'אַרויפֿלאָדן אַ פּראָפֿיל בילד צו פּערסאָנאַליזירן דיין רעזומע. איר קענט אויסקלייַבן צי צו טיילן עס ווען די רעזומע איז געטיילט.',
    shareProfilePictureWhenResumeShared: 'טיילן פּראָפֿיל בילד ווען רעזומע איז געטיילט',
    profilePictureUploaded: 'פּראָפֿיל בילד אַרויפֿגעלאָדן הצלחה',
    profilePictureDeleted: 'פּראָפֿיל בילד אויסגעמעקט הצלחה',
    profilePictureNowShareable: 'פּראָפֿיל בילד וועט זיין געטיילט ווען רעזומע איז געטיילט',
    profilePictureNotShareable: 'פּראָפֿיל בילד וועט נישט זיין געטיילט ווען רעזומע איז געטיילט',
    deleteProfilePictureConfirm: 'זענט איר זיכער איר ווילט אומעקן דעם פּראָפֿיל בילד?',
    failedToUploadProfilePicture: 'נישט געראטן אַרויפֿלאָדן פּראָפֿיל בילד',
    failedToDeleteProfilePicture: 'נישט געראטן אומעקן פּראָפֿיל בילד',
    failedToLoadProfilePicture: 'נישט געראטן לאָדן פּראָפֿיל בילד',
    failedToUpdateShareable: 'נישט געראטן דערהייַנטיקן טיילן סעטטינג',
    invalidImageFormat: 'אומגילטיק בילד פֿאָרמאַט. ביטע אַרויפֿלאָדן JPG, PNG, GIF, אָדער WebP.',
    imageTooLarge: 'בילד איז צו גרויס. מאַקסימום גרייס איז 5MB.',
    noProfilePicture: 'קיין פּראָפֿיל בילד נישט אַרויפֿגעלאָדן',
    uploadProfilePictureToGetStarted: 'אַרויפֿלאָדן אַ פּראָפֿיל בילד צו אָנהייבן',
    replace: 'ערזעצן',
    profilePictureIsShareable: 'דעם פּראָפֿיל בילד איז טיילבאַר מיט שדכנים ווען די רעזומע איז געטיילט.',
    saving: 'היט…',
    saveResume: 'היט רעזומע',
    saveToSpotlight: 'היט צו שפּאָטליכט',
    saveToSuggestions: 'היט צו פֿאָרשלאַגן',
    discardChanges: 'אַוועקוואַרפֿן ענדערונגען',
    discarding: 'אַוועקוואַרפֿנדיק…',
    discardResumeDraftConfirm:
      'אַוועקוואַרפֿן די טיוטע? די אַרויפֿגעלאָדענע רעזומע וועט ווערן אַראָפּגענומען ביז איר וועט ווידער אַרויפֿלאָדן.',
    saveResumeBeforeLeavingTabs:
      'היט די רעזומע צו שפּאָטליכט אָדער פֿאָרשלאַגן איידער איר גייט צו אַן אַנדער טאַב, אָדער אַוועקוואַרפֿט די ענדערונגען.',
    changesDiscarded: 'ענדערונגען אַוועקגעוואָרפֿן',
    resumeSavedToSpotlight: 'רעזומע געהיט צו שפּאָטליכט',
    failedToSaveToSpotlight: 'נישט געלונגען צו היטן צו שפּאָטליכט',
    uploadFailed: 'אַרויפֿלאָדן נישט געלונגען',
    failedToOpenPdf: 'נישט געלונגען צו עפֿענען PDF',
    failedToLoadPdf: 'נישט געלונגען צו לאָדן PDF',
    formAutoFilledFromPdf: 'פֿאָרם אַוטאָ-געפֿילט פֿון PDF',
    pleaseReviewYourInformation: 'ביטע איבערקוק דיין אינפֿאָרמאַציע',
    reviewAutofillMessage: 'דיין פרטים זענען אויטאָמאַטיש עקסטראַקטירט פֿון די PDF. ביטע איבערקוק אַז אַלע פעלדער זענען ריכטיק איידער פֿארזעצן.',
    noPdfsYet: 'נאָך נישט אַרויפֿגעלאָדן PDF טעקעס',
    uploadPdfResumeToGetStarted: 'אַרויפֿלאָדן רעזומע אין PDF צו אָנהייבן',
    noPdfsAvailableForViewing: 'קיין PDF טעקעס נישט פאַראַנען פֿאַר קוקן',
    rabbiPhone: 'רב טעלעפֿאָן',
    siblingName: 'געשוויסטער נאָמען',
    schoolNumber: 'שול #{number}',
    mechutanNumber: 'מחותן #{number}',
    shulNumber: 'שול #{number}',
    noShulsAddedYet: 'נאָך קיין שולן צוגעלייגט.',
    noSchoolsAddedYet: 'נאָך קיין שולן צוגעלייגט.',
    noMechutanimAddedYet: 'נאָך קיין מחתנים צוגעלייגט.',
    noSiblingsAddedYet: 'נאָך קיין געשוויסטער צוגעלייגט.',
    viewProfile: 'קוק פּראָפיל',
    shareForMatch: 'טיילן פֿאַר שידוך',
    togglePublicVisibility: 'טאָגאַל ציבור נראות',
    makePrivate: 'מאַכן פּריוואַט',
    makePublic: 'מאַכן ציבור',
    birthdayLabel: 'געבוירן טאָג',
    heightLabel: 'הייך',
    synagogue: 'שול',
    searchSingles: 'זוכן איינציקע + געטיילטע רעזומע…',
    searchPublicSingles: 'זוכן ציבור איינציקע…',
    searchShidduchim: 'זוכן פֿאָרשלאַגן…',
    searchShadchanim: 'זוכן שדכנים…',
    refresh: 'דערפרישן',
    writeReferenceNote: 'שרייב וואָס די רעקאָמענדאַציע האָט דיר געזאָגט… (נאָר דו קענסט דאָס זען)',
    phonePlaceholder: 'ציפֿרן בלויז (אָדער +)',
    shadchanEmailPlaceholder: 'shadchan@email.com',
    thankYouForHelp: 'אַ דאַנק פֿאַר דיין הילף...',
    provideDetails: 'ביטע גיב ווי פֿיל פרטים ווי מעגלעך כדי מיר קענען דיר העלפֿן בעסער...',
    willGenerateEmail: 'וועט שאַפֿן צייטווייליק בליצפּאָסט אויב נישט צוגעשטעלט',
    enterExistingEmail: 'אַרייַן די בליצפּאָסט פֿון דער עקזיסטירנדיקער איינציק חשבון',
    addChild: 'צולייגן קינד',
    removeChild: 'אַראָפּנעמען קינד',
    childCreated: 'קינד איז באַשאַפֿן מיט הצלחה',
    childLinked: 'קינד איז פֿאַרבונדן מיט הצלחה',
    failedToCreateChild: 'נישט געלונגען צו באַשאַפֿן קינד',
    failedToLinkChild: 'נישט געלונגען צו פֿאַרבינדן קינד',
    failedToLoadChildren: 'נישט געלונגען צו לאָדן קינדער',
    childRemoved: 'קינד איז אַראָפּגענומען',
    removeChildConfirm: 'ביסט זיכער אַז דו ווילסט אַראָפּנעמען דעם קינד? דאָס וועט אויפֿהערן דעם קישור פֿון דיין חשבון אָבער וועט נישט אויסמעקן זיין חשבון.',
    createChild: 'באַשאַפֿן קינד',
    linkChild: 'פֿאַרבינדן קינד',
    createNewChild: 'באַשאַפֿן נייַ חשבון',
    linkExistingChild: 'פֿאַרבינדן עקזיסטירנדיק חשבון',
    childsEmail: 'קינדס בליצפּאָסט',
    childMustHaveAccount: 'דער קינד דאַרף האָבן אַן עקזיסטירנדיק חשבון מיט ראָלע "איינציק"',
    linking: 'פֿאַרבינדן…',
    yourChildren: 'מיינע קינדער',
    manageChildrenAccounts: 'פיר דיינע קינדערס חשבונות און פּראָפילן',
    noChildrenYet: 'נאָך נישט צוגעלייגט קיין קינדער.',
    addYourFirstChild: 'לייג צו דיין ערשטן קינד',
    manageChildAccount: 'פיר {name}ס חשבון',
    backToChildrenList: 'צוריק צו קינדער ליסטע',
    childsAccount: '{name}ס חשבון',
    manageChildResume: 'פיר {name}ס רעזומע, רעפֿערענצן און שדכן הצעות.',
    parentDashboard: 'עלטערן דאַשבאָרד',
    emailRequiredToLink: 'בליצפּאָסט איז נייטיק צו פֿאַרבינדן',
    failedToRemoveChild: 'נישט געלונגען צו אַראָפּנעמען קינד',
    checkingLink: 'טשעקן...',
    childAlreadyLinked: 'דער קינד איז שוין פֿאַרבונדן',
    passwordRequiredForLinking: 'פּאַסוואָרט איז נייטיק פֿאַר ערשטמאָליק פֿאַרבינדן',
    enterChildPassword: 'אַרייַן קינד חשבון פּאַסוואָרט',
    passwordVerifyPermission: 'פּאַסוואָרט איז נייטיק צו באַשטעטיקן אַז דו האָסט דערלויבעניש צו פֿאַרבינדן דעם חשבון',
    failedToStartCheckout: 'נישט געלונגען צו אָנהייב צאָלונג',
    failedToCancelSubscription: 'נישט געלונגען צו אַנולירן אַבאָנעמענט',
    failedToLoadSubscription: 'נישט געלונגען צו לאָדן אַבאָנעמענט',
    processing: 'פּראָצעסירן...',
    readOnlyShared: 'נאָר לייענען (געטיילט מיט דיר)',
    schoolsYeshivosAttended: 'שולן / ישיבות וואָס איז באַטייליקט',
    mechutanim: 'מחתנים',
    siblings: 'געשוויסטער',
    summerCamp: 'זומער / קעמפּ',
    enterSummerCamp: 'צ.ב. קעמפּ אַגודה, קעמפּ שטערנבערג',
    previouslyMarried: 'פריער חתונה געהאט',
    wasMarriedTo: 'איז געווען חתונה מיט',
    divorced: 'גט',
    widowed: 'אלמן/ה',
    none: 'קיינער',
    enterName: 'אַרײַנגעבן נאָמען',
    selectOption: 'אויסוועלן...',
    personalInformation: 'פּערזענלעכע אינפֿאָרמאַציע',
    familyInformation: 'משפּחה',
    educationAndCommunity: 'חינוך און קהילה',
    career: 'קאַריערע',
    uploadPdfToAutofill: 'אַרויפֿלאָדן אַ PDF צו אויטאָמאַטיש אויספֿילן דיין רעזומע דעטאַלן.',
    noResumeDataAvailable: 'קיין רעזומע דאַטן נישט פאַראַנען.',
    share: 'טיילן',
    sharing: 'טיילן…',
    shareViaResunize: 'טיילן דורך Resunize',
    shareViaEmail: 'טיילן דורך אימעיל',
    searchForShadchanim: 'זוכן שדכנים',
    emailSentFromResunize: 'דער אימעיל וועט געשיקט ווערן דירעקט פון Resunize.',
    recipientEmail: 'אימעיל פון עמפֿענגער',
    enterRecipientEmailPlaceholder: 'אַרײַנגעבן אימעיל אַדרעס פון עמפֿענגער...',
    enterRecipientEmail: 'ביטע אַרײַנגעבן אַן אימעיל פון עמפֿענגער.',
    personalMessage: 'פּערזענלעכע הודעה',
    personalMessagePlaceholder: 'לייג צו אַ פּערזענלעכע הודעה צו שיקן מיט דער רעזומע...',
    resumeBeingShared: 'רעזומע וואָס ווערט געטיילט',
    sendFromResunize: 'שיקן פון Resunize',
    sending: 'שיקן...',
    emailSentSuccessfully: 'אימעיל איז הצלחהדיק געשיקט!',
    failedToSendEmail: 'נישט געלונגען צו שיקן אימעיל.',
    optional: 'אָפּציאָנאַל',
    organizeResumes: 'אָרגאַניזירן רעזומע',
    organizeResumesDesc: 'היט יעדער פֿאָרשלאָג נאָנט אין איין זיכער אָרט. זאָג זייַ גוט צו צעשפּרייטעטע טעקעס און פאַרפאַלן PDFs — אַלץ וואָס דו דאַרפסט איז אין דיין פינגער שפּיץ.',
    manageTheProcess: 'פֿאַרוואַלטונג דער פּראָצעס',
    manageTheProcessDesc: 'לייכט שפּור פּראָגרעס, לייג פּריוואַט נאָטיצן, און בלייבן אויף שפּיץ פון יעדער דעטאַל. מאַכן זיכער באַשלוסן מיט קלאָרקייט און שלום.',
    stayFocused: 'בלייַבן פֿאָקוסירט',
    stayFocusedDesc: 'דעקלוטער די נסיעה און קאָנצענטראַט אויף וואָס טאַקע ענינים. מיט רעזוניזע, דער שידוך פּראָצעס ווערט גלאַטער, פּשוטער און מער מעאַנינגפול.',
    tipShadchan: 'געבן טיפ צו שדכן',
    tipYourShadchan: 'געבן טיפ צו דיין שדכן',
    showAppreciationForShadchan: 'ווייַזן דיין אַפּרישייישאַן פֿאַר דיין שדכן ס הילף אין געפֿינען דיין שידוך.',
    tipShadchanProDescription: 'אַרויפֿגרײַדן צו Pro צו געבן טיפ צו דיין שדכן און ווייַזן דיין אַפּרישייישאַן פֿאַר זייער שווער אַרבעט.',
    upgradeToPro: 'אַרויפֿגרײַדן צו Pro',
    proFeature: 'Pro פֿעיִקייט',
    tipAnyShadchan: 'געבן טיפ צו קיין שדכן אין די דאַטאַבאַסע',
    tipByEmail: 'געבן טיפ צו שדכנים דורך בליצפּאָסט אַדרעס',
    securePaymentProcessing: 'זיכער צאָלונג פּראָצעסירונג דורך Stripe',
    upgradeNow: 'אַרויפֿגרײַדן איצט',
    maybeLater: 'אפֿשר שפּעטער',
    selectFromDatabase: 'קלייב פֿון דאַטאַבאַסע',
    selectShadchanFromList: 'קלייב אַ שדכן פֿון אונדזער רשימה',
    tipShadchanNotInDatabase: 'געבן טיפ צו אַ שדכן וואָס איז נאָך נישט רעגיסטרירט',
    enterEmailAddress: 'אַרייַן בליצפּאָסט אַדרעס',
    shadchanEmailAddress: 'שדכן בליצפּאָסט אַדרעס',
    shadchanWillReceiveEmail: 'דער שדכן וועט באַקומען אַ בליצפּאָסט מיט ינסטראַקשאַנז צו פאָדערן זייער טיפ.',
    sendTip: 'שיקן טיפ',
    pleaseEnterValidAmount: 'ביטע אַרייַן אַ גילטיק סומע',
    proRequiredForTipping: 'Pro אַבאָנעמענט איז פארלאנגט פֿאַר טיפּס',
    tipSentSuccessfully: 'טיפ געשיקט הצלחה!',
    failedToProcessTip: 'נישט געלונגען צו פּראָצעס טיפ',
    amount: 'סומע',
    messageOptional: 'אָנזאָג (אָפּציאָנאַל)',
    thankYouForHelp: 'אַ דאַנק פֿאַר דיין הילף!',
    cardDetails: 'קאָרט דעטאַילס',
    processing: 'פּראָצעסירן...',
    withdrawalManagement: 'מיטלונג פֿאַרוואַלטונג',
    availableBalance: 'פאַראַנען באַלאַנס',
    addWithdrawalMethod: 'לייגן מיטלונג אופֿן',
    requestWithdrawal: 'בעטן מיטלונג',
    selectMethod: 'קלייב אופֿן',
    selectWithdrawalMethod: 'קלייב אַ מיטלונג אופֿן',
    maxAmount: 'מאַקסימום סומע',
    withdrawalMethods: 'מיטלונג מעטהאָדס',
    noWithdrawalMethods: 'נאָך קיין מיטלונג מעטהאָדס צוגעלייגט',
    default: 'דעפֿאָלט',
    withdrawalHistory: 'מיטלונג היסטאָריע',
    noWithdrawals: 'נאָך קיין מיטלונגען',
    date: 'דאַטע',
    method: 'אופֿן',
    status: 'סטאַטוס',
    failedToLoadData: 'נישט געלונגען צו לאָדן דאַטן',
    withdrawalMethodAdded: 'מיטלונג אופֿן צוגעלייגט הצלחה',
    failedToAddMethod: 'נישט געלונגען צו לייגן מיטלונג אופֿן',
    pleaseSelectWithdrawalMethod: 'ביטע קלייב אַ מיטלונג אופֿן',
    insufficientBalance: 'נישט גענוג באַלאַנס',
    withdrawalRequestSubmitted: 'מיטלונג בעטן איבערגעגעבן הצלחה',
    failedToRequestWithdrawal: 'נישט געלונגען צו בעטן מיטלונג',
    methodType: 'אופֿן טיפּ',
    stripeAccountId: 'Stripe חשבון ID',
    stripeAccountIdRequired: 'Stripe חשבון ID איז פארלאנגט',
    stripeAccountIdHelp: 'דיין Stripe Connect חשבון ID (סטאַרץ מיט acct_)',
    paypalEmail: 'PayPal בליצפּאָסט',
    paypalEmailRequired: 'PayPal בליצפּאָסט איז פארלאנגט',
    zelleEmail: 'Zelle בליצפּאָסט',
    zellePhone: 'Zelle טעלעפֿאָן',
    zelleEmailOrPhoneRequired: 'אדער בליצפּאָסט אדער טעלעפֿאָן איז פארלאנגט פֿאַר Zelle',
    cancel: 'אַנולירן',
    add: 'לייגן',
    back: 'צוריק',
    saveResumeOrUploadPdfToAddReferences: 'היט די רעזומע אָדער אַרויפֿלאָדן PDF ערשט צו לייגן רעקאָמענדאַציעס.',
    saveResumeToAddReferences: 'היט רעזומע צו לייגן רעקאָמענדאַציעס',
    resumeCreatedForReferences: 'רעזומע געהיט! איצט קענסטו לייגן רעקאָמענדאַציעס.',
    resumeNeededForProfilePicture: 'א רעזומע מוז זיין באשאפן ערשט איידער אַרויפֿלאָדן א פּראָפיל בילד.',
    resumeCreatedForProfilePicture: 'רעזומע באשאפן. איצט קענסטו אַרויפֿלאָדן א פּראָפיל בילד.',
    referenceAdded: 'רעקאָמענדאַציע צוגעלייגט',
    referenceRemoved: 'רעקאָמענדאַציע אַוועקגענומען',
    failedToAddReference: 'נישט געלונגען צו לייגן רעקאָמענדאַציע',
    failedToRemoveReference: 'נישט געלונגען צו אַוועקנעמען רעקאָמענדאַציע',
    resumeMustBeCreatedFirst: 'רעזומע מוז זיין שאַפֿן ערשט',
    suggestedBy: 'פֿאָרשלאָגן דורך',
    enterSuggestedBy: 'אַרייַן ווער האָט פֿאָרשלאָגן די רעזומע...',
    suggestedByName: 'שדכן נאָמען',
    suggestedByEmail: 'שדכן אימעיל',
    enterShadchanName: 'אַרייַן שדכן נאָמען...',
    enterShadchanEmail: 'אַרייַן שדכן אימעיל...',
    searchShadchanim: 'זוכן שדכנים',
    searchShadchanimPlaceholder: 'זוכן לויט נאָמען אָדער אימעיל...',
    orSearchShadchanim: 'אָדער זוכן פֿון רעגיסטרירטע שדכנים',
    tipPayShadchan: 'טיפּ / באַצאָלן שדכן',
    personalNotes: 'פּערזענלעכע נאָטיצן',
    personalNotesPlaceholder: 'לייג דיינע פּערזענלעכע נאָטיצן וועגן דעם פֿאָרשלאָג...',
    personalNotesDescription: 'די נאָטיצן זענען פּריוואַט און נאָר זיכטיק פֿאַר דיר.',
    unsavedChangesWarning: 'דו האָסט ניט-געראַטעוועטע ענדערונגען. ביסט דו זיכער אַז דו ווילסט אַוועקגיין?',
    saveProgressOrDiscard: 'ראַטעווע פּראָגרעס אָדער פֿאַרוואַרפֿן ענדערונגען?',
    personalNotes: 'מיינע פּערזענלעכע הערות',
    personalNotesDescription: 'די הערות זענען פּריוואַט און נאָר זיכטיק פֿאַר דיר.',
    writePersonalNotes: 'שרייב דיינע פּערזענלעכע הערות וועגן דעם פֿאָרשלאָג...',
    saveNotes: 'ראַטעווע הערות',
    saved: 'געראַטעוועט',
    
    // Pages - About (Yiddish translations)
    aboutTitle: 'וועגן Resunize',
    aboutLead: 'Resunize שטיצט דעם זעלבן באַטרויענדיקן שידוך־פּראָצעס וואָס משפחות און שדכנים ניצן שוין — נאָר מיט בעסערע אָרגאַניזאַציע. עס האַלט רעזומעס, פֿאָרשלאַגן, נאָטיצן און קאָמוניקאַציע אין איין אָרט, אַזוי דער פּראָצעס ווערט קלאָרער, רואִיקער און גרינגער צו פירן.',
    ourMission: 'אונדזער מיסיע',
    ourMissionText: 'מיר גלויבן אַז געפֿינען אייער שידוך זאָל זיך פֿילן באַטײַטנדיק, אָרגאַניזירט און ווייניקער דרוקדיק. Resunize העלפֿט אייך בלייבן אויף שפּיץ פון יעדער דעטאַל בשעת מע האַלט דעם פּראָצעס מכּובד, באַקאַנט און טרו צו דער וועג ווי שידוכים זענען שוין אימער געטאָן געוואָרן.',
    aboutMobileAppsTitle: 'מאָביל אַפּס פֿאַר iPhone און Android',
    aboutMobileAppsText:
      'נעמט Resunize מיט אייך — לאָדט אַראָפּ אונדזערע אַפּס פֿאַר iOS און Android פֿאַר די זעלבע פּלאַטפאָרם־פֿעיִקייטן מיט אַ דערפֿארונג צוגעפּאַסט צום טעלעפֿאָן.',
    whatWeOffer: 'וואָס מיר אָפפֿערן',
    organizeResumesTitle: 'אָרגאַניזירטע שידוך־רעזומעס',
    organizeResumesText: 'סטאָקירט אַלע אייערע נאָרמאַלע שידוך־רעזומעס אין איין זיכער אָרט. לאָדט אַרויף PDFs און גרייט צו גרייטן זיי יעדער צייט ווען איר דאַרפֿט.',
    manageTheProcessTitle: 'פירן פֿאָרשלאַגן און נאָטיצן',
    manageTheProcessText: 'שפּור יעדן פֿאָרשלאָג, לייג פּריוואַט נאָטיצן, און היט וויכטיקע דעטאַילס קלאָר דורך דעם גאַנצן פּראָצעס.',
    stayFocusedTitle: 'קלאָרקייט אָן צו טוישן דעם פּראָצעס',
    stayFocusedText: 'Resunize מאַכט נישט נייִקע שידוכים — זי אָרגאַניזירט נאָר וואָס איר טוט שוין, אַזוי גארנישט גייט פאַרלוירן אָדער פאַרפֿעלט.',
    privacySecurityTitle: 'פּריוואַטקייט און זיכערהייט',
    aboutPrivacySecurityText: 'מיר ניצן פּאַסיקע טעכנישע און אָרגאַניזאַציע־שיץ־מיטלעלן צו העלפֿן באַשיצן אייער אינפֿאָרמאַציע און האַלטן קאָנפֿידענציאַליטעט דורך דער גאַנצער שידוך־נסיעה.',
    whoWeServe: 'וועמען מיר דינען',
    singlesTitle: 'איינציקע',
    singlesText: 'אַרויפֿלאָדן און פירן אייער רעזומע, באַקומען פֿאָרשלאַגן, שפּור פּראָגרעס, און בלייבן אָרגאַניזירט פון אָנהייב ביז סוף.',
    parentsTitle: 'עלטערן',
    parentsText: 'פירן קייפל קינדער־חשבונות פֿון איין דאַשבאָרד און היט אַלע רעזומעס, פֿאָרשלאַגן און נאָטיצן אין איין אָרט.',
    builtWithCare: 'געבויט מיט זאָרג',
    builtWithCareText: 'Resunize איז באַשאַפֿן ספּעציעל פֿאַר די ייִדישע קהילה, מיט טיפֿן כּבֿוד פֿאַר די טראַדיציעס און סענסיטיווקייטן פֿון דער שידוך־וועלט. אונדזער ציל איז צו שטיצן דעם פּראָצעס וואָס איר טראָט שוין און מאַכן די טעגליכע קאָאָרדינאַציע גלאַטער — נישט צו טוישן דעם יסודדיקן צוגאַנג, נאָר צו פֿאַרפּשטערן עס.',
    
    // Pages - Getting Started (Yiddish)
    gettingStartedTitle: 'אָנהייב מיט Resunize',
    forSinglesParents: 'פֿאַר איינציקע און עלטערן',
    createYourAccount: 'שאַפֿן דיין חשבון',
    createYourAccountText: 'רעגיסטרירן ווי אַ איינציק אָדער עלטער צו אָנהייב. עלטערן קענען באַקוועם פירן פּראָפֿילן פֿאַר קייפל קינדער פֿון איין דאַשבאָרד.',
    createYourDigitalResume: 'שאַפֿן דיין רעזומע',
    createYourDigitalResumeText: 'בויען דיין פולע רעזומע מיט אַלע דיינע אינפֿאָרמאַציע, רעקאָמענדאַציעס, שולן און מער. מען קען אויך אַרויפֿלאָדן אַ PDF כּדי אַוטאָ־פֿילן די אינפֿאָרמאַציע.',
    uploadYourResume: 'אַרויפֿלאָדן דיין רעזומע',
    uploadYourResumeText: 'לייג דיין רעזומע צו דיין דאַשבאָרד אַזוי עס איז שטענדיק גרייט צו טיילן ווען נויטיג.',
    shareYourResume: 'טיילן דיין רעזומע',
    shareYourResumeText: 'שיקט אייער רעזומע צו שדכנים און פֿרײַנד מיט בליצפּאָסט מיט גרינגקייט.',
    receiveSuggestions: 'באַקומען פֿאָרשלאַגן',
    receiveSuggestionsText: 'שדכנים וועלן שיקן איר פֿאָרשלאַגן. איבערקוקן זיי אין דיין פֿאָרשלאַגן טאַב, באוועגן פּראָמיסינג אָנעס צו שפּאָטליכט און אַרקיווירן יענע נישט פֿאַר איצט.',
    addPrivateNotes: 'לייגן פּריוואַט נאָטיצן',
    addPrivateNotesText: 'היט שפּור פון דיין געדאַנקען, פאָרשונג און פֿידבאַק דורך לייגן פּריוואַט נאָטיצן צו יעדער פֿאָרשלאָג וואָס איר באַקומט.',
    forShadchanim: 'פֿאַר שדכנים',
    registerAsShadchan: 'רעגיסטרירן ווי אַ שדכן',
    registerAsShadchanText: 'שאַפֿן דיין שדכן חשבון צו אָנהייב איבערקוקן רעזומעס און פירן פֿאָרשלאַגן.',
    browseAvailableSingles: 'בראָוז פאַראַנען איינציקע',
    browseAvailableSinglesText: 'קוק ציבור רעזומע און רעזומע וואָס זענען געטיילט מיט איר. זוכן און פֿילטער צו געפֿינען די ריכטיקע שידוכים.',
    createYourQuestionnaire: 'שאַפֿן דיין אַנקעטע',
    createYourQuestionnaireText: 'בויען אייער פּערזענלעכן אַנקעטע פֿאַר יינגלעך און מיידלעך כּדי בעסער צו פֿאַרשטיין וועלכע סארט שידוכים צו רעקאָמענדירן.',
    createMatches: 'שאַפֿן שידוכים',
    createMatchesText: 'פֿאָרשלאָגן שידוכים און שיקן רעזומעס צו איינציקע און עלטערן דורך Resunize אָדער גלייך דורך בליצפּאָסט.',
    sendSuggestions: 'שיקן פֿאָרשלאַגן',
    sendSuggestionsText: 'שיק רעזומע־פֿאָרשלאָגן צו איינציקע אָדער עלטערן דורך Resunize אָדער גלייך דורך בליצפּאָסט. ווער עס ניצט Resunize קען עס איבערקוקן אין זייער דאַשבאָרד.',
    trackProgress: 'שפּור פּראָגרעס',
    trackProgressText: 'מאָניטאָר די סטאַטוס פון אַלע דיין פֿאָרשלאַגן און שידוכים אין איין אָרגאַניזירט דאַשבאָרד.',
    tipsForSuccess: 'טיפּס פֿאַר הצלחה',
    tip1: 'היט דיין רעזומע אַרויף-צו-דאַטע מיט אַקיאַראַט און אַקטועלער אינפֿאָרמאַציע',
    tip2: 'ניצן די שפּאָטליכט שטריך צו אונטערשטרייכן פּראָמיסינג פֿאָרשלאַגן',
    tip3: 'לייגן פּריוואַט נאָטיצן צו געדענקען וויכטיק דעטאַילס',
    tip4: 'קאָמוניקירן מיט שדכנים מיט דער אײַנגעבויטער אָנזאָג־שטריך',
    tip5: 'קאָמוניקירן מיט שדכנים דורך די אָנזאָג שטריך',
    getStartedNow: 'אָנהייב איצט',
    alreadyHaveAccountQuestion: 'האָסט שוין אַ חשבון?',
    
    // Pages - FAQ (Yiddish) - Complete translations
    faqTitle: 'אָפט געפֿרעגטע פֿראַגן',
    faqLead: 'געפֿינען ענטפֿערס צו פּראָסט פֿראַגן וועגן ניצן Resunize. אויב איר געפֿינען נישט וואָס איר זוכט, ביטע',
    contactSupportLink: 'קאָנטאַקט שטיצן',
    faqCategoryGettingStarted: 'אָנהייב',
    faqCategoryDigitalResumes: 'מײַן רעזומע',
    faqCategorySuggestionsSpotlight: 'פֿאָרשלאַגן און שפּאָטליכט',
    faqCategoryPrivacySecurity: 'פּריוואַטקייט און זיכערהייט',
    faqCategoryTechnical: 'טעכניש',
    faqQ1: 'ווי שאַפֿן איך אַ חשבון?',
    faqA1: 'קליק אויף "רעגיסטרירן" אין דער מעניו און קלייב צי איר זענט אַ איינציק, עלטער אָדער שדכן. פֿילן אויס די רעגיסטראַציע פֿאָרם מיט דיין אינפֿאָרמאַציע און איר וועט זיין גרייט צו אָנהייב ניצן Resunize.',
    faqQ2: 'קענען עלטערן פירן קייפל קינדער?',
    faqA2: 'יאָ! עלטערן קענען לייגן קייפל קינדער צו זייער חשבון. יעדער קינד באַקומט זייער אייגענעם דאַשבאָרד מיט זייער אייגענע רעזומע, פֿאָרשלאַגן און שפּאָטליכט רשימה. איר קענט יבערשיידן צווישן קינדער לייכט פון אייער עלטער דאַשבאָרד.',
    faqQ3: 'וואָס אינפֿאָרמאַציע דאַרף איך צו שאַפֿן מײַן רעזומע?',
    faqA3: 'איר דאַרפֿט נאָר אַ PDF פון אייער רעזומע און דעם נאָמען וואָס זאָל ווערן געוויזן אויף דעם פּראָפֿיל.',
    faqQ4: 'ווי טיילן איך מײַן רעזומע מיט אַ שדכן?',
    faqA4: 'עפֿנט "מײַן רעזומע" און קלייב "טיילן". איר קענט געבן צוטריט צו ספּעציפישע שדכנים אויף דער פּלאַטפאָרמע אָדער שיקן דאָס רעזומע דורך בליצפּאָסט.',
    faqQ5: 'קען איך רעדאַקטירן מײַן רעזומע נאָך שאַפֿן?',
    faqA5: 'יאָ, איר קענט רעדאַקטירן אייער רעזומע אין קיין צייט. נאָר איר (דער באַזיצער) קענט רעדאַקטירן אייער רעזומע. ווען געטיילט מיט אנדערע, זיי זען עס אין לייענען-בלויז מאָדע.',
    faqQ6: 'וואָס כאַפּנס ווען איך אַרויפֿלאָדן אַ PDF רעזומע?',
    faqA6: 'די טעקע ווערט געהיט אין אונדזער זיכערן, וואָלקן־באזירטן סיסטעם, אַזוי אַז איר קענט צוגרייפֿן זי יעדער צייט ווען איר דאַרפֿט.',
    faqQ7: 'קען איך לייגן רעקאָמענדאַציעס מאַנואַלי?',
    faqA7: 'יאָ! איר קענט לייגן רעקאָמענדאַציעס מאַנואַלי מיט זייער נאָמען, שייכות, טעלעפֿאָן נומער, בליצפּאָסט און קיין נאָטיצן. רעקאָמענדאַציעס זענען וויכטיק פֿאַר שדכנים צו מאַכן אינפֿאָרמעד פֿאָרשלאַגן.',
    faqQ8: 'וואָס איז די שפּאָטליכט רשימה?',
    faqA8: 'די שפּאָטליכט רשימה איז פֿאַר פֿאָרשלאַגן וואָס זענען "הייס אויף דער טיש" - שידוכים וואָס איר זענט אַקטיוו באַטראַכטן. איר קענט באוועגן פֿאָרשלאַגן פון אייער רעגולער פֿאָרשלאַגן טאַב צו שפּאָטליכט צו פּריאָריטיזירן זיי.',
    faqQ9: 'וואָס מיינט "נישט פֿאַר איצט"?',
    faqA9: 'די "נישט פֿאַר איצט" טאַב איז פֿאַר שידוכים וואָס איר האָט איבערגעקוקט אָבער זענט נישט אינטערעסירט אין דער צייט. איר קענט צוריקשטעלן זיי צו פֿאָרשלאַגן אָדער שפּאָטליכט שפּעטער אויב איר ענדערן אייער מיינונג.',
    faqQ10: 'קען איך לייגן נאָטיצן צו פֿאָרשלאַגן?',
    faqA10: 'יאָ. ווען איר עפֿנט אַ פֿאָרשלאָג, קענט איר לייגן פּריוואַטע נאָטיצן. נאָר איר זעט זיי; זיי העלפֿן היטן וואָס איר האָט געלערנט.',
    faqQ11: 'ווי ווייס איך ווען איך באַקומען אַ נייַ פֿאָרשלאָג?',
    faqA11: 'איר וועט זען נייַע פֿאָרשלאַגן דערשייַנען אין אייער פֿאָרשלאַגן טאַב. די פּלאַטפאָרמע וועט נאָטיפיצירן איר ווען אַ שדכן שיקט איר אַ פֿאָרשלאָג.',
    faqQ12: 'ווי געפֿינען איך איינציקע צו פֿאָרשלאָגן?',
    faqA12: 'אין אייער דאַשבאָרד, איר קענט בראָוז ציבור רעזומע און רעזומע וואָס זענען געטיילט מיט איר. ניצן די זוכן און פֿילטער פֿעיִקייטן צו געפֿינען די ריכטיקע שידוכים.',
    faqQ14: 'קען איך שפּור די סטאַטוס פון מײַנע פֿאָרשלאַגן?',
    faqA14: 'יאָ! אין אייער דאַשבאָרד, איר קענט זען אַלע פֿאָרשלאַגן וואָס איר האָט געשיקט און זייער קראַנט סטאַטוס. איר קענט אויך זען וואָס פֿאָרשלאַגן זענען באוועגט צו שפּאָטליכט אָדער אַרקיווירט.',
    faqQ16: 'ווער קען זען מײַן אינפֿאָרמאַציע?',
    faqA16: 'אייער אינפֿאָרמאַציע איז זיכער און געשיצט. זי ווערט אויפֿגעהיטן אויף אַן ענקריפּטירטע קלאַוד־סערווער און ווערט קיינמאָל נישט געמאכט עפֿנטלעך.',
    faqQ17: 'איז מײַן אינפֿאָרמאַציע זיכער?',
    faqA17: 'יאָ, מיר ניצן אינדוסטריע-נאָרמאַל זיכערהייט מעזשערז כולל ענקריפּטיד קאָנעקשאַנז, זיכער פּאַראָל סטאָרידזש, און ראָלע-באזירט צוטריט קאָנטראָל. אייער אינפֿאָרמאַציע איז געשיצט און נאָר אַקסעסאַבאַל צו אָטאָרייזד ניצערס.',
    faqQ18: 'קען איך מעקן מײַן חשבון?',
    faqA18: 'יאָ, איר קענט קאָנטאַקט שטיצן צו בעטן חשבון דילישאַן. מיר וועלן אַראָפּנעמען אַלע אייער דאַטן אין איבערענסטימונג מיט אונדזער פּריוואַטקייט פּאָליטיק.',
    faqQ19: 'וואָס בראַוזערס זענען סאַפּאָרטיד?',
    faqA19: 'Resunize אַרבעט בעסט אויף מאָדערן בראַוזערס כולל Chrome, Firefox, Safari און Edge. מאַכן זיכער איר ניצן אַ דערהייַנטיקט ווערסיע פֿאַר די בעסטע דערפאַרונג.',
    faqQ20: 'קען איך ניצן Resunize אויף מאָביל?',
    faqA20: 'יאָ. Resunize איז רעספּאָנסיוו און גוט אויף סמאַרטפאָנען און טאַבלעטן, מיט צוטריט צו די זעלבע פֿעיִקייטן ווי אויף דעסקטאָפּ. נאַטיוו Android און iOS אַפּס זענען אין אַנטוויקלונג.',
    faqQ21: 'וואָס אויב איך פֿאַרגעסן מײַן פּאַראָל?',
    faqA21: 'קליק "פֿאַרגעסן אייער פּאַראָל?" אויף דער אַרייַן בלאַט. אַרייַן אייער בליצפּאָסט און איר וועט באַקומען אַ פּאַראָל ריסעט לינק. פאָלגן די ינסטראַקשאַנז צו שאַפֿן אַ נייַ פּאַראָל.',
    faqQ22: 'פאַרוואָס בין איך אַוטאָמאַטיש אַרויסגעגאַנגען?',
    faqA22: 'פֿאַר זיכערהייט, איר וועט זיין אַוטאָמאַטיש אַרויסגעגאַנגען נאָך 5 מינוט פון ינאַקטיוויטי אָדער ווען איר נאַוויגירן צו די היים בלאַט. פשוט אַרייַן ווידער צו פאָרזעצן.',
    stillHaveQuestions: 'נאָך האָבן פֿראַגן?',
    stillHaveQuestionsText: 'קענען נישט געפֿינען די ענטפֿער איר זוכט? אונדזער שטיצן טים איז דאָ צו העלפֿן.',
    contactUs: 'קאָנטאַקט אונדז',
    stillHaveQuestionsText2: 'און מיר וועלן צוריקקומען צו איר ווי באַלד ווי מעגלעך.',
    
    // Pages - Terms (Yiddish) - Complete translations
    termsTitle: 'ניצונג טערמינען',
    lastUpdated: 'לעצט דערהייַנטיקט',
    termsAcceptance: '1. אַקסעפּטאַנס פון טערמינען',
    termsAcceptanceText: 'דורך אַקסעסינג און ניצן Resunize ("דער סערוויס"), איר אַקסעפּט און שטימען צו זיין געבונדן דורך די טערמינען און פּראַוויזשאַנז פון דעם אַגרימאַנט. אויב איר שטימען נישט צו אַבייד דורך די אויבן, ביטע ניצט נישט דעם סערוויס.',
    termsUseLicense: '2. ניצן לאַסענס',
    termsUseLicenseText: 'פּערמישאַן איז געגעבן צו טעמפּערערלי ניצן Resunize פֿאַר פּערסאָנאַל, נישט-קאַמערשאַל טראַנזיטאָרי קוקן בלויז. דאָס איז די גראַנט פון אַ לאַסענס, נישט אַ טראַנספער פון טיטל, און אונטער דעם לאַסענס איר מעגט נישט:',
    termsUseLicenseItem1: 'מאָדיפיצירן אָדער קאָפּיע די מאַטעריאַלס',
    termsUseLicenseItem2: 'ניצן די מאַטעריאַלס פֿאַר קיין קאַמערשאַל ציל אָדער פֿאַר קיין ציבור דיספּלייז',
    termsUseLicenseItem3: 'פּרובירן צו פאַרקערט ענדזשאַניר קיין סאָפטווער קאַנטיינד אויף Resunize',
    termsUseLicenseItem4: 'אַראָפּנעמען קיין קאָפּיריט אָדער אנדערע פּראָפּריאַטערי נאָוטיישאַנז פון די מאַטעריאַלס',
    termsUseLicenseItem5: 'טראַנספער די מאַטעריאַלס צו אַנדער מענטש אָדער "שפּיגל" די מאַטעריאַלס אויף קיין אנדער סערווירער',
    termsUserAccounts: '3. ניצער חשבונות',
    termsUserAccountsText: 'איר זענט פאַראַנטוואָרטלעך פֿאַר מאַינטייניינג די קאָנפידענשאַליטי פון אייער חשבון און פּאַראָל. איר שטימען צו אַקסעפּט פאַראַנטוואָרטלעכקייט פֿאַר אַלע אַקטיוויטיעס וואָס אַקער אונטער אייער חשבון אָדער פּאַראָל. איר מוזן נאָטיפיצירן אונדז מיד פון קיין אַנאָטאָרייזד ניצן פון אייער חשבון.',
    termsUserContent: '4. ניצער אינהאַלט',
    termsUserContentText1: 'איר ריטיין אָונערשיפּ פון קיין אינהאַלט איר סאַבמיט, פּאָסט, אָדער דיספּלייז אויף אָדער דורך דער סערוויס. דורך סאַבמיטינג אינהאַלט, איר גראַנט Resunize אַ וועלטווייטקייט, נישט-עקסקלוסיוו, ראָיאַלטי-פריי לאַסענס צו ניצן, רעפּראָדוצירן, און דיסטריביוט אַזאַ אינהאַלט סאָולי פֿאַר די ציל פון פּראָווידינג און ימפּרוווינג דער סערוויס.',
    termsUserContentText2: 'איר זענט סאָולי פאַראַנטוואָרטלעך פֿאַר די אינהאַלט איר פּאָסט און רעפּריזענט אַז איר האָט אַלעסעסערי רעכט צו פּאָסט אַזאַ אינהאַלט. איר שטימען נישט צו פּאָסט אינהאַלט וואָס איז יליגאַל, שעדלעך, טרעטאַנינג, אַביוסיוו, אָדער וויאַלייץ קיין דריט פּאַרטיי ס רעכט.',
    termsPrivacy: '5. פּריוואַטקייט',
    termsPrivacyText: 'אייער ניצן פון Resunize איז אויך גאָווערנד דורך אונדזער פּריוואַטקייט פּאָליטיק. ביטע איבערקוקן אונדזער פּריוואַטקייט פּאָליטיק צו פֿאַרשטיין אונדזער פּראַקטיסעס וועגן די זאַמלונג און ניצן פון אייער אינפֿאָרמאַציע.',
    termsProhibitedUses: '6. פאַרבאָטן ניצט',
    termsProhibitedUsesText: 'איר מעגט נישט ניצן דער סערוויס:',
    termsProhibitedUsesItem1: 'אין קיין וועג וואָס וויאַלייץ קיין אַפּליקאַבאַל געזעץ אָדער רעגולאַציע',
    termsProhibitedUsesItem2: 'צו טראַנסמיט קיין מאַלישאַס קאָד אָדער ווירוסעס',
    termsProhibitedUsesItem3: 'צו ימפּערסאָנייט אָדער פּרובירן צו ימפּערסאָנייט אַן אנדער ניצער אָדער מענטש',
    termsProhibitedUsesItem4: 'צו ענגיידזש אין קיין אַוטאָמאַטעד ניצן פון די סיסטעם',
    termsProhibitedUsesItem5: 'צו ינטערפער מיט אָדער דיסאַפּט דער סערוויס אָדער סערווירערס',
    termsProhibitedUsesItem6: 'צו זאַמלען אָדער סטאָר פּערסאָנאַל דאַטן וועגן אנדערע ניצערס אָן זייער פּערמישאַן',
    termsTermination: '7. טערמינאַטיאָן',
    termsTerminationText: 'מיר קענען טערמינאַט אָדער סאַספּענד אייער חשבון און צוטריט צו דער סערוויס מיד, אָן פריערדיק נאָטיץ אָדער ליאַביליטי, פֿאַר קיין סיבה וואָס איז, כולל אָן לימיטאַטיאָן אויב איר ברייטש די טערמינען. אויף טערמינאַטיאָן, אייער רעכט צו ניצן דער סערוויס וועט פאַרענדיקן מיד.',
    termsDisclaimer: '8. דיסקליימער',
    termsDisclaimerText1: 'די מאַטעריאַלס אויף Resunize זענען פּראָווידעד אויף אַן "ווי עס איז" באַזיס. Resunize מאכט קיין וואָראַנטיעס, עקספּרעסט אָדער ימפּליד, און דערמיט דיסקליימז און נעגאַטעס אַלע אנדערע וואָראַנטיעס כולל, אָן לימיטאַטיאָן, ימפּליד וואָראַנטיעס אָדער קאַנדישאַנז פון מערטשאַנטאַביליטי, פנעסס פֿאַר אַ באַזונדער ציל, אָדער נישט-ינפרינדזשמאַנט פון ינטעלעקטואַל פּראָפּערטי אָדער אנדערע וויאַליישאַן פון רעכט.',
    termsDisclaimerText2: 'Resunize טוט נישט גאַראַנטירן די אַקיעראַסי, קאַמפּליטנעס, אָדער נוצלעכקייט פון קיין אינפֿאָרמאַציע אויף דער סערוויס. מיר זענען נישט פאַראַנטוואָרטלעך פֿאַר די אַקציעס, אינהאַלט, אינפֿאָרמאַציע, אָדער דאַטן פון דריט פּאַרטיעס.',
    termsLimitationLiability: '9. לימיטאַטיאָן פון ליאַביליטי',
    termsLimitationLiabilityText: 'אין קיין געשעעניש זאָל Resunize אָדער זייַן סאַפּלייערז זיין ליאַבלע פֿאַר קיין דאַמידזשיז (כולל, אָן לימיטאַטיאָן, דאַמידזשיז פֿאַר אָנווער פון דאַטן אָדער פּראָפיט, אָדער צוליב געשעפט ינטעראַפּשאַן) אַרייזינג אויס פון די ניצן אָדער אומפֿאַהיגקייט צו ניצן די מאַטעריאַלס אויף Resunize, אפילו אויב Resunize אָדער אַ Resunize אָטאָרייזד רעפּריזענטאַטיוו איז געווארן נאָטיפייד אוראַלי אָדער אין שרייבן פון די פּאָססיביליטי פון אַזאַ דאַמידזש.',
    termsChanges: '10. ענדערונגען צו טערמינען',
    termsChangesText: 'מיר ריזערוו די רעכט, אין אונדזער סאָול דיסקרעשאַן, צו מאָדיפיצירן אָדער פאַרבייַטן די טערמינען אין קיין צייט. אויב אַ רעוויזיע איז מאַטעריאַל, מיר וועלן פּראָווידער אין מינדסטענס 30 טעג נאָטיץ פריערדיק צו קיין נייַע טערמינען טייקינג עפֿעקט. וואָס קאַנסטיטוטעס אַ מאַטעריאַל ענדערונג וועט זיין דיטערמינד אין אונדזער סאָול דיסקרעשאַן.',
    termsCsae: '11. קינדער זיכערהייט (CSAE)',
    termsCsaeText: 'אונדזער סטאַנדאַרדן קעגן קינדער סעקסועלע מיסבאַנוץ און אויסניצונג זענען פאַרעפנטלעכט דאָ:',
    childSafetyCsaeLink: 'קינדער זיכערהייט און CSAE סטאַנדאַרדן',
    termsContact: '12. קאָנטאַקט אינפֿאָרמאַציע',
    termsContactText: 'אויב איר האָט קיין פֿראַגן וועגן די ניצונג טערמינען, ביטע קאָנטאַקט אונדז דורך אונדזער',
    termsNote: 'נאָטיץ',
    termsNoteText: 'דורך ניצן Resunize, איר אַקנאָוולידזש אַז איר האָט געלייענט, פֿאַרשטאַנען און שטימען צו זיין געבונדן דורך די ניצונג טערמינען.',
    
    // Pages - Privacy (Yiddish) - Complete translations
    privacyTitle: 'פּריוואַטקייט פּאָליטיק',
    privacyLead: 'אין Resunize, מיר נעמען אייער פּריוואַטקייט ערנסט. די פּריוואַטקייט פּאָליטיק ערקלערט ווי מיר זאַמלען, ניצן, דיסקלאָוס, און שיצן אייער אינפֿאָרמאַציע ווען איר ניצן אונדזער סערוויס.',
    privacyInfoWeCollect: '1. אינפֿאָרמאַציע מיר זאַמלען',
    privacyPersonalInfo: 'פּערסאָנאַל אינפֿאָרמאַציע',
    privacyPersonalInfoText: 'מיר זאַמלען אינפֿאָרמאַציע וואָס איר פּראָווידירן דירעקטלי צו אונדז, כולל:',
    privacyPersonalInfoItem1: 'נאָמען, בליצפּאָסט אַדרעס און טעלעפֿאָן נומער',
    privacyPersonalInfoItem2: 'חשבון קרעדענשאַלז (פּאַראָל, געהיט זיכער)',
    privacyPersonalInfoItem3: 'רעזומע אינפֿאָרמאַציע (פּערסאָנאַל דעטאַילס, משפּחה אינפֿאָרמאַציע, רעקאָמענדאַציעס, אאַז"וו)',
    privacyPersonalInfoItem4: 'אָנזאָגן און קאָמוניקאַציעס געשיקט דורך די פּלאַטפאָרמע',
    privacyPersonalInfoItem5: 'קיין אנדערע אינפֿאָרמאַציע איר קלייב צו פּראָווידירן',
    privacyAutoCollected: 'אַוטאָמאַטיש געזאַמלט אינפֿאָרמאַציע',
    privacyAutoCollectedText: 'ווען איר ניצן אונדזער סערוויס, מיר קענען אַוטאָמאַטיש זאַמלען:',
    privacyAutoCollectedItem1: 'דעוויסע אינפֿאָרמאַציע (בראַוזער טיפּ, אָפּערייטינג סיסטעם)',
    privacyAutoCollectedItem2: 'ניצן דאַטן (בלעטער באזוכט, פֿעיִקייטן געניצט, צייט פאַרבראכט)',
    privacyAutoCollectedItem3: 'IP אַדרעס און לאָקיישאַן דאַטן',
    privacyAutoCollectedItem4: 'קוקיס און ענלעך טראַקינג טעכנאָלאָגיעס',
    privacyHowWeUse: '2. ווי מיר ניצן אייער אינפֿאָרמאַציע',
    privacyHowWeUseText: 'מיר ניצן די אינפֿאָרמאַציע מיר זאַמלען צו:',
    privacyHowWeUseItem1: 'פּראָווידירן, מאַינטיינען און ימפּרוווינג אונדזער סערוויס',
    privacyHowWeUseItem2: 'פּראָצעס אייער רעגיסטראַציע און פירן אייער חשבון',
    privacyHowWeUseItem3: 'ענאַבלע קאָמוניקאַציע צווישן ניצערס (איינציקע, עלטערן און שדכנים)',
    privacyHowWeUseItem4: 'שיקן פֿאָרשלאַגן און נאָטיפיקאַטיאָנס',
    privacyHowWeUseItem5: 'רעספּאָנד צו אייער ינקוואַיריז און פּראָווידירן קוסטאָמער שטיצן',
    privacyHowWeUseItem6: 'דיטעקט, פאַרמייַדן און אַדרעס טעכניש ישוז און זיכערהייט טרעץ',
    privacyHowWeUseItem7: 'קאַמפּליי מיט לעגאַל אָבליגיישאַנז',
    privacySharing: '3. אינפֿאָרמאַציע טיילן און דיסקלאָוסור',
    privacySharingText: 'מיר רעספּעקט אייער פּריוואַטקייט און טיילן בלויז אייער אינפֿאָרמאַציע אין די פאָלגענדע צירקומסטאַנסעס:',
    privacySharingWithConsent: 'מיט אייער קאָנסענט',
    privacySharingWithConsentText: 'מיר טיילן אייער רעזומע אינפֿאָרמאַציע מיט שדכנים נאָר ווען איר עקספּליסאַטלי טיילן עס אָדער שטעלן עס צו ציבור. איר קאָנטראָלירן ווער קען זען אייער אינפֿאָרמאַציע.',
    privacySharingServiceProviders: 'סערוויס פּראָווידערז',
    privacySharingServiceProvidersText: 'מיר קענען טיילן אינפֿאָרמאַציע מיט דריט-פּאַרטיי סערוויס פּראָווידערז וואָס דורכפירן סערוויסעס אויף אונדזער ביכאַלף (האָסטינג, בליצפּאָסט דעליווערי, אַנאַליטיקס). די פּראָווידערז זענען געבונדן דורך קאָנפידענשאַליטי אַגרימאַנץ.',
    privacySharingLegal: 'לעגאַל רעקווירעמענץ',
    privacySharingLegalText: 'מיר קענען דיסקלאָוס אינפֿאָרמאַציע אויב פארלאנגט דורך געזעץ, קאָרט סדר, אָדער רעגירונג רעגולאַציע, אָדער צו שיצן די רעכט, פּראָפּערטי, אָדער זיכערהייט פון Resunize, אונדזער ניצערס, אָדער אנדערע.',
    privacySharingBusiness: 'געשעפט טראַנספערס',
    privacySharingBusinessText: 'אין דער געשעעניש פון אַ מערדזשער, אַקוויזישאַן, אָדער פאַרקויף פון אַסעץ, אייער אינפֿאָרמאַציע קען זיין טראַנספערד ווי טייל פון אַזאַ טראַנזאַקציע.',
    privacySecurity: '4. דאַטן זיכערהייט',
    privacySecurityText: 'מיר ימפּלאַמענט אַפּראָפּריאַטע טעכניש און אָרגאַניזאַטיאָנאַל זיכערהייט מעזשערז צו שיצן אייער אינפֿאָרמאַציע, כולל:',
    privacySecurityItem1: 'ענקריפּשאַן פון דאַטן אין טראַנזיט (SSL/TLS)',
    privacySecurityItem2: 'זיכער פּאַראָל סטאָרידזש ניצן אינדוסטריע-נאָרמאַל האַשינג',
    privacySecurityItem3: 'ראָלע-באזירט צוטריט קאָנטראָל',
    privacySecurityItem4: 'רעגולער זיכערהייט אַעסמאַנץ און דערהייַנטיקונגען',
    privacySecurityItem5: 'לימיטעד צוטריט צו פּערסאָנאַל אינפֿאָרמאַציע אויף אַ נויט-צו-וויסן באַזיס',
    privacySecurityNote: 'אָבער, קיין מעטהאָד פון טראַנסמישאַן איבער די אינטערנעט אָדער עלעקטראָניק סטאָרידזש איז 100% זיכער. בשעת מיר שטרעבן צו שיצן אייער אינפֿאָרמאַציע, מיר קענען נישט גאַראַנטירן אַבסאָלוט זיכערהייט.',
    privacyRights: '5. אייער פּריוואַטקייט רעכט',
    privacyRightsText: 'איר האָט די רעכט צו:',
    privacyRightsAccess: 'צוטריט',
    privacyRightsAccessText: 'בעטן צוטריט צו אייער פּערסאָנאַל אינפֿאָרמאַציע',
    privacyRightsCorrection: 'קערעקשאַן',
    privacyRightsCorrectionText: 'דערהייַנטיקן אָדער קערעקט אייער אינפֿאָרמאַציע אין קיין צייט',
    privacyRightsDeletion: 'דילישאַן',
    privacyRightsDeletionText: 'בעטן דילישאַן פון אייער חשבון און דאַטן',
    privacyRightsOptOut: 'אָפּט-אויס',
    privacyRightsOptOutText: 'אַנסובסקרייבן פון נישט-עסענטיאַל קאָמוניקאַציעס',
    privacyRightsPortability: 'דאַטן פּאָרטאַביליטי',
    privacyRightsPortabilityText: 'בעטן אַ קאָפּיע פון אייער דאַטן אין אַ פּאָרטאַבלע פֿאָרמאַט',
    privacyRightsContact: 'צו עקסערסייז די רעכט, ביטע קאָנטאַקט אונדז דורך אונדזער',
    privacyCookies: '6. קוקיס און טראַקינג טעכנאָלאָגיעס',
    privacyCookiesText: 'מיר ניצן קוקיס און ענלעך טראַקינג טעכנאָלאָגיעס צו טראַק אַקטיוויטי אויף אונדזער סערוויס און סטאָר זיכער אינפֿאָרמאַציע. איר קענט ינסטרוקט אייער בראַוזער צו רעפוז אַלע קוקיס אָדער צו ינדיקייט ווען אַ קוקי איז געשיקט. אָבער, אויב איר טאָן נישט אַקסעפּט קוקיס, איר קענט נישט קענען ניצן עטלעכע פּאָרשאַנז פון אונדזער סערוויס.',
    privacyChildren: '7. קינדער פּריוואַטקייט',
    privacyChildrenText: 'אונדזער סערוויס איז נישט ינטענדעד פֿאַר קינדער אונטער די עלטער פון 18. מיר טאָן נישט וויסנדיק זאַמלען פּערסאָנאַל אינפֿאָרמאַציע פון קינדער. אויב איר זענט אַ פאָטער אָדער גוואַרדיאַן און גלויבן אייער קינד האָט פּראָווידעד אונדז מיט פּערסאָנאַל אינפֿאָרמאַציע, ביטע קאָנטאַקט אונדז מיד.',
    privacyRetention: '8. דאַטן ריטענשאַן',
    privacyRetentionText: 'מיר ריטיין אייער אינפֿאָרמאַציע ווי לאַנג ווי אייער חשבון איז אַקטיוו אָדער ווי נויטיק צו פּראָווידירן איר סערוויסעס. אויב איר מעקן אייער חשבון, מיר וועלן מעקן אָדער אַנאָנימיזירן אייער אינפֿאָרמאַציע, חוץ ווו מיר זענען פארלאנגט צו ריטיין עס פֿאַר לעגאַל צוועקן.',
    privacyInternational: '9. אינטערנאַטיאָנאַל דאַטן טראַנספערס',
    privacyInternationalText: 'אייער אינפֿאָרמאַציע קען זיין טראַנספערד צו און פּראָסעסט אין לענדער אנדערש ווי אייער לאַנד פון רעזידענס. די לענדער קענען האָבן דאַטן שוץ געזעצן וואָס דיפער פון די אין אייער לאַנד. דורך ניצן אונדזער סערוויס, איר קאָנסענט צו אַזאַ טראַנספערס.',
    privacyChanges: '10. ענדערונגען צו די פּריוואַטקייט פּאָליטיק',
    privacyChangesText: 'מיר קענען דערהייַנטיקן אונדזער פּריוואַטקייט פּאָליטיק פון צייט צו צייט. מיר וועלן נאָטיפיצירן איר פון קיין ענדערונגען דורך פּאָסטינג די נייַע פּריוואַטקייט פּאָליטיק אויף דעם בלאַט און דערהייַנטיקן די "לעצט דערהייַנטיקט" דאַטע. איר זענט אַדווייזד צו איבערקוקן די פּריוואַטקייט פּאָליטיק פּעריאָדיקלי פֿאַר קיין ענדערונגען.',
    privacyContact: '11. קאָנטאַקט אונדז',
    privacyContactText: 'אויב איר האָט קיין פֿראַגן וועגן די פּריוואַטקייט פּאָליטיק, ביטע קאָנטאַקט אונדז דורך אונדזער',
    privacyMatters: 'דיין פּריוואַטקייט ענינים',
    privacyMattersText: 'מיר זענען פארפעסטיקט צו שיצן דיין פּריוואַטקייט און זיין טראַנספּאַראַנט וועגן ווי מיר זאַמלען און ניצן דיין אינפֿאָרמאַציע. אויב איר האָבן קאַנסערנז אָדער פֿראַגן, ביטע נישט צעגערן צו דערגרייכן אויס.',
    
    // Pages - Contact Support (Yiddish)
    contactSupportSubtitle: 'מיר זענען דאָ צו העלפֿן! דערגרייכן אויס מיט קיין פֿראַגן אָדער קאַנסערנז.',
    emailUs: 'בליצפּאָסט אונדז',
    responseTime: 'ענטפֿער צייט',
    responseTimeText: 'אין 24-48 שעה',
    supportHours: 'שטיצן שעה',
    supportHoursText: 'מאָנטיק - פֿרייטיק, 9 AM - 5 PM EST',
    nameRequired: 'נאָמען *',
    emailRequired: 'בליצפּאָסט *',
    categoryRequired: 'קאַטעגאָריע *',
    subjectRequired: 'סוביעקט *',
    messageRequired: 'אָנזאָג *',
    generalInquiry: 'אַלגעמיין אַנקוויירי',
    technicalSupport: 'טעכניש שטיצן',
    accountIssues: 'חשבון ישוז',
    billingQuestion: 'בילינג פֿראַגע',
    featureRequest: 'שטריך בעטן',
    reportBug: 'רעפּאָרט אַ באַג',
    privacyConcern: 'פּריוואַטקייט קאַנסערן',
    sendMessage: 'שיקן אָנזאָג',
    sending: 'שיקנדיק...',
    frequentlyAskedQuestions: 'אָפט געפֿרעגטע פֿראַגן',
    beforeContacting: 'איידער קאָנטאַקטינג שטיצן, איר זאָלט געפֿינען די ענטפֿער אין אונדזער',
    faqSection: 'FAQ אָפּטיילונג',
    beforeContactingText: 'מיר האָבן קאָמפּילעד ענטפֿערס צו די מערסט פּראָסט פֿראַגן וועגן ניצן Resunize.',
    needImmediateHelp: 'דאַרפֿן מיד הילף?',
    needImmediateHelpText: 'פֿאַר דרינגענדיק חשבון ישוז אָדער זיכערהייט קאַנסערנז, ביטע אַרייַננעמען "דרינגענדיק" אין דיין סוביעקט שורה. מיר פּריאָריטיזירן די ריקוועסץ און וועלן ענטפֿערן ווי שנעל ווי מעגלעך.',
    
    // Chat (Yiddish)
    chatTitle: 'אָנזאָגן',
    conversations: 'שמועסן',
    searchConversations: 'זוכן שמועסן...',
    contactShadchan: 'קאָנטאַקט אַ שדכן',
    contactSingle: 'קאָנטאַקט אַ איינציק',
    contactByEmail: 'קאָנטאַקט דורך בליצפּאָסט',
    start: 'אָנהייב',
    noConversations: 'נאָך קיין שמועסן. אָנהייב אַ נייַ שמועס צו אָנהייב אָנזאָגן.',
    startNewConversation: 'אָנהייב נייַ שמועס',
    typeMessage: 'טיפּ אַ אָנזאָג...',
    send: 'שיקן',
    noMessages: 'נאָך קיין אָנזאָגן. אָנהייב די שמועס!',
    searchContacts: 'זוכן קאָנטאַקט...',
    noContacts: 'קיין קאָנטאַקט געפֿונען.',
    selectContact: 'קלייב אַ קאָנטאַקט צו אָנהייב טשאַטינג',
    attachment: 'אַטאַטשמאַנט',
    removeAttachment: 'אַראָפּנעמען אַטאַטשמאַנט',
    fileSizeError: 'טעקע גרייס מוז זיין ווייניגער ווי 10MB',
    today: 'היינט',
    read: 'געלייענט',
    sent: 'געשיקט',
    image: 'בילד',
    file: 'טעקע',
    justNow: 'פּונקט איצט',
    minutesAgo: 'פאַר {minutes} מינוטן',
    hoursAgo: 'פאַר {hours} שעה',
    daysAgo: 'פאַר {days} טעג',
    showPassword: 'ווייַזן פּאַראָל',
    hidePassword: 'באַהאַלטן פּאַראָל',
    loginFailedError: 'אַרייַן נישט געלונגען',
    conversations: 'שמועסן',
    searchConversations: 'זוכן שמועסן...',
    contactShadchan: 'קאָנטאַקט שדכן',
    contactSingle: 'קאָנטאַקט איינציק',
    justNow: 'איצט',
    minutesAgo: 'פאַר {minutes} מינוטן',
    hoursAgo: 'פאַר {hours} שעה',
    daysAgo: 'פאַר {days} טעג',
    preview: 'פֿאָרויסיקע קוק',
    image: 'בילד',
    file: 'טעקע',
    
    // Metadata (Yiddish)
    siteTitle: 'Resunize - שידוך אָרגאַנייזער',
    siteDescription: 'Resunize - אָרגאַניזירן רעזומע, פירן דער פּראָצעס, בלייבן פֿאָקוסירט',
    enableJavaScript: 'איר דאַרפֿט ענאַבלע JavaScript צו לויפן די אַפּ.',
    wrongAccountType: 'דער חשבון איז אַ {role}. ביטע ניצן די ריכטיקע אַרייַן בלאַט.',
    failedToUpdateVisibility: 'נישט געלונגען צו דערהייַנטיקן נראות',
    failedToLoadProfile: 'נישט געלונגען צו לאָדן פּראָפיל',
    failedToLoadResumes: 'נישט געלונגען צו לאָדן רעזומע',

    // Landing Page (Yiddish)
    landingBadge: 'דער מאָדערנער רעזומע אָרגאַנייזער',
    landingHero1: 'האַלטן דעם',
    landingHero2: 'שידוך פּראָצעס אָרגאַניזירט',
    landingSubtitle: 'Resunize האַלט דעם זעלבן שידוך פּראָצעס וואָס איר קענט שוין, נאָר מער אָרגאַניזירט. לאָדט אַרויף PDF רעזומעס וואָס מען האָט אייך געשלאָגן פֿאָר, און האַלט נאָטיצן און וויכטיקע אינפֿאָרמאַציע צוזאַמען אין איין אָרט.',
    landingGetStarted: 'אָנהייבן אומזיסט',
    landingSignIn: 'אַרייַנגיין',
    landingSecure: 'זיכער און פּריוואַט',
    landingFree: 'אומזיסט צו אָנהייבן',
    landingTrusted: 'באַגלויבטע פּלאַטפאָרמע',
    landingFeaturesLabel: 'פארוואס Resunize',
    landingFeaturesTitle1: 'דער זעלבער פּראָצעס,',
    landingFeaturesTitle2: 'נאָר בעסערע אָרגאַניזאַציע',
    landingFeaturesSubtitle: 'קיין נייע סיסטעם צו לערנען. נאָר פּשוטע מכשירים צו אָרגאַניזירן רעזומעס, הצעות און נאָטיצן.',
    landingFeatureDigitalTitle: 'רעזומע ארויפלאָדן',
    landingFeatureDigitalDesc: 'לאָדט אַרויף אַ PDF רעזומע וואָס מען האָט אייך געשלאָגן פֿאָר. עס שפּאָרט צייט און האַלט אייער געוויינטלעכער פּראָצעס אין גאַנג.',
    landingFeatureTrackTitle: 'הצעות און נאָטיצן',
    landingFeatureTrackDesc: 'האַלט יעדע הצעה אָרגאַניזירט מיט סטאַטוסן, נאָטיצן און וויכטיקע פרטים, כּדי גאָרנישט זאָל נישט פאַרלירן ווערן.',
    landingFeatureChildrenTitle: 'פירן מערערע קינדער',
    landingFeatureChildrenDesc: 'קלײַבט דעם חשבון טיפּ וואָס פּאַסט צו אייערע באַדערפענישן. רווקים קענען פירן זייערע אייגענע רעזומעס און הצעות, בשעת עלטערן קענען שאַפֿן אַ עלטערן חשבון וואָס ערלויבט צו איבערזען און אָרגאַניזירן פּראָפילן פֿון מערערע קינדער פֿון איין פּשוטער דאַשבאָרד.',
    landingFeatureMessageTitle: 'פּשוטע קאָמוניקאַציע',
    landingFeatureMessageDesc: 'ווען נויטיק, האַלט הודעות און געטיילטע טעקעס אין איין אָרט, כּדי די שמועסן זאָלן בלייבן קלאָר און אָרגאַניזירט.',
    landingFeaturePrivacyTitle: 'פּריוואַטקייט ערשט',
    landingFeaturePrivacyDesc: 'אייַער אינפֿאָרמאַציע איז באַשיצט מיט אינדוסטריע-סטאַנדאַרט ענקריפּציע. מיר טיילן קיינמאָל נישט אייַערע דאַטן מיט דריטע צדדים — אייַער פּריוואַטקייט איז אונדזער העכסטע פּריאָריטעט.',
    landingFeatureLangTitle: 'מערשפּראַכיק',
    landingFeatureLangDesc: 'פולע שטיצע פֿאַר ענגליש, עברית און ייִדיש. די פּלאַטפאָרמע פּאַסט זיך אָן צו אייַער באַליבטע שפּראַך.',
    landingHowLabel: 'ווי עס אַרבעט',
    landingHowTitle: 'הייבט אָן אין מינוטן',
    landingHowSubtitle: 'דרייַ פּשוטע טריט צו האַלטן אייער געוויינטלעכן שידוך פּראָצעס אָרגאַניזירט.',
    landingStep1Title: 'שאַפֿט אייער חשבון',
    landingStep1Desc: 'רעגיסטרירט זיך אַלס רווק/ה אָדער עלטער און הייבט אָן מיט דער זעלבער אַרבעטס־פֿלוס וואָס איר קענט שוין.',
    landingStep2Title: 'לייגט צו רעזומע אינפֿאָרמאַציע',
    landingStep2Desc: 'לאָדט אַרויף אַ PDF רעזומע ווען עס קומט אָן, און האַלט אַלע רעלעוואַנטע אינפֿאָרמאַציע צוזאַמען.',
    landingStep3Title: 'פירט דעם פּראָצעס',
    landingStep3Desc: 'גייט נאָך הצעות, שפּאָרט נאָטיצן און האַלט קאָמוניקאַציע אָרגאַניזירט פֿון אָנהייב ביז סוף.',
    landingMobileAppLabel: 'מאָביל־אַפּ',
    landingMobileAppTitle: 'לאָדט אָראָפּ אונדזער מאָביל־אַפּ',
    landingMobileAppSubtitle: 'נעמט Resunize מיט אײַך אויף iPhone און Android — דער זעלבער חשבון, אָפּטימיזירט פֿאַר טעלעפֿאָן.',
    landingRolesLabel: 'געבויט פֿאַר אַלעמען',
    landingRolesTitle: 'אָרגאַניזירט לויט אייער ראָלע',
    landingRoleSinglesTitle: 'רווקים/ות',
    landingRoleSinglesDesc: 'האַלט אייער רעזומע, הצעות און נאָטיצן אָרגאַניזירט אין איין אָרט בשעת איר פֿאָלגט דעם געוויינטלעכן פּראָצעס.',
    landingCtaTitle: 'גרייט צו אָרגאַניזירן אייער פּראָצעס?',
    landingCtaSubtitle: 'ניצט אייער זעלבן שידוך פּראָצעס, מיט פּשוטערע אָרגאַניזאַציע פֿאַר רעזומעס, נאָטיצן און הצעות.',
    landingCtaButton: 'שאַפֿט אַ חשבון אומזיסט',
    landingFooterAbout: 'וועגן',
    landingFooterFaq: 'שאלות',
    landingFooterTerms: 'תנאים',
    landingFooterPrivacy: 'פּריוואַטקייט',
    landingFooterContact: 'קאָנטאַקט',
  }
};

// Helper function to replace placeholders in translation strings
const replacePlaceholders = (text, replacements = {}) => {
  let result = text;
  Object.keys(replacements).forEach(key => {
    result = result.replace(new RegExp(`\\{${key}\\}`, 'g'), replacements[key]);
  });
  return result;
};

export const getTranslation = (key, language = 'en', replacements = {}) => {
  const translation = translations[language]?.[key] || translations.en[key] || key;
  return replacePlaceholders(translation, replacements);
};

export const getTranslationOr = (key, language = 'en', fallback = '', replacements = {}) => {
  const translation = translations[language]?.[key] ?? translations.en[key];
  if (translation == null) {
    return replacePlaceholders(fallback, replacements);
  }
  return replacePlaceholders(translation, replacements);
};
